export * from '../models/AccessCondition.js';
export * from '../models/AccessConditionEffect.js';
export * from '../models/AccessConditionalExpression.js';
export * from '../models/Account.js';
export * from '../models/AccountConfigInput.js';
export * from '../models/AccountIdCondition.js';
export * from '../models/AccountIdFilters.js';
export * from '../models/AccountInstallationMethod.js';
export * from '../models/AccountMetricsDestination.js';
export * from '../models/AccountNameFilters.js';
export * from '../models/AccountState.js';
export * from '../models/AccountStatusFilters.js';
export * from '../models/AccountUpdateInput.js';
export * from '../models/AccountVersion.js';
export * from '../models/ActionFilters.js';
export * from '../models/ActionRequiredDetails.js';
export * from '../models/ActionRequiredType.js';
export * from '../models/ActivateAtlasOrganizationResponse.js';
export * from '../models/ActivateGcpFolderResponse.js';
export * from '../models/ActivateGcpOrganizationResponse.js';
export * from '../models/AddRestoreAtlasPrivateLinkRequest.js';
export * from '../models/AgreementWithCredits.js';
export * from '../models/Ami.js';
export * from '../models/AmiBlockDevice.js';
export * from '../models/AnalyzeSqlQueryRequest.js';
export * from '../models/AnnuallyConfig.js';
export * from '../models/AnomalyDataPoint.js';
export * from '../models/AnomalyGraphData.js';
export * from '../models/ApiCredentials.js';
export * from '../models/ApiCredentialsProperties.js';
export * from '../models/App.js';
export * from '../models/AppFilters.js';
export * from '../models/ApplicationOverride.js';
export * from '../models/AppsCondition.js';
export * from '../models/AppsDetails.js';
export * from '../models/AtlasCluster.js';
export * from '../models/AtlasClusters.js';
export * from '../models/AtlasOrganization.js';
export * from '../models/AtlasProject.js';
export * from '../models/AtlasProjects.js';
export * from '../models/AuditLog.js';
export * from '../models/AuditLogAction.js';
export * from '../models/AuditLogAuthMethod.js';
export * from '../models/AuditLogAuthStatus.js';
export * from '../models/AuditLogEntitiesInner.js';
export * from '../models/AuditLogExtendedData.js';
export * from '../models/AuditLogExtendedDataAuth.js';
export * from '../models/AuditLogFilterConditions.js';
export * from '../models/AuditLogInitiatorType.js';
export * from '../models/AuditLogMfaMethod.js';
export * from '../models/AuthResponse.js';
export * from '../models/AwsAccountConfigInput.js';
export * from '../models/AwsAccountMetricsDestination.js';
export * from '../models/AwsCredentialProfile.js';
export * from '../models/AwsCredentialProfileInput.js';
export * from '../models/AwsDatabaseDestination.js';
export * from '../models/AwsDynamoDBDestination.js';
export * from '../models/AwsDynamoDbResource.js';
export * from '../models/AwsDynamoDbSnapshotProperties.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
export * from '../models/AwsEbsSnapshotConvertResult.js';
export * from '../models/AwsEbsVolumeResource.js';
export * from '../models/AwsEbsVolumeRestoreData.js';
export * from '../models/AwsEbsVolumeRestoreResult.js';
export * from '../models/AwsEbsVolumeSnapshotProperties.js';
export * from '../models/AwsEc2AmiConvertResult.js';
export * from '../models/AwsEc2InstanceRestoreDestination.js';
export * from '../models/AwsEc2InstanceRestoreResult.js';
export * from '../models/AwsEc2InstanceRestoreTarget.js';
export * from '../models/AwsEc2Resource.js';
export * from '../models/AwsEc2SnapshotProperties.js';
export * from '../models/AwsEksNamespaceResource.js';
export * from '../models/AwsEksNamespaceSnapshotProperties.js';
export * from '../models/AwsFsxResource.js';
export * from '../models/AwsKeyspacesDestination.js';
export * from '../models/AwsKeyspacesResource.js';
export * from '../models/AwsNativePitrBackupPolicyPlan.js';
export * from '../models/AwsNativePitrBackupResourceType.js';
export * from '../models/AwsNativePitrConfig.js';
export * from '../models/AwsNeptuneResource.js';
export * from '../models/AwsRdsEngine.js';
export * from '../models/AwsRdsResource.js';
export * from '../models/AwsRdsResourceAurora.js';
export * from '../models/AwsRdsResourceStorageSettings.js';
export * from '../models/AwsRedshiftResource.js';
export * from '../models/AwsRestoreAccountAttributes.js';
export * from '../models/AwsRestoreAccountAttributesInput.js';
export * from '../models/AwsRestoreAccountConnectivityConfig.js';
export * from '../models/AwsSourceAccountAttributes.js';
export * from '../models/AwsSourceAccountAttributesInput.js';
export * from '../models/AwsVaultConfig.js';
export * from '../models/AwsVaultConfigInput.js';
export * from '../models/AwsVpcConnectivityConfig.js';
export * from '../models/AzureAccountConfigInput.js';
export * from '../models/AzureAksNamespaceResource.js';
export * from '../models/AzureAppRegistrationOption.js';
export * from '../models/AzureBackupApplicationsResponse.js';
export * from '../models/AzureCmkEligibleApp.js';
export * from '../models/AzureConsentUrlResponse.js';
export * from '../models/AzureDisk.js';
export * from '../models/AzureDiskRestoreData.js';
export * from '../models/AzureDiskRestoreDestination.js';
export * from '../models/AzureDiskRestoreResult.js';
export * from '../models/AzureDiskSettings.js';
export * from '../models/AzureDiskTarget.js';
export * from '../models/AzureEonApplication.js';
export * from '../models/AzureListResourceGroupsResponse.js';
export * from '../models/AzureListSubscriptionsResponse.js';
export * from '../models/AzureManagementGroup.js';
export * from '../models/AzureManagementGroups.js';
export * from '../models/AzureMarketplaceWebhookInput.js';
export * from '../models/AzureMarketplaceWebhookInputSubscription.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
export * from '../models/AzureMssqlSnapshotProperties.js';
export * from '../models/AzureOnboardedTenantsResponse.js';
export * from '../models/AzureOnboardingStatus.js';
export * from '../models/AzurePostgresDatabaseRestoreDestination.js';
export * from '../models/AzurePostgresDatabaseRestoreTarget.js';
export * from '../models/AzureResourceGroup.js';
export * from '../models/AzureResourceGroups.js';
export * from '../models/AzureRestoreAccountAttributes.js';
export * from '../models/AzureRestoreAccountAttributesInput.js';
export * from '../models/AzureRestoreAccountConnectivityConfig.js';
export * from '../models/AzureRestorePointData.js';
export * from '../models/AzureRestorePointSpec.js';
export * from '../models/AzureSapHanaResource.js';
export * from '../models/AzureScanningAccountSetupStatus200Response.js';
export * from '../models/AzureSourceAccountAttributes.js';
export * from '../models/AzureSourceAccountAttributesInput.js';
export * from '../models/AzureSqlDatabaseRestoreDestination.js';
export * from '../models/AzureSqlDatabaseRestoreTarget.js';
export * from '../models/AzureStorageAccount.js';
export * from '../models/AzureStorageAccounts.js';
export * from '../models/AzureSubscription.js';
export * from '../models/AzureTenant.js';
export * from '../models/AzureVaultConfig.js';
export * from '../models/AzureVaultConfigInput.js';
export * from '../models/AzureVaultType.js';
export * from '../models/AzureVmInstanceRestoreDestination.js';
export * from '../models/AzureVmInstanceRestoreResult.js';
export * from '../models/AzureVmInstanceRestoreTarget.js';
export * from '../models/AzureVmSnapshotProperties.js';
export * from '../models/AzureVnetConnectivityConfig.js';
export * from '../models/BackedUpByResourceType.js';
export * from '../models/BackedUpByResourceTypeDataInner.js';
export * from '../models/BackedUpStorageDateHistogram.js';
export * from '../models/BackupControlViolations.js';
export * from '../models/BackupJob.js';
export * from '../models/BackupJobResponse.js';
export * from '../models/BackupJobSortField.js';
export * from '../models/BackupJobType.js';
export * from '../models/BackupJobTypeFilters.js';
export * from '../models/BackupJobsFilterConditions.js';
export * from '../models/BackupPoliciesFilters.js';
export * from '../models/BackupPoliciesLimits.js';
export * from '../models/BackupPoliciesSecurityConfig.js';
export * from '../models/BackupPolicy.js';
export * from '../models/BackupPolicyAppliesNotificationArguments.js';
export * from '../models/BackupPolicyConfig.js';
export * from '../models/BackupPolicyExpression.js';
export * from '../models/BackupPolicyGroupCondition.js';
export * from '../models/BackupPolicyNotificationArguments.js';
export * from '../models/BackupPolicyPlan.js';
export * from '../models/BackupPolicyResourceSelector.js';
export * from '../models/BackupPolicySecurityConfig.js';
export * from '../models/BackupPolicyType.js';
export * from '../models/BackupRegionsFilters.js';
export * from '../models/BackupSchedule.js';
export * from '../models/BackupScope.js';
export * from '../models/BackupScopeSummary.js';
export * from '../models/BackupStatus.js';
export * from '../models/BackupStatusFilters.js';
export * from '../models/BackupVault.js';
export * from '../models/BackupZeroEtlAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsAccessConfiguration.js';
export * from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
export * from '../models/BackupZeroEtlCatalogConfiguration.js';
export * from '../models/BackupZeroEtlIdentityColumnField.js';
export * from '../models/BackupZeroEtlIdentityColumnSpec.js';
export * from '../models/BackupZeroEtlPolicy.js';
export * from '../models/BackupZeroEtlResourceSelector.js';
export * from '../models/BackupZeroEtlRoutingMode.js';
export * from '../models/BackupZeroEtlRoutingPolicy.js';
export * from '../models/BackupZeroEtlStorageConfiguration.js';
export * from '../models/BatchApplicationOverrides.js';
export * from '../models/BatchMode.js';
export * from '../models/BatchOperationResponse.js';
export * from '../models/BatchResourceValidationResult.js';
export * from '../models/BatchUpdateLlgPoliciesRequest.js';
export * from '../models/BatchUpdateLlgPolicyItem.js';
export * from '../models/BatchValidateResourceConfigurationRequest.js';
export * from '../models/BatchValidateResourceConfigurationResponse.js';
export * from '../models/BigQueryDatasetDestination.js';
export * from '../models/BigQueryIntegrationConfig.js';
export * from '../models/BigQueryNativePitrBackupPolicyPlan.js';
export * from '../models/BigQueryNativePitrBackupResourceType.js';
export * from '../models/BigQueryNativePitrConfig.js';
export * from '../models/BigQueryNativePitrDestination.js';
export * from '../models/BiglakeCatalogProperties.js';
export * from '../models/BillingPeriod.js';
export * from '../models/BillingTransactionHistory.js';
export * from '../models/BooleanFilters.js';
export * from '../models/BucketPathPartitionSpec.js';
export * from '../models/CancelExclusionFromBackupResponse.js';
export * from '../models/CancelMyMPARequestResponse.js';
export * from '../models/CatalogAccessRequest.js';
export * from '../models/CatalogAccessResponse.js';
export * from '../models/CdcBackupModeCheckResult.js';
export * from '../models/CheckAzureVMNameExists200Response.js';
export * from '../models/CheckAzureVMNameExistsRequest.js';
export * from '../models/CheckCdcPrerequisitesResponse.js';
export * from '../models/Classifications.js';
export * from '../models/CloudAccountIdFilters.js';
export * from '../models/CloudAccountNotificationArguments.js';
export * from '../models/CloudAccountType.js';
export * from '../models/CloudProviderCondition.js';
export * from '../models/CloudProviderFilters.js';
export * from '../models/CloudRegion.js';
export * from '../models/CloudResourceAttachmentEvent.js';
export * from '../models/CloudResourceAttachmentEventType.js';
export * from '../models/CloudResourceConfiguration.js';
export * from '../models/CloudResourceConfigurationCdcBackup.js';
export * from '../models/CloudResourceConfigurationInventoryBackup.js';
export * from '../models/CloudResourceSecurityProperties.js';
export * from '../models/CloudSnapshotsPerVolume.js';
export * from '../models/ClusterNameFilters.js';
export * from '../models/ColumnMetadata.js';
export * from '../models/CompactionStrategy.js';
export * from '../models/CompanyContact.js';
export * from '../models/Condition.js';
export * from '../models/ConditionOperatorEnum.js';
export * from '../models/ConnectAtlasOrganizationRequest.js';
export * from '../models/ConnectAtlasOrganizationResponse.js';
export * from '../models/ConnectAzureBackupAccountRequest.js';
export * from '../models/ConnectAzureBackupApplicationsRequest.js';
export * from '../models/ConnectAzureRestoreAccountRequest.js';
export * from '../models/ConnectAzureSourceAccountRequest.js';
export * from '../models/ConnectAzureVaultAccountRequest.js';
export * from '../models/ConnectBYOApps200Response.js';
export * from '../models/ConnectBYOAppsRequest.js';
export * from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
export * from '../models/ConnectCustomerVaultAccountRequest.js';
export * from '../models/ConnectCustomerVaultAccountResponse.js';
export * from '../models/ConnectGcpFolderRequest.js';
export * from '../models/ConnectGcpFolderResponse.js';
export * from '../models/ConnectGcpOrganizationRequest.js';
export * from '../models/ConnectGcpOrganizationResponse.js';
export * from '../models/ConnectRestoreAccountRequest.js';
export * from '../models/ConnectRestoreAccountResponse.js';
export * from '../models/ConnectSourceAccountRequest.js';
export * from '../models/ConnectSourceAccountResponse.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
export * from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/Control.js';
export * from '../models/ControlPlaneConfig.js';
export * from '../models/ControlRules.js';
export * from '../models/ControlViolation.js';
export * from '../models/ControlViolations.js';
export * from '../models/ControlViolationsPerSeverity.js';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
export * from '../models/ControlsFilters.js';
export * from '../models/ConvertEbsSnapshotConfig.js';
export * from '../models/ConvertEc2ImageConfig.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
export * from '../models/ConvertResourceSnapshotsRequest.js';
export * from '../models/ConvertResourceSnapshotsResponse.js';
export * from '../models/Cost.js';
export * from '../models/CostDataFilters.js';
export * from '../models/CostDataGroupBy.js';
export * from '../models/CostDataRecord.js';
export * from '../models/CostDataRecordCost.js';
export * from '../models/CostDataRecordDimensions.js';
export * from '../models/CostGranularity.js';
export * from '../models/CostRecordMetadata.js';
export * from '../models/CostRecordMetadataDataTransfer.js';
export * from '../models/CostRecordMetadataType.js';
export * from '../models/CostUnit.js';
export * from '../models/CreateAccountInput.js';
export * from '../models/CreateApiCredentialsRequest.js';
export * from '../models/CreateApiCredentialsResponse.js';
export * from '../models/CreateBackupPolicyRequest.js';
export * from '../models/CreateBackupPolicyResponse.js';
export * from '../models/CreateBackupZeroEtlPolicyInput.js';
export * from '../models/CreateCredentialsProfileInput.js';
export * from '../models/CreateCredentialsProfileInputAwsCredentialProfile.js';
export * from '../models/CreateDashboardInput.js';
export * from '../models/CreateDataCatalogInput.js';
export * from '../models/CreateDlsgPolicyRequest.js';
export * from '../models/CreateDlsgPolicyResponse.js';
export * from '../models/CreateFabricTableShortcutDemoRequest.js';
export * from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
export * from '../models/CreateFabricTableShortcutDemoResponse.js';
export * from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
export * from '../models/CreateGraphInput.js';
export * from '../models/CreateIdpGroupRequest.js';
export * from '../models/CreateIdpGroupResponse.js';
export * from '../models/CreateInfectedExcludePathInput.js';
export * from '../models/CreateIngestionPipelineInput.js';
export * from '../models/CreateIntegrationRequest.js';
export * from '../models/CreateIntegrationResponse.js';
export * from '../models/CreateJobTemplateInput.js';
export * from '../models/CreateMPAPolicyRequest.js';
export * from '../models/CreateMPAPolicyResponse.js';
export * from '../models/CreateMPARequestReviewRequest.js';
export * from '../models/CreateMPARequestReviewResponse.js';
export * from '../models/CreateNotebookInput.js';
export * from '../models/CreateOAuthAppRequest.js';
export * from '../models/CreateOAuthAppResponse.js';
export * from '../models/CreatePolicyInput.js';
export * from '../models/CreatePolicyScheduleInput.js';
export * from '../models/CreatePrivateLinkInput.js';
export * from '../models/CreateProjectInput.js';
export * from '../models/CreatePulumiConfigurationRequest.js';
export * from '../models/CreateRoleRequest.js';
export * from '../models/CreateRoleResponse.js';
export * from '../models/CreateSamlIdentityProviderConfigInput.js';
export * from '../models/CreateSavedQueryInput.js';
export * from '../models/CreateScanJobInput.js';
export * from '../models/CreateScanJobResponse.js';
export * from '../models/CreateSessionRequest.js';
export * from '../models/CreateSparkEngineInput.js';
export * from '../models/CreateSqlEngineInput.js';
export * from '../models/CreateUserInput.js';
export * from '../models/CreateVaultRequest.js';
export * from '../models/CreateVaultResponse.js';
export * from '../models/CreateVpcPeeringInput.js';
export * from '../models/CreateZeroEtlPolicyInput.js';
export * from '../models/CredentialFinding.js';
export * from '../models/CredentialsProfile.js';
export * from '../models/CredentialsProfileAwsCredentialProfile.js';
export * from '../models/CreditsMonthlyUsageNotificationArguments.js';
export * from '../models/CreditsNotificationArguments.js';
export * from '../models/CrossResourceQueryRequest.js';
export * from '../models/CrossResourceQueryRequestResourcesInner.js';
export * from '../models/CustomTagsInner.js';
export * from '../models/CustomerVaultAccount.js';
export * from '../models/DBResourceMetadata.js';
export * from '../models/DBServerRecord.js';
export * from '../models/DBSnapshotMetadata.js';
export * from '../models/DBSnapshotType.js';
export * from '../models/DailyConfig.js';
export * from '../models/DailySnapshotData.js';
export * from '../models/DailyStorageSummaries.js';
export * from '../models/DailyStorageSummary.js';
export * from '../models/Dashboard.js';
export * from '../models/DashboardGraph.js';
export * from '../models/DashboardGraphLayout.js';
export * from '../models/DashboardWithGraphs.js';
export * from '../models/DataCatalog.js';
export * from '../models/DataCatalogBiglakeProperties.js';
export * from '../models/DataCatalogGlueProperties.js';
export * from '../models/DataCatalogIcebergRestProperties.js';
export * from '../models/DataCatalogType.js';
export * from '../models/DataClass.js';
export * from '../models/DataClassesCondition.js';
export * from '../models/DataClassesDetails.js';
export * from '../models/DataClassesFilters.js';
export * from '../models/DataClassificationEntity.js';
export * from '../models/DataShareIntegrationConfig.js';
export * from '../models/DataTransferOperationType.js';
export * from '../models/DatabaseDestination.js';
export * from '../models/DatabaseRecord.js';
export * from '../models/DatabricksIntegrationConfig.js';
export * from '../models/DayOfWeek.js';
export * from '../models/DeactivateAccountRequest.js';
export * from '../models/DeactivateAccountResponse.js';
export * from '../models/DeactivateAtlasOrganizationResponse.js';
export * from '../models/DeactivateGcpFolderResponse.js';
export * from '../models/DeactivateGcpOrganizationResponse.js';
export * from '../models/DestinationDetails.js';
export * from '../models/DestinationProviderAttributes.js';
export * from '../models/DestinationProviderAttributesAzure.js';
export * from '../models/DestinationRestoreTypeAttributes.js';
export * from '../models/DetectorSummary.js';
export * from '../models/DetectorType.js';
export * from '../models/DisableResourceOverrideLimitsResponse.js';
export * from '../models/DisconnectCustomerVaultAccountResponse.js';
export * from '../models/DisconnectRestoreAccountResponse.js';
export * from '../models/DisconnectSourceAccountResponse.js';
export * from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/DiscoveryInvokeParams.js';
export * from '../models/DiscoveryJob.js';
export * from '../models/DiscoveryStatusResponse.js';
export * from '../models/DlsgPolicy.js';
export * from '../models/DlsgPolicyConfig.js';
export * from '../models/DlsgPolicyFilters.js';
export * from '../models/DlsgPolicyPlan.js';
export * from '../models/DlsgSettings.js';
export * from '../models/DocumentDBRestoreDestination.js';
export * from '../models/DocumentDbClusterParameterGroup.js';
export * from '../models/DocumentDbClusterParameterGroups.js';
export * from '../models/DocumentDbSnapshotProperties.js';
export * from '../models/DriftProtectionPolicy.js';
export * from '../models/DriftProtectionSummary.js';
export * from '../models/DriftProtectionTimePoint.js';
export * from '../models/DynamoDBAdvancedIndexConfig.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
export * from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
export * from '../models/DynamoDbBackupConfig.js';
export * from '../models/DynamoDbBackupConfigApplication.js';
export * from '../models/DynamoDbBillingMode.js';
export * from '../models/DynamodbTableRestoreDestination.js';
export * from '../models/EFSRestoreDestination.js';
export * from '../models/EbsRestoreDestination.js';
export * from '../models/EbsSnapshotRestoreDestination.js';
export * from '../models/EbsSnapshotTarget.js';
export * from '../models/EbsTarget.js';
export * from '../models/EfsSnapshotProperties.js';
export * from '../models/EksCluster.js';
export * from '../models/EksClusterStatus.js';
export * from '../models/EksNamespaceRestoreDestination.js';
export * from '../models/EksNamespaceRestoreResult.js';
export * from '../models/EksVolumeRestoreResult.js';
export * from '../models/EmrIntegrationConfig.js';
export * from '../models/EnableFromLimitExceededResponse.js';
export * from '../models/EnableResourceOverrideLimitsResponse.js';
export * from '../models/EnableRestoreAccountMetricsConfigRequest.js';
export * from '../models/EnableRestoreAccountMetricsConfigResponse.js';
export * from '../models/EnableSourceAccountMetricsConfigRequest.js';
export * from '../models/EnableSourceAccountMetricsConfigResponse.js';
export * from '../models/EncryptionKey.js';
export * from '../models/EncryptionKeys.js';
export * from '../models/EndTimeDateFilters.js';
export * from '../models/Environment.js';
export * from '../models/EnvironmentCondition.js';
export * from '../models/EnvironmentDetails.js';
export * from '../models/EnvironmentFilters.js';
export * from '../models/EonAccount.js';
export * from '../models/EonAccountIdFilters.js';
export * from '../models/EonAccountStatus.js';
export * from '../models/EonAccountType.js';
export * from '../models/EonSparkVersion.js';
export * from '../models/ErrorCode.js';
export * from '../models/ErrorPolicy.js';
export * from '../models/ExcludeFromBackupResponse.js';
export * from '../models/ExecuteNotebookCodeInput.js';
export * from '../models/ExportAccessDeniedItemsRequest.js';
export * from '../models/ExportCostData400Response.js';
export * from '../models/ExportCostDataRequest.js';
export * from '../models/FSxRestoreDestination.js';
export * from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
export * from '../models/FeatureFlagOverrideGet200Response.js';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
export * from '../models/FileExplorerResponse.js';
export * from '../models/FileFormat.js';
export * from '../models/FilePath.js';
export * from '../models/FileRestoreData.js';
export * from '../models/FileSearchRecord.js';
export * from '../models/FileSnapshot.js';
export * from '../models/FindingCountEntry.js';
export * from '../models/FindingEntry.js';
export * from '../models/ForceDeleteSnapshotsRequest.js';
export * from '../models/FreeTextFilters.js';
export * from '../models/FsxOntapVolume.js';
export * from '../models/FsxSnapshotProperties.js';
export * from '../models/FsxVolumeBackupInfo.js';
export * from '../models/GCSBucket.js';
export * from '../models/GCSBuckets.js';
export * from '../models/GCSRestoreDestination.js';
export * from '../models/GCSRestoreTarget.js';
export * from '../models/GcpAccountConfigInput.js';
export * from '../models/GcpBigQueryResource.js';
export * from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
export * from '../models/GcpBigQueryResourceRoutinesInner.js';
export * from '../models/GcpBigQueryResourceTablesInner.js';
export * from '../models/GcpBigQueryResourceViewsInner.js';
export * from '../models/GcpCloudSqlResource.js';
export * from '../models/GcpCloudSqlResourceStorageSettings.js';
export * from '../models/GcpCloudSqlRestoreDestination.js';
export * from '../models/GcpCloudSqlSnapshotProperties.js';
export * from '../models/GcpCloudSqlTarget.js';
export * from '../models/GcpDiskResource.js';
export * from '../models/GcpDiskRestoreData.js';
export * from '../models/GcpDiskRestoreDestination.js';
export * from '../models/GcpDiskSettings.js';
export * from '../models/GcpDiskSnapshotProperties.js';
export * from '../models/GcpDiskTarget.js';
export * from '../models/GcpDiskTypesResponse.js';
export * from '../models/GcpEncryptionKey.js';
export * from '../models/GcpEncryptionKeys.js';
export * from '../models/GcpGkeNamespaceResource.js';
export * from '../models/GcpMachineTypesResponse.js';
export * from '../models/GcpNetworkConnectivityConfig.js';
export * from '../models/GcpNetworkType.js';
export * from '../models/GcpOrganization.js';
export * from '../models/GcpRestoreAccountAttributes.js';
export * from '../models/GcpRestoreAccountAttributesInput.js';
export * from '../models/GcpRestoreAccountConnectivityConfig.js';
export * from '../models/GcpSapHanaResource.js';
export * from '../models/GcpSourceAccountAttributes.js';
export * from '../models/GcpSourceAccountAttributesInput.js';
export * from '../models/GcpSubnet.js';
export * from '../models/GcpSubnetPerRegion.js';
export * from '../models/GcpVaultConfig.js';
export * from '../models/GcpVaultConfigInput.js';
export * from '../models/GcpVmInstanceRestoreDestination.js';
export * from '../models/GcpVmInstanceRestoreResult.js';
export * from '../models/GcpVmInstanceRestoreTarget.js';
export * from '../models/GcpVmResource.js';
export * from '../models/GcpVmSnapshotProperties.js';
export * from '../models/GcsSourceProperties.js';
export * from '../models/GenericSnapshotData.js';
export * from '../models/GetAWSStackDetailsResponse.js';
export * from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
export * from '../models/GetAgreementsResponse.js';
export * from '../models/GetAwsPrivateLinkStatusResponse.js';
export * from '../models/GetBackupJobResponse.js';
export * from '../models/GetBackupPolicyResponse.js';
export * from '../models/GetBillingPeriodsResponse.js';
export * from '../models/GetCloudResourceSecurityPropertiesResponse.js';
export * from '../models/GetCredits400Response.js';
export * from '../models/GetCreditsResponse.js';
export * from '../models/GetDlsgPolicyResponse.js';
export * from '../models/GetGcsServiceAgentResponse.js';
export * from '../models/GetIdpGroupResponse.js';
export * from '../models/GetIntegrationResponse.js';
export * from '../models/GetLimitsResponseValue.js';
export * from '../models/GetMPAPolicyResponse.js';
export * from '../models/GetMPARequestResponse.js';
export * from '../models/GetNotebookContent200Response.js';
export * from '../models/GetProjectConfigurationKeyResponse.js';
export * from '../models/GetProjectConfigurationKeysResponse.js';
export * from '../models/GetResourceResponse.js';
export * from '../models/GetRestoreAccountConnectivityConfigResponse.js';
export * from '../models/GetRestoreAccountMetricsConfigResponse.js';
export * from '../models/GetRestoreJobResponse.js';
export * from '../models/GetRoleResponse.js';
export * from '../models/GetScanJobResponse.js';
export * from '../models/GetSnapshotResponse.js';
export * from '../models/GetSourceAccountMetricsConfigResponse.js';
export * from '../models/GetSourceAccountResponse.js';
export * from '../models/GetSqlVmNetworkInfoRequest.js';
export * from '../models/GetSqlVmNetworkInfoResponse.js';
export * from '../models/GetVaultResponse.js';
export * from '../models/GlobalClusterIdentifierCondition.js';
export * from '../models/GlueCatalogProperties.js';
export * from '../models/GoogleWorkspaceConnectionInfo.js';
export * from '../models/GoogleWorkspaceServiceAccountInfo.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributes.js';
export * from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
export * from '../models/HighFrequencyBackupPolicyPlan.js';
export * from '../models/HighFrequencyBackupResourceType.js';
export * from '../models/HighFrequencyBackupScheduleConfig.js';
export * from '../models/HighFrequencyBackupScheduleFrequency.js';
export * from '../models/HighFrequencyBackupSchedules.js';
export * from '../models/HighFrequencyIntervalConfig.js';
export * from '../models/IDs.js';
export * from '../models/IcebergRestCatalogAuthType.js';
export * from '../models/IcebergRestCatalogProperties.js';
export * from '../models/IdFilters.js';
export * from '../models/Identifier.js';
export * from '../models/IdentityProvidersNames.js';
export * from '../models/Idp.js';
export * from '../models/IdpGroup.js';
export * from '../models/ImportDlsgCertificateRequest.js';
export * from '../models/IndexRestoreMode.js';
export * from '../models/InfectedDataByClassification.js';
export * from '../models/InfectedDataClassificationSize.js';
export * from '../models/InfectedDataOverTime.js';
export * from '../models/InfectedDateSize.js';
export * from '../models/InfectedExcludePath.js';
export * from '../models/InfectedResourcesCountResponse.js';
export * from '../models/IngestionPipeline.js';
export * from '../models/IngestionPipelineStatus.js';
export * from '../models/IngestionSourceType.js';
export * from '../models/InitAuthInput.js';
export * from '../models/Initiator.js';
export * from '../models/InitiatorNameFilters.js';
export * from '../models/IntegConfig.js';
export * from '../models/IntegType.js';
export * from '../models/IntegrationConfig.js';
export * from '../models/InventoryFilterConditions.js';
export * from '../models/InventoryGcpDisk.js';
export * from '../models/InventoryResource.js';
export * from '../models/InventoryResourceMetadata.js';
export * from '../models/InventorySnapshotVolume.js';
export * from '../models/InventoryVault.js';
export * from '../models/InventoryVolume.js';
export * from '../models/IsVaultDeletableResponse.js';
export * from '../models/IssueMutedNotificationArguments.js';
export * from '../models/JobExecutionDetails.js';
export * from '../models/JobFailedNotificationArguments.js';
export * from '../models/JobIdFilters.js';
export * from '../models/JobInitiationResponse.js';
export * from '../models/JobMetricsReportFailedArguments.js';
export * from '../models/JobSnapshotDetails.js';
export * from '../models/JobStatus.js';
export * from '../models/JobStatusFilters.js';
export * from '../models/JobStep.js';
export * from '../models/JobStepName.js';
export * from '../models/JobStepStatus.js';
export * from '../models/JobSucceededNotificationArguments.js';
export * from '../models/JobTemplate.js';
export * from '../models/JobTemplateRetryPolicy.js';
export * from '../models/KafkaBatchConfig.js';
export * from '../models/KafkaErrorHandlingConfig.js';
export * from '../models/KafkaKeyHandling.js';
export * from '../models/KafkaMessageFormat.js';
export * from '../models/KafkaPartitioningConfig.js';
export * from '../models/KafkaSaslMechanism.js';
export * from '../models/KafkaSecurityConfig.js';
export * from '../models/KafkaSecurityProtocol.js';
export * from '../models/KafkaSourceConfig.js';
export * from '../models/KafkaSourceProperties.js';
export * from '../models/KafkaStartingOffset.js';
export * from '../models/KeyspacesBackupConfig.js';
export * from '../models/KeyspacesBackupConfigApplication.js';
export * from '../models/KeyspacesTableRestoreDestination.js';
export * from '../models/KubeAccessStatus.js';
export * from '../models/KubernetesAccessMode.js';
export * from '../models/LimitData.js';
export * from '../models/ListAccountsResponse.js';
export * from '../models/ListAllRegionsResponse.js';
export * from '../models/ListAllRegionsResponseRegions.js';
export * from '../models/ListApiCredentialsResponse.js';
export * from '../models/ListApplicationOverrideResponse.js';
export * from '../models/ListAtlasOrganizationsResponse.js';
export * from '../models/ListAuditLogRequest.js';
export * from '../models/ListAuditLogResponse.js';
export * from '../models/ListAuditLogsResponse.js';
export * from '../models/ListAwsVpcsResponse.js';
export * from '../models/ListAwsVpcsResponseVpcsInner.js';
export * from '../models/ListAzureAppRegistrationsResponse.js';
export * from '../models/ListAzureCmkEligibleAppsResponse.js';
export * from '../models/ListAzureRegions200Response.js';
export * from '../models/ListAzureSKUs200Response.js';
export * from '../models/ListAzureSKUs200ResponseSkusInner.js';
export * from '../models/ListAzureSKUsRequest.js';
export * from '../models/ListAzureStorageAccountContainers200Response.js';
export * from '../models/ListAzureStorageAccountContainersRequest.js';
export * from '../models/ListAzureSubnets200Response.js';
export * from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
export * from '../models/ListAzureSubnetsRequest.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
export * from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
export * from '../models/ListAzureVirtualNetworks200Response.js';
export * from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
export * from '../models/ListAzureVirtualNetworksRequest.js';
export * from '../models/ListBackupJobTypesResponse.js';
export * from '../models/ListBackupJobsInternal200Response.js';
export * from '../models/ListBackupJobsRequest.js';
export * from '../models/ListBackupJobsResponse.js';
export * from '../models/ListBackupPoliciesResponse.js';
export * from '../models/ListBackupPolicyResponse.js';
export * from '../models/ListBackupVaultResponse.js';
export * from '../models/ListBackupZeroEtlPoliciesResponse.js';
export * from '../models/ListBillingTransactionHistoryRequest.js';
export * from '../models/ListBillingTransactionHistoryResponse.js';
export * from '../models/ListCloudSnapshotsResponse.js';
export * from '../models/ListControlViolationsResponse.js';
export * from '../models/ListControlsResponse.js';
export * from '../models/ListCredentialFindingsResponse.js';
export * from '../models/ListCredentialsProfilesResponse.js';
export * from '../models/ListDailySnapshotsResponse.js';
export * from '../models/ListDashboardsResponse.js';
export * from '../models/ListDataCatalogsResponse.js';
export * from '../models/ListDataClassificationEntitiesResponse.js';
export * from '../models/ListDatabaseSnapshotsResponse.js';
export * from '../models/ListDlsgPoliciesResponse.js';
export * from '../models/ListDynamoDbBackupConfigsResponse.js';
export * from '../models/ListEksClustersResponse.js';
export * from '../models/ListFindingsResponse.js';
export * from '../models/ListGcpFoldersResponse.js';
export * from '../models/ListGcpNetworksResponse.js';
export * from '../models/ListGcpNetworksResponseNetworksInner.js';
export * from '../models/ListGcpOrganizationsResponse.js';
export * from '../models/ListGcpSubnetsResponse.js';
export * from '../models/ListIdpGroupsResponse.js';
export * from '../models/ListIdpsResponse.js';
export * from '../models/ListInfectedExcludePathsResponse.js';
export * from '../models/ListIngestionPipelinesResponse.js';
export * from '../models/ListInstanceProfilesResponse.js';
export * from '../models/ListInstanceTypesResponse.js';
export * from '../models/ListIntegrationsResponse.js';
export * from '../models/ListInventoryAppsResponse.js';
export * from '../models/ListInventoryBackupRegionsResponse.js';
export * from '../models/ListInventoryEnvironmentsResponse.js';
export * from '../models/ListInventoryGlobalDatabasesResponse.js';
export * from '../models/ListInventoryItemSnapshotsResponse.js';
export * from '../models/ListInventoryNetworksResponse.js';
export * from '../models/ListInventoryRequest.js';
export * from '../models/ListInventoryResourceGroupsResponse.js';
export * from '../models/ListInventoryResourceIdentifiersResponse.js';
export * from '../models/ListInventoryResourceTypesResponse.js';
export * from '../models/ListInventoryResourcesResponse.js';
export * from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
export * from '../models/ListInventorySnapshotsRequest.js';
export * from '../models/ListInventorySnapshotsResponse.js';
export * from '../models/ListInventorySourceRegionsResponse.js';
export * from '../models/ListInventorySubnetsResponse.js';
export * from '../models/ListInventoryTagsResponse.js';
export * from '../models/ListJobErrorCodesResponse.js';
export * from '../models/ListJobTemplatesResponse.js';
export * from '../models/ListKeyspacesBackupConfigsResponse.js';
export * from '../models/ListKnownAppsResponse.js';
export * from '../models/ListLogSourcesPoliciesResponse.js';
export * from '../models/ListLogSourcesResponse.js';
export * from '../models/ListMPAOperationsResponse.js';
export * from '../models/ListMPAPoliciesResponse.js';
export * from '../models/ListMPARequestsRequest.js';
export * from '../models/ListMPARequestsRequestFilters.js';
export * from '../models/ListMPARequestsResponse.js';
export * from '../models/ListMPARequestsSort.js';
export * from '../models/ListMongoAtlasPrivateLinks200Response.js';
export * from '../models/ListMyMPARequestsRequest.js';
export * from '../models/ListMyMPARequestsRequestFilters.js';
export * from '../models/ListMyMPARequestsResponse.js';
export * from '../models/ListNotebooksResponse.js';
export * from '../models/ListNotificationPoliciesResponse.js';
export * from '../models/ListNotificationsResponse.js';
export * from '../models/ListOAuthAppsResponse.js';
export * from '../models/ListObjectStoreExclusionRulesResponse.js';
export * from '../models/ListOperators.js';
export * from '../models/ListPermissionsResponse.js';
export * from '../models/ListProjectsResponse.js';
export * from '../models/ListResourceAttachmentEventsResponse.js';
export * from '../models/ListResourcesResponse.js';
export * from '../models/ListRestoreAccountsRequest.js';
export * from '../models/ListRestoreAccountsResponse.js';
export * from '../models/ListRestoreJobTypesResponse.js';
export * from '../models/ListRestoreJobsInternal200Response.js';
export * from '../models/ListRestoreJobsRequest.js';
export * from '../models/ListRestoreJobsResponse.js';
export * from '../models/ListRolesResponse.js';
export * from '../models/ListSavedQueriesResponse.js';
export * from '../models/ListScanJobTypesResponse.js';
export * from '../models/ListScanJobsInternal200Response.js';
export * from '../models/ListScanJobsRequest.js';
export * from '../models/ListScanJobsResponse.js';
export * from '../models/ListSensitivityAnnotationsResponse.js';
export * from '../models/ListSourceAccountsRequest.js';
export * from '../models/ListSourceAccountsResponse.js';
export * from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
export * from '../models/ListSparkEnginesResponse.js';
export * from '../models/ListSparkJobsResponse.js';
export * from '../models/ListSqlEnginesResponse.js';
export * from '../models/ListSqlQueryExecutionsResponse.js';
export * from '../models/ListStorageGatewaysResponse.js';
export * from '../models/ListSubnetsResponse.js';
export * from '../models/ListSubnetsResponseV2.js';
export * from '../models/ListSubnetsResponseV2SubnetsInner.js';
export * from '../models/ListUsersResponse.js';
export * from '../models/ListZeroEtlPoliciesResponse.js';
export * from '../models/LlgLocationResource.js';
export * from '../models/LlgLocationWithResources.js';
export * from '../models/LlgResourcePolicy.js';
export * from '../models/LogRecord.js';
export * from '../models/LogSource.js';
export * from '../models/LogSourceLocation.js';
export * from '../models/LogSourceLocationCloudTrail.js';
export * from '../models/LogSourceLocationCloudWatchLogs.js';
export * from '../models/LogSourceLocationDatadog.js';
export * from '../models/LogSourceLocationGcpCloudLogging.js';
export * from '../models/LogSourceLocationSplunkDdss.js';
export * from '../models/LogSourceWithPolicy.js';
export * from '../models/LogicalOperator.js';
export * from '../models/LogsHistogramDataPoint.js';
export * from '../models/LogsSchema.js';
export * from '../models/LogsSchemaColumn.js';
export * from '../models/LogsSchemaEntry.js';
export * from '../models/LogsSchemasResponse.js';
export * from '../models/LuceneQueryInput.js';
export * from '../models/MPADecision.js';
export * from '../models/MPAListRequestSortField.js';
export * from '../models/MPAOperationInfo.js';
export * from '../models/MPAOperationScope.js';
export * from '../models/MPAOperationType.js';
export * from '../models/MPAPolicy.js';
export * from '../models/MPARequest.js';
export * from '../models/MPARequestDetail.js';
export * from '../models/MPARequestStatus.js';
export * from '../models/MPAResourceSelectionMode.js';
export * from '../models/MPAResourceSelector.js';
export * from '../models/MPAReview.js';
export * from '../models/MPAReviewSubmitDecision.js';
export * from '../models/MaxRetentionDaysLimit.js';
export * from '../models/MaxRetentionRule.js';
export * from '../models/Message.js';
export * from '../models/MeteringDimension.js';
export * from '../models/MicrosoftFabricIntegrationConfig.js';
export * from '../models/MinRetentionRule.js';
export * from '../models/ModelError.js';
export * from '../models/MongoAtlasPrivateLinkEntry.js';
export * from '../models/MongoAtlasRestoreAccountAttributes.js';
export * from '../models/MongoAtlasRestoreAccountAttributesInput.js';
export * from '../models/MongoAtlasSourceAccountAttributes.js';
export * from '../models/MongoAtlasSourceAccountAttributesInput.js';
export * from '../models/MonthlyConfig.js';
export * from '../models/MonthlySnapshotData.js';
export * from '../models/MsaAcceptanceResponse.js';
export * from '../models/NativeStandardBackupPolicyPlan.js';
export * from '../models/NativeStandardBackupSchedules.js';
export * from '../models/NativeStandardConfig.js';
export * from '../models/NeptuneClusterParameterGroup.js';
export * from '../models/NeptuneClusterParameterGroups.js';
export * from '../models/NeptuneRestoreDestination.js';
export * from '../models/NeptuneSnapshotProperties.js';
export * from '../models/NetworkInterfaceConfig.js';
export * from '../models/Notebook.js';
export * from '../models/NotebookExecutionOutput.js';
export * from '../models/NotebookExecutionResult.js';
export * from '../models/NotebookSession.js';
export * from '../models/NotebookSessionStatus.js';
export * from '../models/Notification.js';
export * from '../models/NotificationArguments.js';
export * from '../models/NotificationPolicy.js';
export * from '../models/NotificationPolicyConfig.js';
export * from '../models/NotificationPolicyConfigEmail.js';
export * from '../models/NotificationPolicyConfigServiceNow.js';
export * from '../models/NotificationPolicyConfigSlack.js';
export * from '../models/NotificationPolicyConfigSns.js';
export * from '../models/NotificationPolicyConfigSplunk.js';
export * from '../models/NotificationPolicyConfigWebhook.js';
export * from '../models/NotificationStatus.js';
export * from '../models/NotificationType.js';
export * from '../models/NumberOfCopiesRule.js';
export * from '../models/OAuthApp.js';
export * from '../models/Oauth2TokenResponse.js';
export * from '../models/ObjectStorageDestination.js';
export * from '../models/ObjectStoreExclusionRule.js';
export * from '../models/OnboardAdditionalAzureApps200Response.js';
export * from '../models/OnboardAdditionalAzureAppsRequest.js';
export * from '../models/OnboardRdsCdcRequest.js';
export * from '../models/OnboardRdsCdcResponse.js';
export * from '../models/OnboardingAzureResourceGroup.js';
export * from '../models/OperationIdFilters.js';
export * from '../models/OverrideDataClassificationsRequest.js';
export * from '../models/OverrideDataClassificationsResponse.js';
export * from '../models/OverrideEnvironmentRequest.js';
export * from '../models/OverrideEnvironmentResponse.js';
export * from '../models/OverrideSensitivityAnnotationsRequest.js';
export * from '../models/Pagination.js';
export * from '../models/ParameterCheckResult.js';
export * from '../models/ParentIdFilters.js';
export * from '../models/PartialRestoreData.js';
export * from '../models/PartialRestoreType.js';
export * from '../models/PartitionFormat.js';
export * from '../models/PartitionSegmentType.js';
export * from '../models/PartitionType.js';
export * from '../models/Path.js';
export * from '../models/PathSegment.js';
export * from '../models/PathSnapshotsRequest.js';
export * from '../models/PathSnapshotsResponse.js';
export * from '../models/PathType.js';
export * from '../models/Permission.js';
export * from '../models/PermissionCategory.js';
export * from '../models/PermissionGrant.js';
export * from '../models/PermissionGrantInput.js';
export * from '../models/PermissionType.js';
export * from '../models/PersistentVolumeClaimProperties.js';
export * from '../models/PitrBackupPolicyPlan.js';
export * from '../models/PitrBackupResourceType.js';
export * from '../models/PitrBackupSchedules.js';
export * from '../models/PitrIntervalConfig.js';
export * from '../models/PitrRestoreVaultWindows.js';
export * from '../models/PitrRestoreWindow.js';
export * from '../models/PitrRestoreWindowsResponse.js';
export * from '../models/Preferences.js';
export * from '../models/PrivateLink.js';
export * from '../models/PrivateLinkCheckResult.js';
export * from '../models/PrivateLinkFormatInstructions.js';
export * from '../models/PrivateLinkInstructionStep.js';
export * from '../models/PrivateLinkStatus.js';
export * from '../models/Project.js';
export * from '../models/ProjectConfigurationKeyEnum.js';
export * from '../models/ProjectIdFilters.js';
export * from '../models/Provider.js';
export * from '../models/ProviderAccountIdFilters.js';
export * from '../models/ProviderCategory.js';
export * from '../models/ProviderCategoryFilters.js';
export * from '../models/ProviderParentIdFilters.js';
export * from '../models/ProviderRestoreAccountConnectivityConfig.js';
export * from '../models/PulumiConfiguration.js';
export * from '../models/PulumiConfigurations.js';
export * from '../models/PulumiConfigurationsFilterConditions.js';
export * from '../models/PulumiConfigurationsRequest.js';
export * from '../models/QueryCostData400Response.js';
export * from '../models/QueryCostDataRequest.js';
export * from '../models/QueryCostDataResponse.js';
export * from '../models/QueryDBRequest.js';
export * from '../models/QueryDBResponse.js';
export * from '../models/QueryDBRestoreDestination.js';
export * from '../models/QueryDBRestoreDestinationType.js';
export * from '../models/QueryDBResultResponse.js';
export * from '../models/QueryDBStatus.js';
export * from '../models/QueryDBStatusResponse.js';
export * from '../models/QuotaStatus.js';
export * from '../models/QuotaStatusFilters.js';
export * from '../models/RamShareCheckResult.js';
export * from '../models/RansomwareResourceNotificationArguments.js';
export * from '../models/RdsNativePitrAdvancedConfig.js';
export * from '../models/RdsNativePitrClusterAdvancedConfig.js';
export * from '../models/RdsNativePitrNetworkConfig.js';
export * from '../models/RdsNativePitrWindow.js';
export * from '../models/RdsPasswordConfig.js';
export * from '../models/RdsSecurityGroup.js';
export * from '../models/ReactivateAccountRequest.js';
export * from '../models/ReconnectCustomerVaultAccountResponse.js';
export * from '../models/ReconnectRestoreAccountResponse.js';
export * from '../models/ReconnectSourceAccountResponse.js';
export * from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
export * from '../models/RecordRestoreResult.js';
export * from '../models/RecoveryPointData.js';
export * from '../models/RedshiftCluster.js';
export * from '../models/RedshiftClusters.js';
export * from '../models/RedshiftIntegrationConfig.js';
export * from '../models/RedshiftRestoreDestination.js';
export * from '../models/RedshiftServerlessNamespace.js';
export * from '../models/RedshiftServerlessNamespaces.js';
export * from '../models/RedshiftSnapshotProperties.js';
export * from '../models/RegionCondition.js';
export * from '../models/RegisterInput.js';
export * from '../models/RegisterInputBillingToken.js';
export * from '../models/RegisterResponse.js';
export * from '../models/RelatedGlobalDbCluster.js';
export * from '../models/RequestDetails.js';
export * from '../models/ResourceDetails.js';
export * from '../models/ResourceGroupNameCondition.js';
export * from '../models/ResourceIdCondition.js';
export * from '../models/ResourceIdFilters.js';
export * from '../models/ResourceIdentifiers.js';
export * from '../models/ResourceNameCondition.js';
export * from '../models/ResourceNameFilters.js';
export * from '../models/ResourceProperties.js';
export * from '../models/ResourceQuota.js';
export * from '../models/ResourceSelectorMode.js';
export * from '../models/ResourceSnapshot.js';
export * from '../models/ResourceSnapshotProperties.js';
export * from '../models/ResourceSortField.js';
export * from '../models/ResourceTag.js';
export * from '../models/ResourceType.js';
export * from '../models/ResourceTypeCondition.js';
export * from '../models/ResourceTypeFilters.js';
export * from '../models/ResourceTypeToSecurityGroup.js';
export * from '../models/ResourceValidationError.js';
export * from '../models/RestoreAccount.js';
export * from '../models/RestoreAccountAttributesInput.js';
export * from '../models/RestoreAccountCloudAttributes.js';
export * from '../models/RestoreAccountConnectivityConfig.js';
export * from '../models/RestoreAccountMetricsConfig.js';
export * from '../models/RestoreAccountRegions.js';
export * from '../models/RestoreAccountSortField.js';
export * from '../models/RestoreAccountsFilterConditions.js';
export * from '../models/RestoreAtlasClusterInput.js';
export * from '../models/RestoreAvailabilityZones.js';
export * from '../models/RestoreAwsEc2InstanceRequest.js';
export * from '../models/RestoreAzureDiskConfig.js';
export * from '../models/RestoreAzureDiskRequest.js';
export * from '../models/RestoreAzureInstanceDiskInput.js';
export * from '../models/RestoreAzurePostgresDatabaseRequest.js';
export * from '../models/RestoreAzureSqlDatabaseRequest.js';
export * from '../models/RestoreAzureSqlVmPitrRequest.js';
export * from '../models/RestoreAzureVMInstanceConfig.js';
export * from '../models/RestoreAzureVmInstanceRequest.js';
export * from '../models/RestoreBigQueryDatasetRequest.js';
export * from '../models/RestoreBigQueryNativePitrRequest.js';
export * from '../models/RestoreBucketRequest.js';
export * from '../models/RestoreDbToRdsInstanceRequest.js';
export * from '../models/RestoreDbToRdsSnapshotRequest.js';
export * from '../models/RestoreDestinationLimits.js';
export * from '../models/RestoreDocumentDBRequest.js';
export * from '../models/RestoreDynamoDBTableRequest.js';
export * from '../models/RestoreDynamoDBToExistingTableRequest.js';
export * from '../models/RestoreDynamoDbTableConfig.js';
export * from '../models/RestoreEFSRequest.js';
export * from '../models/RestoreEbsVolumeConfig.js';
export * from '../models/RestoreEc2InstanceConfig.js';
export * from '../models/RestoreEksNamespaceConfig.js';
export * from '../models/RestoreEksNamespaceInput.js';
export * from '../models/RestoreEksNamespaceVolumeInput.js';
export * from '../models/RestoreFSxRequest.js';
export * from '../models/RestoreFilesRequest.js';
export * from '../models/RestoreGceDiskConfig.js';
export * from '../models/RestoreGceInstanceConfig.js';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
export * from '../models/RestoreGcpCloudSqlRequest.js';
export * from '../models/RestoreGcpDiskRequest.js';
export * from '../models/RestoreGcpInstanceDiskInput.js';
export * from '../models/RestoreGcpVmInstanceRequest.js';
export * from '../models/RestoreImage201Response.js';
export * from '../models/RestoreImageImageDeviceInput.js';
export * from '../models/RestoreImageImageInput.js';
export * from '../models/RestoreImageInput.js';
export * from '../models/RestoreImageVolumeInput.js';
export * from '../models/RestoreInstanceImageDeviceInput.js';
export * from '../models/RestoreInstanceImageInput.js';
export * from '../models/RestoreInstanceVolumeInput.js';
export * from '../models/RestoreJob.js';
export * from '../models/RestoreJobConfiguration.js';
export * from '../models/RestoreJobInitiationResponse.js';
export * from '../models/RestoreJobSortField.js';
export * from '../models/RestoreJobType.js';
export * from '../models/RestoreJobTypeFilters.js';
export * from '../models/RestoreJobsFilterConditions.js';
export * from '../models/RestoreKeyspacesTableRequest.js';
export * from '../models/RestoreMethod.js';
export * from '../models/RestoreMethodAvailabilityReason.js';
export * from '../models/RestoreNeptuneRequest.js';
export * from '../models/RestoreRdsInstanceClasses.js';
export * from '../models/RestoreRdsInstanceConfig.js';
export * from '../models/RestoreRdsNativePitrRequest.js';
export * from '../models/RestoreRdsSubnetGroups.js';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
export * from '../models/RestoreRedshiftRequest.js';
export * from '../models/RestoreResult.js';
export * from '../models/RestoreSecurityGroups.js';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
export * from '../models/RestoreVolumeToEbsRequest.js';
export * from '../models/RestoreVolumeToEbsSnapshotRequest.js';
export * from '../models/Role.js';
export * from '../models/RoleAccessGroupCondition.js';
export * from '../models/RoleInstallationMethod.js';
export * from '../models/S3Bucket.js';
export * from '../models/S3Buckets.js';
export * from '../models/S3RestoreDestination.js';
export * from '../models/S3RestoreTarget.js';
export * from '../models/S3SourceProperties.js';
export * from '../models/SAMLCallback400Response.js';
export * from '../models/SAMLCallback401Response.js';
export * from '../models/SAMLCallback500Response.js';
export * from '../models/SamlIdentityProvider.js';
export * from '../models/SamlIdentityProviderConfigsResponse.js';
export * from '../models/SapHanaInstance.js';
export * from '../models/SapHanaRestoreProperties.js';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
export * from '../models/SaveNotebookContentRequest.js';
export * from '../models/SavedQuery.js';
export * from '../models/ScalarOperators.js';
export * from '../models/ScanJob.js';
export * from '../models/ScanJobType.js';
export * from '../models/ScheduleMode.js';
export * from '../models/ScheduleType.js';
export * from '../models/SchemaEvolutionMode.js';
export * from '../models/SchemaRecord.js';
export * from '../models/SchemaRegistryAuthConfig.js';
export * from '../models/SchemaRegistryAuthType.js';
export * from '../models/SchemaRegistryConfig.js';
export * from '../models/SearchDBResponse.js';
export * from '../models/SearchFilesResponse.js';
export * from '../models/SearchInput.js';
export * from '../models/SearchLogsHistogramInput.js';
export * from '../models/SearchLogsHistogramResponse.js';
export * from '../models/SearchLogsInput.js';
export * from '../models/SearchLogsResponse.js';
export * from '../models/SearchResources200Response.js';
export * from '../models/SearchResources200ResponseTablesInner.js';
export * from '../models/SearchResources200ResponseTablesInnerResource.js';
export * from '../models/SearchResources200ResponseTablesInnerSnapshots.js';
export * from '../models/SearchResources200ResponseTablesInnerSource.js';
export * from '../models/SearchResources200ResponseTablesInnerTablesInner.js';
export * from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner.js';
export * from '../models/SearchResourcesRequest.js';
export * from '../models/SecurityAssignmentStatus.js';
export * from '../models/SecurityGroupRule.js';
export * from '../models/SecurityGroupRuleProtocol.js';
export * from '../models/SecurityInformation.js';
export * from '../models/SecurityPlan.js';
export * from '../models/SecurityPlanEnabledResponse.js';
export * from '../models/SecurityResourceNotificationArguments.js';
export * from '../models/SecurityScan.js';
export * from '../models/SecurityScanConclusion.js';
export * from '../models/SecurityScanExclusionPathType.js';
export * from '../models/SecurityScanNotificationData.js';
export * from '../models/SecurityScanResult.js';
export * from '../models/SecurityScansSummaryResponse.js';
export * from '../models/SecuritySnapshotNotificationArguments.js';
export * from '../models/SecuritySummary.js';
export * from '../models/SegmentType.js';
export * from '../models/SendA2AMessageRequest.js';
export * from '../models/SendMessageToAI400Response.js';
export * from '../models/SendMessageToAIRequest.js';
export * from '../models/SensitivityAnnotation.js';
export * from '../models/SensitivityAnnotationsDetails.js';
export * from '../models/ServiceProviderDetails.js';
export * from '../models/Session.js';
export * from '../models/SetupAwsPrivateLinkRequest.js';
export * from '../models/SetupAwsPrivateLinkResponse.js';
export * from '../models/SetupMongoAtlasPrivateLinkRequest.js';
export * from '../models/SetupMongoAtlasPrivateLinkResponse.js';
export * from '../models/Severity.js';
export * from '../models/SeverityFilters.js';
export * from '../models/Snapshot.js';
export * from '../models/SnapshotAccessDeniedNotificationArguments.js';
export * from '../models/SnapshotDateFilters.js';
export * from '../models/SnapshotFilterConditions.js';
export * from '../models/SnapshotFindingCountsResponse.js';
export * from '../models/SnapshotIdFilters.js';
export * from '../models/SnapshotLocation.js';
export * from '../models/SnapshotReference.js';
export * from '../models/SnapshotSortField.js';
export * from '../models/SnapshotStatus.js';
export * from '../models/SnapshotStorage.js';
export * from '../models/SnapshotsSummaryResponse.js';
export * from '../models/SnowflakeIntegrationConfig.js';
export * from '../models/SortBackupJobBy.js';
export * from '../models/SortColumnSpec.js';
export * from '../models/SortLogsBy.js';
export * from '../models/SortOrder.js';
export * from '../models/SortResourceBy.js';
export * from '../models/SortRestoreAccountsBy.js';
export * from '../models/SortRestoreJobBy.js';
export * from '../models/SortSnapshotsBy.js';
export * from '../models/SortSourceAccountsBy.js';
export * from '../models/SourceAccount.js';
export * from '../models/SourceAccountAttributesInput.js';
export * from '../models/SourceAccountCloudAttributes.js';
export * from '../models/SourceAccountMetricsConfig.js';
export * from '../models/SourceAccountProviderIdFilters.js';
export * from '../models/SourceAccountSortField.js';
export * from '../models/SourceAccountsFilterConditions.js';
export * from '../models/SourceAwsOrganizationalUnit.js';
export * from '../models/SourceRegionFilters.js';
export * from '../models/SourceSizeCheckResult.js';
export * from '../models/SourceStorage.js';
export * from '../models/SourceStorageBackupStatus.js';
export * from '../models/SparkEngine.js';
export * from '../models/SparkEngineStatus.js';
export * from '../models/SparkJob.js';
export * from '../models/SparkJobRetryPolicy.js';
export * from '../models/SparkJobSparkSubmitParams.js';
export * from '../models/SparkJobStatus.js';
export * from '../models/SparkJobStorageConfig.js';
export * from '../models/SqlEngine.js';
export * from '../models/SqlEngineStatus.js';
export * from '../models/SqlInstructions.js';
export * from '../models/SqlQueryExecution.js';
export * from '../models/SqlQueryExecutionResult.js';
export * from '../models/SqlQueryExecutionResultColumn.js';
export * from '../models/SqlQueryExecutionStatus.js';
export * from '../models/SqlVmNetworkInfo.js';
export * from '../models/SsoIntegrationSettings.js';
export * from '../models/StackNameFilters.js';
export * from '../models/StandardBackupPolicyPlan.js';
export * from '../models/StandardBackupScheduleConfig.js';
export * from '../models/StandardBackupScheduleFrequency.js';
export * from '../models/StandardBackupSchedules.js';
export * from '../models/StandardIntervalConfig.js';
export * from '../models/StartNotebookSessionInput.js';
export * from '../models/StartSparkJobDirectParams.js';
export * from '../models/StartSparkJobInput.js';
export * from '../models/StartSparkJobTemplateParams.js';
export * from '../models/StartSqlQueryExecutionInput.js';
export * from '../models/StartTimeDateFilters.js';
export * from '../models/StatusCodeFilters.js';
export * from '../models/StorageAccountContainerRestoreDestination.js';
export * from '../models/StorageAccountRestoreTarget.js';
export * from '../models/StorageConfig.js';
export * from '../models/StorageGateway.js';
export * from '../models/StorageGatewayDetails.js';
export * from '../models/StorageGatewayStatus.js';
export * from '../models/SubjectNamingStrategy.js';
export * from '../models/SubnetConfig.js';
export * from '../models/SubnetFilters.js';
export * from '../models/SubnetPerAvailabilityZone.js';
export * from '../models/SubnetsCondition.js';
export * from '../models/SupportedProviders.js';
export * from '../models/TableMaintenanceConfig.js';
export * from '../models/TableRecord.js';
export * from '../models/TagKeyValue.js';
export * from '../models/TagKeyValuesCondition.js';
export * from '../models/TagKeyValuesFilters.js';
export * from '../models/TagKeysCondition.js';
export * from '../models/TagKeysFilters.js';
export * from '../models/TakeNativeSnapshotRequest.js';
export * from '../models/TakeSnapshotRequest.js';
export * from '../models/TakeSnapshotResponse.js';
export * from '../models/TeardownAwsPrivateLinkResponse.js';
export * from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
export * from '../models/TimeFrame.js';
export * from '../models/TimeOfDay.js';
export * from '../models/TimeOfYear.js';
export * from '../models/TokenResponse.js';
export * from '../models/TotalSourceStorageSizeRequest.js';
export * from '../models/TotalSourceStorageSizeResponse.js';
export * from '../models/TriggerKeyspacesScheduledDump200Response.js';
export * from '../models/UnifiedDBRecord.js';
export * from '../models/UnifiedDBServerRecord.js';
export * from '../models/UnifiedDatabaseRecord.js';
export * from '../models/UnifiedSchemaRecord.js';
export * from '../models/UnifiedTableRecord.js';
export * from '../models/UpPulumiStacksResponse.js';
export * from '../models/UpdateAccountCompanyContactsRequest.js';
export * from '../models/UpdateAccountLabelsRequest.js';
export * from '../models/UpdateAccountProfileResponse.js';
export * from '../models/UpdateApiCredentialsRequest.js';
export * from '../models/UpdateAwsRestoreAccountAttributes.js';
export * from '../models/UpdateAwsSourceAccountAttributes.js';
export * from '../models/UpdateBackupPolicyRequest.js';
export * from '../models/UpdateBackupPolicyResponse.js';
export * from '../models/UpdateBackupZeroEtlPolicyInput.js';
export * from '../models/UpdateCloudResourceConfigurationRequest.js';
export * from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
export * from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
export * from '../models/UpdateControlViolationInput.js';
export * from '../models/UpdateCredentialsProfileInput.js';
export * from '../models/UpdateDashboardInput.js';
export * from '../models/UpdateDlsgPolicyRequest.js';
export * from '../models/UpdateDlsgPolicyResponse.js';
export * from '../models/UpdateGcpRestoreAccountAttributes.js';
export * from '../models/UpdateGcpSourceAccountAttributes.js';
export * from '../models/UpdateGraphInput.js';
export * from '../models/UpdateIdpGroupRequest.js';
export * from '../models/UpdateIdpGroupResponse.js';
export * from '../models/UpdateIngestionPipelineInput.js';
export * from '../models/UpdateIntegrationRequest.js';
export * from '../models/UpdateIntegrationResponse.js';
export * from '../models/UpdateJobTemplateInput.js';
export * from '../models/UpdateMPAPolicyRequest.js';
export * from '../models/UpdateMPAPolicyResponse.js';
export * from '../models/UpdateNotebookInput.js';
export * from '../models/UpdatePrivateLinkInput.js';
export * from '../models/UpdateProjectConfigurationKeyRequest.js';
export * from '../models/UpdatePulumiConfigurationRequest.js';
export * from '../models/UpdateResourceSecurityScansExclusionRequest.js';
export * from '../models/UpdateRestoreAccountAttributesInput.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
export * from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
export * from '../models/UpdateRestoreAccountRequest.js';
export * from '../models/UpdateRestoreAccountResponse.js';
export * from '../models/UpdateRoleRequest.js';
export * from '../models/UpdateRoleResponse.js';
export * from '../models/UpdateSamlIdentityProviderInput.js';
export * from '../models/UpdateSavedQueryInput.js';
export * from '../models/UpdateSessionRequest.js';
export * from '../models/UpdateShouldFullBackupResourceRequest.js';
export * from '../models/UpdateSourceAccountAttributesInput.js';
export * from '../models/UpdateSourceAccountRequest.js';
export * from '../models/UpdateSourceAccountResponse.js';
export * from '../models/UpdateTableMaintenanceConfigInput.js';
export * from '../models/UpdateUserInput.js';
export * from '../models/UpdateVaultRequest.js';
export * from '../models/UpdateVaultResponse.js';
export * from '../models/UpdateViewerRoleRequest.js';
export * from '../models/UpdateWorkspaceBucketPolicyInput.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInput.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInput.js';
export * from '../models/UpdateZeroEtlPolicyInput.js';
export * from '../models/Usage.js';
export * from '../models/UsageUnit.js';
export * from '../models/User.js';
export * from '../models/UserIdFilters.js';
export * from '../models/VNetConfig.js';
export * from '../models/ValidateResourceConfigurationRequest.js';
export * from '../models/ValidateResourceConfigurationResponse.js';
export * from '../models/VaultFilters.js';
export * from '../models/VaultMetadataReplicationConfig.js';
export * from '../models/VaultNotificationArguments.js';
export * from '../models/VaultProviderAttributes.js';
export * from '../models/VaultProviderAttributesInput.js';
export * from '../models/VaultSnapshotCount.js';
export * from '../models/VaultStatus.js';
export * from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
export * from '../models/Viewer.js';
export * from '../models/ViolationsDetectionNotificationArguments.js';
export * from '../models/VirtualMachineRestoreDestination.js';
export * from '../models/VisualizationHistogramSeries.js';
export * from '../models/VisualizationHistogramTimePoint.js';
export * from '../models/VisualizationLabel.js';
export * from '../models/VolumeSettings.js';
export * from '../models/VpcCondition.js';
export * from '../models/VpcPeering.js';
export * from '../models/VpcPeeringStatus.js';
export * from '../models/VpcPropertyFilters.js';
export * from '../models/WarmCapacity.js';
export * from '../models/WeeklyConfig.js';
export * from '../models/Workspace.js';
export * from '../models/WorkspaceBucketPolicy.js';
export * from '../models/WorkspaceLoggingSettings.js';
export * from '../models/WorkspaceMetricsSettings.js';
export * from '../models/WorkspaceNetworkingSettings.js';
export * from '../models/WorkspaceNetworkingSettingsVpcPeering.js';
export * from '../models/WorkspaceStatus.js';
export * from '../models/YearlySnapshotDistribution.js';
export * from '../models/ZeroEtlIdentityColumnField.js';
export * from '../models/ZeroEtlIdentityColumnSpec.js';
export * from '../models/ZeroEtlPolicy.js';
export * from '../models/ZeroEtlResourceSelector.js';
export * from '../models/ZeroEtlRoutingMode.js';
export * from '../models/ZeroEtlRoutingPolicy.js';
import { AccessCondition } from '../models/AccessCondition.js';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression.js';
import { Account } from '../models/Account.js';
import { AccountConfigInput } from '../models/AccountConfigInput.js';
import { AccountIdCondition } from '../models/AccountIdCondition.js';
import { AccountIdFilters } from '../models/AccountIdFilters.js';
import { AccountMetricsDestination } from '../models/AccountMetricsDestination.js';
import { AccountNameFilters } from '../models/AccountNameFilters.js';
import { AccountStatusFilters } from '../models/AccountStatusFilters.js';
import { AccountUpdateInput } from '../models/AccountUpdateInput.js';
import { AccountVersion } from '../models/AccountVersion.js';
import { ActionFilters } from '../models/ActionFilters.js';
import { ActionRequiredDetails } from '../models/ActionRequiredDetails.js';
import { ActivateAtlasOrganizationResponse } from '../models/ActivateAtlasOrganizationResponse.js';
import { ActivateGcpFolderResponse } from '../models/ActivateGcpFolderResponse.js';
import { ActivateGcpOrganizationResponse } from '../models/ActivateGcpOrganizationResponse.js';
import { AddRestoreAtlasPrivateLinkRequest } from '../models/AddRestoreAtlasPrivateLinkRequest.js';
import { AgreementWithCredits } from '../models/AgreementWithCredits.js';
import { Ami } from '../models/Ami.js';
import { AmiBlockDevice } from '../models/AmiBlockDevice.js';
import { AnalyzeSqlQueryRequest } from '../models/AnalyzeSqlQueryRequest.js';
import { AnnuallyConfig } from '../models/AnnuallyConfig.js';
import { AnomalyDataPoint } from '../models/AnomalyDataPoint.js';
import { AnomalyGraphData } from '../models/AnomalyGraphData.js';
import { ApiCredentials } from '../models/ApiCredentials.js';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties.js';
import { App } from '../models/App.js';
import { AppFilters } from '../models/AppFilters.js';
import { ApplicationOverride } from '../models/ApplicationOverride.js';
import { AppsCondition } from '../models/AppsCondition.js';
import { AppsDetails } from '../models/AppsDetails.js';
import { AtlasCluster } from '../models/AtlasCluster.js';
import { AtlasClusters } from '../models/AtlasClusters.js';
import { AtlasOrganization } from '../models/AtlasOrganization.js';
import { AtlasProject } from '../models/AtlasProject.js';
import { AtlasProjects } from '../models/AtlasProjects.js';
import { AuditLog } from '../models/AuditLog.js';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner.js';
import { AuditLogExtendedData } from '../models/AuditLogExtendedData.js';
import { AuditLogExtendedDataAuth } from '../models/AuditLogExtendedDataAuth.js';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions.js';
import { AuthResponse } from '../models/AuthResponse.js';
import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput.js';
import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination.js';
import { AwsCredentialProfile } from '../models/AwsCredentialProfile.js';
import { AwsCredentialProfileInput } from '../models/AwsCredentialProfileInput.js';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination.js';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination.js';
import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource.js';
import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput.js';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner.js';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.js';
import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult.js';
import { AwsEbsVolumeResource } from '../models/AwsEbsVolumeResource.js';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData.js';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult.js';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties.js';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult.js';
import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination.js';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult.js';
import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget.js';
import { AwsEc2Resource } from '../models/AwsEc2Resource.js';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties.js';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource.js';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties.js';
import { AwsFsxResource } from '../models/AwsFsxResource.js';
import { AwsKeyspacesDestination } from '../models/AwsKeyspacesDestination.js';
import { AwsKeyspacesResource } from '../models/AwsKeyspacesResource.js';
import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan.js';
import { AwsNativePitrBackupResourceType } from '../models/AwsNativePitrBackupResourceType.js';
import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig.js';
import { AwsNeptuneResource } from '../models/AwsNeptuneResource.js';
import { AwsRdsResource } from '../models/AwsRdsResource.js';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora.js';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings.js';
import { AwsRedshiftResource } from '../models/AwsRedshiftResource.js';
import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes.js';
import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput.js';
import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig.js';
import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes.js';
import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput.js';
import { AwsVaultConfig } from '../models/AwsVaultConfig.js';
import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput.js';
import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig.js';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput.js';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource.js';
import { AzureAppRegistrationOption } from '../models/AzureAppRegistrationOption.js';
import { AzureBackupApplicationsResponse } from '../models/AzureBackupApplicationsResponse.js';
import { AzureCmkEligibleApp } from '../models/AzureCmkEligibleApp.js';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse.js';
import { AzureDisk } from '../models/AzureDisk.js';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData.js';
import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination.js';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult.js';
import { AzureDiskSettings } from '../models/AzureDiskSettings.js';
import { AzureDiskTarget } from '../models/AzureDiskTarget.js';
import { AzureEonApplication } from '../models/AzureEonApplication.js';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse.js';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse.js';
import { AzureManagementGroup } from '../models/AzureManagementGroup.js';
import { AzureManagementGroups } from '../models/AzureManagementGroups.js';
import { AzureMarketplaceWebhookInput } from '../models/AzureMarketplaceWebhookInput.js';
import { AzureMarketplaceWebhookInputSubscription } from '../models/AzureMarketplaceWebhookInputSubscription.js';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary.js';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser.js';
import { AzureMarketplaceWebhookInputSubscriptionTerm } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm.js';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties.js';
import { AzureOnboardedTenantsResponse } from '../models/AzureOnboardedTenantsResponse.js';
import { AzureOnboardingStatus } from '../models/AzureOnboardingStatus.js';
import { AzurePostgresDatabaseRestoreDestination } from '../models/AzurePostgresDatabaseRestoreDestination.js';
import { AzurePostgresDatabaseRestoreTarget } from '../models/AzurePostgresDatabaseRestoreTarget.js';
import { AzureResourceGroup } from '../models/AzureResourceGroup.js';
import { AzureResourceGroups } from '../models/AzureResourceGroups.js';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes.js';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput.js';
import { AzureRestoreAccountConnectivityConfig } from '../models/AzureRestoreAccountConnectivityConfig.js';
import { AzureRestorePointData } from '../models/AzureRestorePointData.js';
import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec.js';
import { AzureSapHanaResource } from '../models/AzureSapHanaResource.js';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response.js';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes.js';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput.js';
import { AzureSqlDatabaseRestoreDestination } from '../models/AzureSqlDatabaseRestoreDestination.js';
import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget.js';
import { AzureStorageAccount } from '../models/AzureStorageAccount.js';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts.js';
import { AzureSubscription } from '../models/AzureSubscription.js';
import { AzureTenant } from '../models/AzureTenant.js';
import { AzureVaultConfig } from '../models/AzureVaultConfig.js';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput.js';
import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination.js';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult.js';
import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget.js';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties.js';
import { AzureVnetConnectivityConfig } from '../models/AzureVnetConnectivityConfig.js';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType.js';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner.js';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram.js';
import { BackupControlViolations } from '../models/BackupControlViolations.js';
import { BackupJob } from '../models/BackupJob.js';
import { BackupJobResponse } from '../models/BackupJobResponse.js';
import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters.js';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions.js';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters.js';
import { BackupPoliciesLimits } from '../models/BackupPoliciesLimits.js';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig.js';
import { BackupPolicy } from '../models/BackupPolicy.js';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments.js';
import { BackupPolicyConfig } from '../models/BackupPolicyConfig.js';
import { BackupPolicyExpression } from '../models/BackupPolicyExpression.js';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition.js';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments.js';
import { BackupPolicyPlan } from '../models/BackupPolicyPlan.js';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector.js';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig.js';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters.js';
import { BackupSchedule } from '../models/BackupSchedule.js';
import { BackupScope } from '../models/BackupScope.js';
import { BackupScopeSummary } from '../models/BackupScopeSummary.js';
import { BackupStatusFilters } from '../models/BackupStatusFilters.js';
import { BackupVault } from '../models/BackupVault.js';
import { BackupZeroEtlAccessConfiguration } from '../models/BackupZeroEtlAccessConfiguration.js';
import { BackupZeroEtlAwsAccessConfiguration } from '../models/BackupZeroEtlAwsAccessConfiguration.js';
import { BackupZeroEtlAwsGlueCatalogConfiguration } from '../models/BackupZeroEtlAwsGlueCatalogConfiguration.js';
import { BackupZeroEtlCatalogConfiguration } from '../models/BackupZeroEtlCatalogConfiguration.js';
import { BackupZeroEtlIdentityColumnSpec } from '../models/BackupZeroEtlIdentityColumnSpec.js';
import { BackupZeroEtlPolicy } from '../models/BackupZeroEtlPolicy.js';
import { BackupZeroEtlResourceSelector } from '../models/BackupZeroEtlResourceSelector.js';
import { BackupZeroEtlRoutingPolicy } from '../models/BackupZeroEtlRoutingPolicy.js';
import { BackupZeroEtlStorageConfiguration } from '../models/BackupZeroEtlStorageConfiguration.js';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides.js';
import { BatchOperationResponse } from '../models/BatchOperationResponse.js';
import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult.js';
import { BatchUpdateLlgPoliciesRequest } from '../models/BatchUpdateLlgPoliciesRequest.js';
import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem.js';
import { BatchValidateResourceConfigurationRequest } from '../models/BatchValidateResourceConfigurationRequest.js';
import { BatchValidateResourceConfigurationResponse } from '../models/BatchValidateResourceConfigurationResponse.js';
import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination.js';
import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig.js';
import { BigQueryNativePitrBackupPolicyPlan } from '../models/BigQueryNativePitrBackupPolicyPlan.js';
import { BigQueryNativePitrBackupResourceType } from '../models/BigQueryNativePitrBackupResourceType.js';
import { BigQueryNativePitrConfig } from '../models/BigQueryNativePitrConfig.js';
import { BigQueryNativePitrDestination } from '../models/BigQueryNativePitrDestination.js';
import { BiglakeCatalogProperties } from '../models/BiglakeCatalogProperties.js';
import { BillingPeriod } from '../models/BillingPeriod.js';
import { BillingTransactionHistory } from '../models/BillingTransactionHistory.js';
import { BooleanFilters } from '../models/BooleanFilters.js';
import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec.js';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse.js';
import { CancelMyMPARequestResponse } from '../models/CancelMyMPARequestResponse.js';
import { CatalogAccessRequest } from '../models/CatalogAccessRequest.js';
import { CatalogAccessResponse } from '../models/CatalogAccessResponse.js';
import { CdcBackupModeCheckResult } from '../models/CdcBackupModeCheckResult.js';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response.js';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest.js';
import { CheckCdcPrerequisitesResponse } from '../models/CheckCdcPrerequisitesResponse.js';
import { Classifications } from '../models/Classifications.js';
import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters.js';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments.js';
import { CloudProviderCondition } from '../models/CloudProviderCondition.js';
import { CloudProviderFilters } from '../models/CloudProviderFilters.js';
import { CloudRegion } from '../models/CloudRegion.js';
import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent.js';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration.js';
import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup.js';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup.js';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties.js';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume.js';
import { ClusterNameFilters } from '../models/ClusterNameFilters.js';
import { ColumnMetadata } from '../models/ColumnMetadata.js';
import { CompanyContact } from '../models/CompanyContact.js';
import { Condition } from '../models/Condition.js';
import { ConnectAtlasOrganizationRequest } from '../models/ConnectAtlasOrganizationRequest.js';
import { ConnectAtlasOrganizationResponse } from '../models/ConnectAtlasOrganizationResponse.js';
import { ConnectAzureBackupAccountRequest } from '../models/ConnectAzureBackupAccountRequest.js';
import { ConnectAzureBackupApplicationsRequest } from '../models/ConnectAzureBackupApplicationsRequest.js';
import { ConnectAzureRestoreAccountRequest } from '../models/ConnectAzureRestoreAccountRequest.js';
import { ConnectAzureSourceAccountRequest } from '../models/ConnectAzureSourceAccountRequest.js';
import { ConnectAzureVaultAccountRequest } from '../models/ConnectAzureVaultAccountRequest.js';
import { ConnectBYOApps200Response } from '../models/ConnectBYOApps200Response.js';
import { ConnectBYOAppsRequest } from '../models/ConnectBYOAppsRequest.js';
import { ConnectBYOAzureBackupApplicationsRequest } from '../models/ConnectBYOAzureBackupApplicationsRequest.js';
import { ConnectCustomerVaultAccountRequest } from '../models/ConnectCustomerVaultAccountRequest.js';
import { ConnectCustomerVaultAccountResponse } from '../models/ConnectCustomerVaultAccountResponse.js';
import { ConnectGcpFolderRequest } from '../models/ConnectGcpFolderRequest.js';
import { ConnectGcpFolderResponse } from '../models/ConnectGcpFolderResponse.js';
import { ConnectGcpOrganizationRequest } from '../models/ConnectGcpOrganizationRequest.js';
import { ConnectGcpOrganizationResponse } from '../models/ConnectGcpOrganizationResponse.js';
import { ConnectRestoreAccountRequest } from '../models/ConnectRestoreAccountRequest.js';
import { ConnectRestoreAccountResponse } from '../models/ConnectRestoreAccountResponse.js';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest.js';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse.js';
import { ConnectSourceAwsOrganizationalUnitRequest } from '../models/ConnectSourceAwsOrganizationalUnitRequest.js';
import { ConnectSourceAwsOrganizationalUnitResponse } from '../models/ConnectSourceAwsOrganizationalUnitResponse.js';
import { Control } from '../models/Control.js';
import { ControlPlaneConfig } from '../models/ControlPlaneConfig.js';
import { ControlRules } from '../models/ControlRules.js';
import { ControlViolation } from '../models/ControlViolation.js';
import { ControlViolations } from '../models/ControlViolations.js';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity.js';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner.js';
import { ControlsFilters } from '../models/ControlsFilters.js';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig.js';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig.js';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest.js';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.js';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest.js';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse.js';
import { Cost } from '../models/Cost.js';
import { CostDataFilters } from '../models/CostDataFilters.js';
import { CostDataRecord } from '../models/CostDataRecord.js';
import { CostDataRecordCost } from '../models/CostDataRecordCost.js';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions.js';
import { CostRecordMetadata } from '../models/CostRecordMetadata.js';
import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer.js';
import { CreateAccountInput } from '../models/CreateAccountInput.js';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest.js';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse.js';
import { CreateBackupPolicyRequest } from '../models/CreateBackupPolicyRequest.js';
import { CreateBackupPolicyResponse } from '../models/CreateBackupPolicyResponse.js';
import { CreateBackupZeroEtlPolicyInput } from '../models/CreateBackupZeroEtlPolicyInput.js';
import { CreateCredentialsProfileInput } from '../models/CreateCredentialsProfileInput.js';
import { CreateCredentialsProfileInputAwsCredentialProfile } from '../models/CreateCredentialsProfileInputAwsCredentialProfile.js';
import { CreateDashboardInput } from '../models/CreateDashboardInput.js';
import { CreateDataCatalogInput } from '../models/CreateDataCatalogInput.js';
import { CreateDlsgPolicyRequest } from '../models/CreateDlsgPolicyRequest.js';
import { CreateDlsgPolicyResponse } from '../models/CreateDlsgPolicyResponse.js';
import { CreateFabricTableShortcutDemoRequest } from '../models/CreateFabricTableShortcutDemoRequest.js';
import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner.js';
import { CreateFabricTableShortcutDemoResponse } from '../models/CreateFabricTableShortcutDemoResponse.js';
import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner.js';
import { CreateGraphInput } from '../models/CreateGraphInput.js';
import { CreateIdpGroupRequest } from '../models/CreateIdpGroupRequest.js';
import { CreateIdpGroupResponse } from '../models/CreateIdpGroupResponse.js';
import { CreateInfectedExcludePathInput } from '../models/CreateInfectedExcludePathInput.js';
import { CreateIngestionPipelineInput } from '../models/CreateIngestionPipelineInput.js';
import { CreateIntegrationRequest } from '../models/CreateIntegrationRequest.js';
import { CreateIntegrationResponse } from '../models/CreateIntegrationResponse.js';
import { CreateJobTemplateInput } from '../models/CreateJobTemplateInput.js';
import { CreateMPAPolicyRequest } from '../models/CreateMPAPolicyRequest.js';
import { CreateMPAPolicyResponse } from '../models/CreateMPAPolicyResponse.js';
import { CreateMPARequestReviewRequest } from '../models/CreateMPARequestReviewRequest.js';
import { CreateMPARequestReviewResponse } from '../models/CreateMPARequestReviewResponse.js';
import { CreateNotebookInput } from '../models/CreateNotebookInput.js';
import { CreateOAuthAppRequest } from '../models/CreateOAuthAppRequest.js';
import { CreateOAuthAppResponse } from '../models/CreateOAuthAppResponse.js';
import { CreatePolicyInput } from '../models/CreatePolicyInput.js';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput.js';
import { CreatePrivateLinkInput } from '../models/CreatePrivateLinkInput.js';
import { CreateProjectInput } from '../models/CreateProjectInput.js';
import { CreatePulumiConfigurationRequest } from '../models/CreatePulumiConfigurationRequest.js';
import { CreateRoleRequest } from '../models/CreateRoleRequest.js';
import { CreateRoleResponse } from '../models/CreateRoleResponse.js';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput.js';
import { CreateSavedQueryInput } from '../models/CreateSavedQueryInput.js';
import { CreateScanJobInput } from '../models/CreateScanJobInput.js';
import { CreateScanJobResponse } from '../models/CreateScanJobResponse.js';
import { CreateSessionRequest } from '../models/CreateSessionRequest.js';
import { CreateSparkEngineInput } from '../models/CreateSparkEngineInput.js';
import { CreateSqlEngineInput } from '../models/CreateSqlEngineInput.js';
import { CreateUserInput } from '../models/CreateUserInput.js';
import { CreateVaultRequest } from '../models/CreateVaultRequest.js';
import { CreateVaultResponse } from '../models/CreateVaultResponse.js';
import { CreateVpcPeeringInput } from '../models/CreateVpcPeeringInput.js';
import { CreateZeroEtlPolicyInput } from '../models/CreateZeroEtlPolicyInput.js';
import { CredentialFinding } from '../models/CredentialFinding.js';
import { CredentialsProfile } from '../models/CredentialsProfile.js';
import { CredentialsProfileAwsCredentialProfile } from '../models/CredentialsProfileAwsCredentialProfile.js';
import { CreditsMonthlyUsageNotificationArguments } from '../models/CreditsMonthlyUsageNotificationArguments.js';
import { CreditsNotificationArguments } from '../models/CreditsNotificationArguments.js';
import { CrossResourceQueryRequest } from '../models/CrossResourceQueryRequest.js';
import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner.js';
import { CustomTagsInner } from '../models/CustomTagsInner.js';
import { CustomerVaultAccount } from '../models/CustomerVaultAccount.js';
import { DBResourceMetadata } from '../models/DBResourceMetadata.js';
import { DBServerRecord } from '../models/DBServerRecord.js';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata.js';
import { DailyConfig } from '../models/DailyConfig.js';
import { DailySnapshotData } from '../models/DailySnapshotData.js';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries.js';
import { DailyStorageSummary } from '../models/DailyStorageSummary.js';
import { Dashboard } from '../models/Dashboard.js';
import { DashboardGraph } from '../models/DashboardGraph.js';
import { DashboardGraphLayout } from '../models/DashboardGraphLayout.js';
import { DashboardWithGraphs } from '../models/DashboardWithGraphs.js';
import { DataCatalog } from '../models/DataCatalog.js';
import { DataCatalogBiglakeProperties } from '../models/DataCatalogBiglakeProperties.js';
import { DataCatalogGlueProperties } from '../models/DataCatalogGlueProperties.js';
import { DataCatalogIcebergRestProperties } from '../models/DataCatalogIcebergRestProperties.js';
import { DataClassesCondition } from '../models/DataClassesCondition.js';
import { DataClassesDetails } from '../models/DataClassesDetails.js';
import { DataClassesFilters } from '../models/DataClassesFilters.js';
import { DataClassificationEntity } from '../models/DataClassificationEntity.js';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig.js';
import { DatabaseDestination } from '../models/DatabaseDestination.js';
import { DatabaseRecord } from '../models/DatabaseRecord.js';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig.js';
import { DeactivateAccountRequest } from '../models/DeactivateAccountRequest.js';
import { DeactivateAccountResponse } from '../models/DeactivateAccountResponse.js';
import { DeactivateAtlasOrganizationResponse } from '../models/DeactivateAtlasOrganizationResponse.js';
import { DeactivateGcpFolderResponse } from '../models/DeactivateGcpFolderResponse.js';
import { DeactivateGcpOrganizationResponse } from '../models/DeactivateGcpOrganizationResponse.js';
import { DestinationDetails } from '../models/DestinationDetails.js';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes.js';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure.js';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes.js';
import { DetectorSummary } from '../models/DetectorSummary.js';
import { DisableResourceOverrideLimitsResponse } from '../models/DisableResourceOverrideLimitsResponse.js';
import { DisconnectCustomerVaultAccountResponse } from '../models/DisconnectCustomerVaultAccountResponse.js';
import { DisconnectRestoreAccountResponse } from '../models/DisconnectRestoreAccountResponse.js';
import { DisconnectSourceAccountResponse } from '../models/DisconnectSourceAccountResponse.js';
import { DisconnectSourceAwsOrganizationalUnitResponse } from '../models/DisconnectSourceAwsOrganizationalUnitResponse.js';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams.js';
import { DiscoveryJob } from '../models/DiscoveryJob.js';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse.js';
import { DlsgPolicy } from '../models/DlsgPolicy.js';
import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig.js';
import { DlsgPolicyFilters } from '../models/DlsgPolicyFilters.js';
import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan.js';
import { DlsgSettings } from '../models/DlsgSettings.js';
import { DocumentDBRestoreDestination } from '../models/DocumentDBRestoreDestination.js';
import { DocumentDbClusterParameterGroup } from '../models/DocumentDbClusterParameterGroup.js';
import { DocumentDbClusterParameterGroups } from '../models/DocumentDbClusterParameterGroups.js';
import { DocumentDbSnapshotProperties } from '../models/DocumentDbSnapshotProperties.js';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy.js';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary.js';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint.js';
import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig.js';
import { DynamoDBRestoreMethodAvailabilityRequest } from '../models/DynamoDBRestoreMethodAvailabilityRequest.js';
import { DynamoDBRestoreMethodAvailabilityResponse } from '../models/DynamoDBRestoreMethodAvailabilityResponse.js';
import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig.js';
import { DynamoDbBackupConfigApplication } from '../models/DynamoDbBackupConfigApplication.js';
import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination.js';
import { EFSRestoreDestination } from '../models/EFSRestoreDestination.js';
import { EbsRestoreDestination } from '../models/EbsRestoreDestination.js';
import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination.js';
import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget.js';
import { EbsTarget } from '../models/EbsTarget.js';
import { EfsSnapshotProperties } from '../models/EfsSnapshotProperties.js';
import { EksCluster } from '../models/EksCluster.js';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination.js';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult.js';
import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult.js';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig.js';
import { EnableFromLimitExceededResponse } from '../models/EnableFromLimitExceededResponse.js';
import { EnableResourceOverrideLimitsResponse } from '../models/EnableResourceOverrideLimitsResponse.js';
import { EnableRestoreAccountMetricsConfigRequest } from '../models/EnableRestoreAccountMetricsConfigRequest.js';
import { EnableRestoreAccountMetricsConfigResponse } from '../models/EnableRestoreAccountMetricsConfigResponse.js';
import { EnableSourceAccountMetricsConfigRequest } from '../models/EnableSourceAccountMetricsConfigRequest.js';
import { EnableSourceAccountMetricsConfigResponse } from '../models/EnableSourceAccountMetricsConfigResponse.js';
import { EncryptionKey } from '../models/EncryptionKey.js';
import { EncryptionKeys } from '../models/EncryptionKeys.js';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters.js';
import { EnvironmentCondition } from '../models/EnvironmentCondition.js';
import { EnvironmentDetails } from '../models/EnvironmentDetails.js';
import { EnvironmentFilters } from '../models/EnvironmentFilters.js';
import { EonAccount } from '../models/EonAccount.js';
import { EonAccountIdFilters } from '../models/EonAccountIdFilters.js';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse.js';
import { ExecuteNotebookCodeInput } from '../models/ExecuteNotebookCodeInput.js';
import { ExportAccessDeniedItemsRequest } from '../models/ExportAccessDeniedItemsRequest.js';
import { ExportCostData400Response } from '../models/ExportCostData400Response.js';
import { ExportCostDataRequest } from '../models/ExportCostDataRequest.js';
import { FSxRestoreDestination } from '../models/FSxRestoreDestination.js';
import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions.js';
import { FeatureFlagOverrideGet200Response } from '../models/FeatureFlagOverrideGet200Response.js';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse.js';
import { FileExplorerResponse } from '../models/FileExplorerResponse.js';
import { FilePath } from '../models/FilePath.js';
import { FileRestoreData } from '../models/FileRestoreData.js';
import { FileSearchRecord } from '../models/FileSearchRecord.js';
import { FileSnapshot } from '../models/FileSnapshot.js';
import { FindingCountEntry } from '../models/FindingCountEntry.js';
import { FindingEntry } from '../models/FindingEntry.js';
import { ForceDeleteSnapshotsRequest } from '../models/ForceDeleteSnapshotsRequest.js';
import { FreeTextFilters } from '../models/FreeTextFilters.js';
import { FsxOntapVolume } from '../models/FsxOntapVolume.js';
import { FsxSnapshotProperties } from '../models/FsxSnapshotProperties.js';
import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo.js';
import { GCSBucket } from '../models/GCSBucket.js';
import { GCSBuckets } from '../models/GCSBuckets.js';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination.js';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget.js';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput.js';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource.js';
import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner.js';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner.js';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner.js';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner.js';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource.js';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings.js';
import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination.js';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties.js';
import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget.js';
import { GcpDiskResource } from '../models/GcpDiskResource.js';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData.js';
import { GcpDiskRestoreDestination } from '../models/GcpDiskRestoreDestination.js';
import { GcpDiskSettings } from '../models/GcpDiskSettings.js';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties.js';
import { GcpDiskTarget } from '../models/GcpDiskTarget.js';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse.js';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey.js';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys.js';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource.js';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse.js';
import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig.js';
import { GcpOrganization } from '../models/GcpOrganization.js';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes.js';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput.js';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig.js';
import { GcpSapHanaResource } from '../models/GcpSapHanaResource.js';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes.js';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput.js';
import { GcpSubnet } from '../models/GcpSubnet.js';
import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion.js';
import { GcpVaultConfig } from '../models/GcpVaultConfig.js';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput.js';
import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination.js';
import { GcpVmInstanceRestoreResult } from '../models/GcpVmInstanceRestoreResult.js';
import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget.js';
import { GcpVmResource } from '../models/GcpVmResource.js';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties.js';
import { GcsSourceProperties } from '../models/GcsSourceProperties.js';
import { GenericSnapshotData } from '../models/GenericSnapshotData.js';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse.js';
import { GetAdditionalAzureAppsOnboardingStatus200Response } from '../models/GetAdditionalAzureAppsOnboardingStatus200Response.js';
import { GetAgreementsResponse } from '../models/GetAgreementsResponse.js';
import { GetAwsPrivateLinkStatusResponse } from '../models/GetAwsPrivateLinkStatusResponse.js';
import { GetBackupJobResponse } from '../models/GetBackupJobResponse.js';
import { GetBackupPolicyResponse } from '../models/GetBackupPolicyResponse.js';
import { GetBillingPeriodsResponse } from '../models/GetBillingPeriodsResponse.js';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse.js';
import { GetCredits400Response } from '../models/GetCredits400Response.js';
import { GetCreditsResponse } from '../models/GetCreditsResponse.js';
import { GetDlsgPolicyResponse } from '../models/GetDlsgPolicyResponse.js';
import { GetGcsServiceAgentResponse } from '../models/GetGcsServiceAgentResponse.js';
import { GetIdpGroupResponse } from '../models/GetIdpGroupResponse.js';
import { GetIntegrationResponse } from '../models/GetIntegrationResponse.js';
import { GetLimitsResponseValue } from '../models/GetLimitsResponseValue.js';
import { GetMPAPolicyResponse } from '../models/GetMPAPolicyResponse.js';
import { GetMPARequestResponse } from '../models/GetMPARequestResponse.js';
import { GetNotebookContent200Response } from '../models/GetNotebookContent200Response.js';
import { GetProjectConfigurationKeyResponse } from '../models/GetProjectConfigurationKeyResponse.js';
import { GetProjectConfigurationKeysResponse } from '../models/GetProjectConfigurationKeysResponse.js';
import { GetResourceResponse } from '../models/GetResourceResponse.js';
import { GetRestoreAccountConnectivityConfigResponse } from '../models/GetRestoreAccountConnectivityConfigResponse.js';
import { GetRestoreAccountMetricsConfigResponse } from '../models/GetRestoreAccountMetricsConfigResponse.js';
import { GetRestoreJobResponse } from '../models/GetRestoreJobResponse.js';
import { GetRoleResponse } from '../models/GetRoleResponse.js';
import { GetScanJobResponse } from '../models/GetScanJobResponse.js';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse.js';
import { GetSourceAccountMetricsConfigResponse } from '../models/GetSourceAccountMetricsConfigResponse.js';
import { GetSourceAccountResponse } from '../models/GetSourceAccountResponse.js';
import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest.js';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse.js';
import { GetVaultResponse } from '../models/GetVaultResponse.js';
import { GlobalClusterIdentifierCondition } from '../models/GlobalClusterIdentifierCondition.js';
import { GlueCatalogProperties } from '../models/GlueCatalogProperties.js';
import { GoogleWorkspaceConnectionInfo } from '../models/GoogleWorkspaceConnectionInfo.js';
import { GoogleWorkspaceServiceAccountInfo } from '../models/GoogleWorkspaceServiceAccountInfo.js';
import { GoogleWorkspaceSourceAccountAttributes } from '../models/GoogleWorkspaceSourceAccountAttributes.js';
import { GoogleWorkspaceSourceAccountAttributesInput } from '../models/GoogleWorkspaceSourceAccountAttributesInput.js';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan.js';
import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType.js';
import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig.js';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules.js';
import { HighFrequencyIntervalConfig } from '../models/HighFrequencyIntervalConfig.js';
import { IDs } from '../models/IDs.js';
import { IcebergRestCatalogProperties } from '../models/IcebergRestCatalogProperties.js';
import { IdFilters } from '../models/IdFilters.js';
import { Identifier } from '../models/Identifier.js';
import { IdentityProvidersNames } from '../models/IdentityProvidersNames.js';
import { Idp } from '../models/Idp.js';
import { IdpGroup } from '../models/IdpGroup.js';
import { ImportDlsgCertificateRequest } from '../models/ImportDlsgCertificateRequest.js';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification.js';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize.js';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime.js';
import { InfectedDateSize } from '../models/InfectedDateSize.js';
import { InfectedExcludePath } from '../models/InfectedExcludePath.js';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse.js';
import { IngestionPipeline } from '../models/IngestionPipeline.js';
import { InitAuthInput } from '../models/InitAuthInput.js';
import { Initiator } from '../models/Initiator.js';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters.js';
import { IntegConfig } from '../models/IntegConfig.js';
import { IntegrationConfig } from '../models/IntegrationConfig.js';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions.js';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk.js';
import { InventoryResource } from '../models/InventoryResource.js';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata.js';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume.js';
import { InventoryVault } from '../models/InventoryVault.js';
import { InventoryVolume } from '../models/InventoryVolume.js';
import { IsVaultDeletableResponse } from '../models/IsVaultDeletableResponse.js';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments.js';
import { JobExecutionDetails } from '../models/JobExecutionDetails.js';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments.js';
import { JobIdFilters } from '../models/JobIdFilters.js';
import { JobInitiationResponse } from '../models/JobInitiationResponse.js';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments.js';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails.js';
import { JobStatusFilters } from '../models/JobStatusFilters.js';
import { JobStep } from '../models/JobStep.js';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments.js';
import { JobTemplate } from '../models/JobTemplate.js';
import { JobTemplateRetryPolicy } from '../models/JobTemplateRetryPolicy.js';
import { KafkaBatchConfig } from '../models/KafkaBatchConfig.js';
import { KafkaErrorHandlingConfig } from '../models/KafkaErrorHandlingConfig.js';
import { KafkaPartitioningConfig } from '../models/KafkaPartitioningConfig.js';
import { KafkaSecurityConfig } from '../models/KafkaSecurityConfig.js';
import { KafkaSourceConfig } from '../models/KafkaSourceConfig.js';
import { KafkaSourceProperties } from '../models/KafkaSourceProperties.js';
import { KeyspacesBackupConfig } from '../models/KeyspacesBackupConfig.js';
import { KeyspacesBackupConfigApplication } from '../models/KeyspacesBackupConfigApplication.js';
import { KeyspacesTableRestoreDestination } from '../models/KeyspacesTableRestoreDestination.js';
import { LimitData } from '../models/LimitData.js';
import { ListAccountsResponse } from '../models/ListAccountsResponse.js';
import { ListAllRegionsResponse } from '../models/ListAllRegionsResponse.js';
import { ListAllRegionsResponseRegions } from '../models/ListAllRegionsResponseRegions.js';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse.js';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse.js';
import { ListAtlasOrganizationsResponse } from '../models/ListAtlasOrganizationsResponse.js';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest.js';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse.js';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse.js';
import { ListAwsVpcsResponse } from '../models/ListAwsVpcsResponse.js';
import { ListAwsVpcsResponseVpcsInner } from '../models/ListAwsVpcsResponseVpcsInner.js';
import { ListAzureAppRegistrationsResponse } from '../models/ListAzureAppRegistrationsResponse.js';
import { ListAzureCmkEligibleAppsResponse } from '../models/ListAzureCmkEligibleAppsResponse.js';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response.js';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response.js';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner.js';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest.js';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response.js';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest.js';
import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response.js';
import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner.js';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest.js';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response.js';
import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.js';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest.js';
import { ListAzureVirtualNetworks200Response } from '../models/ListAzureVirtualNetworks200Response.js';
import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner.js';
import { ListAzureVirtualNetworksRequest } from '../models/ListAzureVirtualNetworksRequest.js';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse.js';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response.js';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest.js';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse.js';
import { ListBackupPoliciesResponse } from '../models/ListBackupPoliciesResponse.js';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse.js';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse.js';
import { ListBackupZeroEtlPoliciesResponse } from '../models/ListBackupZeroEtlPoliciesResponse.js';
import { ListBillingTransactionHistoryRequest } from '../models/ListBillingTransactionHistoryRequest.js';
import { ListBillingTransactionHistoryResponse } from '../models/ListBillingTransactionHistoryResponse.js';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse.js';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse.js';
import { ListControlsResponse } from '../models/ListControlsResponse.js';
import { ListCredentialFindingsResponse } from '../models/ListCredentialFindingsResponse.js';
import { ListCredentialsProfilesResponse } from '../models/ListCredentialsProfilesResponse.js';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse.js';
import { ListDashboardsResponse } from '../models/ListDashboardsResponse.js';
import { ListDataCatalogsResponse } from '../models/ListDataCatalogsResponse.js';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse.js';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse.js';
import { ListDlsgPoliciesResponse } from '../models/ListDlsgPoliciesResponse.js';
import { ListDynamoDbBackupConfigsResponse } from '../models/ListDynamoDbBackupConfigsResponse.js';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse.js';
import { ListFindingsResponse } from '../models/ListFindingsResponse.js';
import { ListGcpFoldersResponse } from '../models/ListGcpFoldersResponse.js';
import { ListGcpNetworksResponse } from '../models/ListGcpNetworksResponse.js';
import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner.js';
import { ListGcpOrganizationsResponse } from '../models/ListGcpOrganizationsResponse.js';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse.js';
import { ListIdpGroupsResponse } from '../models/ListIdpGroupsResponse.js';
import { ListIdpsResponse } from '../models/ListIdpsResponse.js';
import { ListInfectedExcludePathsResponse } from '../models/ListInfectedExcludePathsResponse.js';
import { ListIngestionPipelinesResponse } from '../models/ListIngestionPipelinesResponse.js';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse.js';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse.js';
import { ListIntegrationsResponse } from '../models/ListIntegrationsResponse.js';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse.js';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse.js';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse.js';
import { ListInventoryGlobalDatabasesResponse } from '../models/ListInventoryGlobalDatabasesResponse.js';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse.js';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse.js';
import { ListInventoryRequest } from '../models/ListInventoryRequest.js';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse.js';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse.js';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse.js';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse.js';
import { ListInventorySensitivityAnnotationValuesResponse } from '../models/ListInventorySensitivityAnnotationValuesResponse.js';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest.js';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse.js';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse.js';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse.js';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse.js';
import { ListJobErrorCodesResponse } from '../models/ListJobErrorCodesResponse.js';
import { ListJobTemplatesResponse } from '../models/ListJobTemplatesResponse.js';
import { ListKeyspacesBackupConfigsResponse } from '../models/ListKeyspacesBackupConfigsResponse.js';
import { ListKnownAppsResponse } from '../models/ListKnownAppsResponse.js';
import { ListLogSourcesPoliciesResponse } from '../models/ListLogSourcesPoliciesResponse.js';
import { ListLogSourcesResponse } from '../models/ListLogSourcesResponse.js';
import { ListMPAOperationsResponse } from '../models/ListMPAOperationsResponse.js';
import { ListMPAPoliciesResponse } from '../models/ListMPAPoliciesResponse.js';
import { ListMPARequestsRequest } from '../models/ListMPARequestsRequest.js';
import { ListMPARequestsRequestFilters } from '../models/ListMPARequestsRequestFilters.js';
import { ListMPARequestsResponse } from '../models/ListMPARequestsResponse.js';
import { ListMPARequestsSort } from '../models/ListMPARequestsSort.js';
import { ListMongoAtlasPrivateLinks200Response } from '../models/ListMongoAtlasPrivateLinks200Response.js';
import { ListMyMPARequestsRequest } from '../models/ListMyMPARequestsRequest.js';
import { ListMyMPARequestsRequestFilters } from '../models/ListMyMPARequestsRequestFilters.js';
import { ListMyMPARequestsResponse } from '../models/ListMyMPARequestsResponse.js';
import { ListNotebooksResponse } from '../models/ListNotebooksResponse.js';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse.js';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse.js';
import { ListOAuthAppsResponse } from '../models/ListOAuthAppsResponse.js';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse.js';
import { ListPermissionsResponse } from '../models/ListPermissionsResponse.js';
import { ListProjectsResponse } from '../models/ListProjectsResponse.js';
import { ListResourceAttachmentEventsResponse } from '../models/ListResourceAttachmentEventsResponse.js';
import { ListResourcesResponse } from '../models/ListResourcesResponse.js';
import { ListRestoreAccountsRequest } from '../models/ListRestoreAccountsRequest.js';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse.js';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse.js';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response.js';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest.js';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse.js';
import { ListRolesResponse } from '../models/ListRolesResponse.js';
import { ListSavedQueriesResponse } from '../models/ListSavedQueriesResponse.js';
import { ListScanJobTypesResponse } from '../models/ListScanJobTypesResponse.js';
import { ListScanJobsInternal200Response } from '../models/ListScanJobsInternal200Response.js';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest.js';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse.js';
import { ListSensitivityAnnotationsResponse } from '../models/ListSensitivityAnnotationsResponse.js';
import { ListSourceAccountsRequest } from '../models/ListSourceAccountsRequest.js';
import { ListSourceAccountsResponse } from '../models/ListSourceAccountsResponse.js';
import { ListSourceAwsOrganizationalUnitsResponse } from '../models/ListSourceAwsOrganizationalUnitsResponse.js';
import { ListSparkEnginesResponse } from '../models/ListSparkEnginesResponse.js';
import { ListSparkJobsResponse } from '../models/ListSparkJobsResponse.js';
import { ListSqlEnginesResponse } from '../models/ListSqlEnginesResponse.js';
import { ListSqlQueryExecutionsResponse } from '../models/ListSqlQueryExecutionsResponse.js';
import { ListStorageGatewaysResponse } from '../models/ListStorageGatewaysResponse.js';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse.js';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2.js';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner.js';
import { ListUsersResponse } from '../models/ListUsersResponse.js';
import { ListZeroEtlPoliciesResponse } from '../models/ListZeroEtlPoliciesResponse.js';
import { LlgLocationResource } from '../models/LlgLocationResource.js';
import { LlgLocationWithResources } from '../models/LlgLocationWithResources.js';
import { LlgResourcePolicy } from '../models/LlgResourcePolicy.js';
import { LogRecord } from '../models/LogRecord.js';
import { LogSource } from '../models/LogSource.js';
import { LogSourceLocation } from '../models/LogSourceLocation.js';
import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail.js';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs.js';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog.js';
import { LogSourceLocationGcpCloudLogging } from '../models/LogSourceLocationGcpCloudLogging.js';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss.js';
import { LogSourceWithPolicy } from '../models/LogSourceWithPolicy.js';
import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint.js';
import { LogsSchema } from '../models/LogsSchema.js';
import { LogsSchemaColumn } from '../models/LogsSchemaColumn.js';
import { LogsSchemaEntry } from '../models/LogsSchemaEntry.js';
import { LogsSchemasResponse } from '../models/LogsSchemasResponse.js';
import { LuceneQueryInput } from '../models/LuceneQueryInput.js';
import { MPAOperationInfo } from '../models/MPAOperationInfo.js';
import { MPAPolicy } from '../models/MPAPolicy.js';
import { MPARequest } from '../models/MPARequest.js';
import { MPARequestDetail } from '../models/MPARequestDetail.js';
import { MPAResourceSelector } from '../models/MPAResourceSelector.js';
import { MPAReview } from '../models/MPAReview.js';
import { MaxRetentionDaysLimit } from '../models/MaxRetentionDaysLimit.js';
import { MaxRetentionRule } from '../models/MaxRetentionRule.js';
import { Message } from '../models/Message.js';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig.js';
import { MinRetentionRule } from '../models/MinRetentionRule.js';
import { ModelError } from '../models/ModelError.js';
import { MongoAtlasPrivateLinkEntry } from '../models/MongoAtlasPrivateLinkEntry.js';
import { MongoAtlasRestoreAccountAttributes } from '../models/MongoAtlasRestoreAccountAttributes.js';
import { MongoAtlasRestoreAccountAttributesInput } from '../models/MongoAtlasRestoreAccountAttributesInput.js';
import { MongoAtlasSourceAccountAttributes } from '../models/MongoAtlasSourceAccountAttributes.js';
import { MongoAtlasSourceAccountAttributesInput } from '../models/MongoAtlasSourceAccountAttributesInput.js';
import { MonthlyConfig } from '../models/MonthlyConfig.js';
import { MonthlySnapshotData } from '../models/MonthlySnapshotData.js';
import { MsaAcceptanceResponse } from '../models/MsaAcceptanceResponse.js';
import { NativeStandardBackupPolicyPlan } from '../models/NativeStandardBackupPolicyPlan.js';
import { NativeStandardBackupSchedules } from '../models/NativeStandardBackupSchedules.js';
import { NativeStandardConfig } from '../models/NativeStandardConfig.js';
import { NeptuneClusterParameterGroup } from '../models/NeptuneClusterParameterGroup.js';
import { NeptuneClusterParameterGroups } from '../models/NeptuneClusterParameterGroups.js';
import { NeptuneRestoreDestination } from '../models/NeptuneRestoreDestination.js';
import { NeptuneSnapshotProperties } from '../models/NeptuneSnapshotProperties.js';
import { NetworkInterfaceConfig } from '../models/NetworkInterfaceConfig.js';
import { Notebook } from '../models/Notebook.js';
import { NotebookExecutionOutput } from '../models/NotebookExecutionOutput.js';
import { NotebookExecutionResult } from '../models/NotebookExecutionResult.js';
import { NotebookSession } from '../models/NotebookSession.js';
import { Notification } from '../models/Notification.js';
import { NotificationArguments } from '../models/NotificationArguments.js';
import { NotificationPolicy } from '../models/NotificationPolicy.js';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig.js';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail.js';
import { NotificationPolicyConfigServiceNow } from '../models/NotificationPolicyConfigServiceNow.js';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack.js';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns.js';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk.js';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook.js';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule.js';
import { OAuthApp } from '../models/OAuthApp.js';
import { Oauth2TokenResponse } from '../models/Oauth2TokenResponse.js';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination.js';
import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule.js';
import { OnboardAdditionalAzureApps200Response } from '../models/OnboardAdditionalAzureApps200Response.js';
import { OnboardAdditionalAzureAppsRequest } from '../models/OnboardAdditionalAzureAppsRequest.js';
import { OnboardRdsCdcRequest } from '../models/OnboardRdsCdcRequest.js';
import { OnboardRdsCdcResponse } from '../models/OnboardRdsCdcResponse.js';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup.js';
import { OperationIdFilters } from '../models/OperationIdFilters.js';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest.js';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse.js';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest.js';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse.js';
import { OverrideSensitivityAnnotationsRequest } from '../models/OverrideSensitivityAnnotationsRequest.js';
import { Pagination } from '../models/Pagination.js';
import { ParameterCheckResult } from '../models/ParameterCheckResult.js';
import { ParentIdFilters } from '../models/ParentIdFilters.js';
import { PartialRestoreData } from '../models/PartialRestoreData.js';
import { Path } from '../models/Path.js';
import { PathSegment } from '../models/PathSegment.js';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest.js';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse.js';
import { Permission } from '../models/Permission.js';
import { PermissionGrant } from '../models/PermissionGrant.js';
import { PermissionGrantInput } from '../models/PermissionGrantInput.js';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties.js';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan.js';
import { PitrBackupResourceType } from '../models/PitrBackupResourceType.js';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules.js';
import { PitrIntervalConfig } from '../models/PitrIntervalConfig.js';
import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows.js';
import { PitrRestoreWindow } from '../models/PitrRestoreWindow.js';
import { PitrRestoreWindowsResponse } from '../models/PitrRestoreWindowsResponse.js';
import { Preferences } from '../models/Preferences.js';
import { PrivateLink } from '../models/PrivateLink.js';
import { PrivateLinkCheckResult } from '../models/PrivateLinkCheckResult.js';
import { PrivateLinkFormatInstructions } from '../models/PrivateLinkFormatInstructions.js';
import { PrivateLinkInstructionStep } from '../models/PrivateLinkInstructionStep.js';
import { Project } from '../models/Project.js';
import { ProjectIdFilters } from '../models/ProjectIdFilters.js';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters.js';
import { ProviderCategoryFilters } from '../models/ProviderCategoryFilters.js';
import { ProviderParentIdFilters } from '../models/ProviderParentIdFilters.js';
import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig.js';
import { PulumiConfiguration } from '../models/PulumiConfiguration.js';
import { PulumiConfigurations } from '../models/PulumiConfigurations.js';
import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions.js';
import { PulumiConfigurationsRequest } from '../models/PulumiConfigurationsRequest.js';
import { QueryCostData400Response } from '../models/QueryCostData400Response.js';
import { QueryCostDataRequest } from '../models/QueryCostDataRequest.js';
import { QueryCostDataResponse } from '../models/QueryCostDataResponse.js';
import { QueryDBRequest } from '../models/QueryDBRequest.js';
import { QueryDBResponse } from '../models/QueryDBResponse.js';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination.js';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse.js';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse.js';
import { QuotaStatusFilters } from '../models/QuotaStatusFilters.js';
import { RamShareCheckResult } from '../models/RamShareCheckResult.js';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments.js';
import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig.js';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig.js';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig.js';
import { RdsNativePitrWindow } from '../models/RdsNativePitrWindow.js';
import { RdsPasswordConfig } from '../models/RdsPasswordConfig.js';
import { RdsSecurityGroup } from '../models/RdsSecurityGroup.js';
import { ReactivateAccountRequest } from '../models/ReactivateAccountRequest.js';
import { ReconnectCustomerVaultAccountResponse } from '../models/ReconnectCustomerVaultAccountResponse.js';
import { ReconnectRestoreAccountResponse } from '../models/ReconnectRestoreAccountResponse.js';
import { ReconnectSourceAccountResponse } from '../models/ReconnectSourceAccountResponse.js';
import { ReconnectSourceAwsOrganizationalUnitResponse } from '../models/ReconnectSourceAwsOrganizationalUnitResponse.js';
import { RecordRestoreResult } from '../models/RecordRestoreResult.js';
import { RecoveryPointData } from '../models/RecoveryPointData.js';
import { RedshiftCluster } from '../models/RedshiftCluster.js';
import { RedshiftClusters } from '../models/RedshiftClusters.js';
import { RedshiftIntegrationConfig } from '../models/RedshiftIntegrationConfig.js';
import { RedshiftRestoreDestination } from '../models/RedshiftRestoreDestination.js';
import { RedshiftServerlessNamespace } from '../models/RedshiftServerlessNamespace.js';
import { RedshiftServerlessNamespaces } from '../models/RedshiftServerlessNamespaces.js';
import { RedshiftSnapshotProperties } from '../models/RedshiftSnapshotProperties.js';
import { RegionCondition } from '../models/RegionCondition.js';
import { RegisterInput } from '../models/RegisterInput.js';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken.js';
import { RegisterResponse } from '../models/RegisterResponse.js';
import { RelatedGlobalDbCluster } from '../models/RelatedGlobalDbCluster.js';
import { RequestDetails } from '../models/RequestDetails.js';
import { ResourceDetails } from '../models/ResourceDetails.js';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition.js';
import { ResourceIdCondition } from '../models/ResourceIdCondition.js';
import { ResourceIdFilters } from '../models/ResourceIdFilters.js';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers.js';
import { ResourceNameCondition } from '../models/ResourceNameCondition.js';
import { ResourceNameFilters } from '../models/ResourceNameFilters.js';
import { ResourceProperties } from '../models/ResourceProperties.js';
import { ResourceQuota } from '../models/ResourceQuota.js';
import { ResourceSnapshot } from '../models/ResourceSnapshot.js';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties.js';
import { ResourceTag } from '../models/ResourceTag.js';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition.js';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters.js';
import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup.js';
import { ResourceValidationError } from '../models/ResourceValidationError.js';
import { RestoreAccount } from '../models/RestoreAccount.js';
import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput.js';
import { RestoreAccountCloudAttributes } from '../models/RestoreAccountCloudAttributes.js';
import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig.js';
import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig.js';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions.js';
import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions.js';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput.js';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones.js';
import { RestoreAwsEc2InstanceRequest } from '../models/RestoreAwsEc2InstanceRequest.js';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig.js';
import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest.js';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput.js';
import { RestoreAzurePostgresDatabaseRequest } from '../models/RestoreAzurePostgresDatabaseRequest.js';
import { RestoreAzureSqlDatabaseRequest } from '../models/RestoreAzureSqlDatabaseRequest.js';
import { RestoreAzureSqlVmPitrRequest } from '../models/RestoreAzureSqlVmPitrRequest.js';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig.js';
import { RestoreAzureVmInstanceRequest } from '../models/RestoreAzureVmInstanceRequest.js';
import { RestoreBigQueryDatasetRequest } from '../models/RestoreBigQueryDatasetRequest.js';
import { RestoreBigQueryNativePitrRequest } from '../models/RestoreBigQueryNativePitrRequest.js';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest.js';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest.js';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest.js';
import { RestoreDestinationLimits } from '../models/RestoreDestinationLimits.js';
import { RestoreDocumentDBRequest } from '../models/RestoreDocumentDBRequest.js';
import { RestoreDynamoDBTableRequest } from '../models/RestoreDynamoDBTableRequest.js';
import { RestoreDynamoDBToExistingTableRequest } from '../models/RestoreDynamoDBToExistingTableRequest.js';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig.js';
import { RestoreEFSRequest } from '../models/RestoreEFSRequest.js';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig.js';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig.js';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig.js';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput.js';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput.js';
import { RestoreFSxRequest } from '../models/RestoreFSxRequest.js';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest.js';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig.js';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig.js';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig.js';
import { RestoreGcpCloudSqlRequest } from '../models/RestoreGcpCloudSqlRequest.js';
import { RestoreGcpDiskRequest } from '../models/RestoreGcpDiskRequest.js';
import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput.js';
import { RestoreGcpVmInstanceRequest } from '../models/RestoreGcpVmInstanceRequest.js';
import { RestoreImage201Response } from '../models/RestoreImage201Response.js';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput.js';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput.js';
import { RestoreImageInput } from '../models/RestoreImageInput.js';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput.js';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput.js';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput.js';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput.js';
import { RestoreJob } from '../models/RestoreJob.js';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration.js';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse.js';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters.js';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions.js';
import { RestoreKeyspacesTableRequest } from '../models/RestoreKeyspacesTableRequest.js';
import { RestoreNeptuneRequest } from '../models/RestoreNeptuneRequest.js';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses.js';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig.js';
import { RestoreRdsNativePitrRequest } from '../models/RestoreRdsNativePitrRequest.js';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups.js';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner.js';
import { RestoreRedshiftRequest } from '../models/RestoreRedshiftRequest.js';
import { RestoreResult } from '../models/RestoreResult.js';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups.js';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner.js';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest.js';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest.js';
import { Role } from '../models/Role.js';
import { RoleAccessGroupCondition } from '../models/RoleAccessGroupCondition.js';
import { S3Bucket } from '../models/S3Bucket.js';
import { S3Buckets } from '../models/S3Buckets.js';
import { S3RestoreDestination } from '../models/S3RestoreDestination.js';
import { S3RestoreTarget } from '../models/S3RestoreTarget.js';
import { S3SourceProperties } from '../models/S3SourceProperties.js';
import { SAMLCallback400Response } from '../models/SAMLCallback400Response.js';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response.js';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response.js';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider.js';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse.js';
import { SapHanaInstance } from '../models/SapHanaInstance.js';
import { SapHanaRestoreProperties } from '../models/SapHanaRestoreProperties.js';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest.js';
import { SaveNotebookContentRequest } from '../models/SaveNotebookContentRequest.js';
import { SavedQuery } from '../models/SavedQuery.js';
import { ScanJob } from '../models/ScanJob.js';
import { SchemaRecord } from '../models/SchemaRecord.js';
import { SchemaRegistryAuthConfig } from '../models/SchemaRegistryAuthConfig.js';
import { SchemaRegistryConfig } from '../models/SchemaRegistryConfig.js';
import { SearchDBResponse } from '../models/SearchDBResponse.js';
import { SearchFilesResponse } from '../models/SearchFilesResponse.js';
import { SearchInput } from '../models/SearchInput.js';
import { SearchLogsHistogramInput } from '../models/SearchLogsHistogramInput.js';
import { SearchLogsHistogramResponse } from '../models/SearchLogsHistogramResponse.js';
import { SearchLogsInput } from '../models/SearchLogsInput.js';
import { SearchLogsResponse } from '../models/SearchLogsResponse.js';
import { SearchResources200Response } from '../models/SearchResources200Response.js';
import { SearchResources200ResponseTablesInner } from '../models/SearchResources200ResponseTablesInner.js';
import { SearchResources200ResponseTablesInnerResource } from '../models/SearchResources200ResponseTablesInnerResource.js';
import { SearchResources200ResponseTablesInnerSnapshots } from '../models/SearchResources200ResponseTablesInnerSnapshots.js';
import { SearchResources200ResponseTablesInnerSource } from '../models/SearchResources200ResponseTablesInnerSource.js';
import { SearchResources200ResponseTablesInnerTablesInner } from '../models/SearchResources200ResponseTablesInnerTablesInner.js';
import { SearchResources200ResponseTablesInnerTablesInnerColumnsInner } from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner.js';
import { SearchResourcesRequest } from '../models/SearchResourcesRequest.js';
import { SecurityGroupRule } from '../models/SecurityGroupRule.js';
import { SecurityInformation } from '../models/SecurityInformation.js';
import { SecurityPlan } from '../models/SecurityPlan.js';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse.js';
import { SecurityResourceNotificationArguments } from '../models/SecurityResourceNotificationArguments.js';
import { SecurityScan } from '../models/SecurityScan.js';
import { SecurityScanNotificationData } from '../models/SecurityScanNotificationData.js';
import { SecurityScanResult } from '../models/SecurityScanResult.js';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse.js';
import { SecuritySnapshotNotificationArguments } from '../models/SecuritySnapshotNotificationArguments.js';
import { SecuritySummary } from '../models/SecuritySummary.js';
import { SendA2AMessageRequest } from '../models/SendA2AMessageRequest.js';
import { SendMessageToAI400Response } from '../models/SendMessageToAI400Response.js';
import { SendMessageToAIRequest } from '../models/SendMessageToAIRequest.js';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation.js';
import { SensitivityAnnotationsDetails } from '../models/SensitivityAnnotationsDetails.js';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails.js';
import { Session } from '../models/Session.js';
import { SetupAwsPrivateLinkRequest } from '../models/SetupAwsPrivateLinkRequest.js';
import { SetupAwsPrivateLinkResponse } from '../models/SetupAwsPrivateLinkResponse.js';
import { SetupMongoAtlasPrivateLinkRequest } from '../models/SetupMongoAtlasPrivateLinkRequest.js';
import { SetupMongoAtlasPrivateLinkResponse } from '../models/SetupMongoAtlasPrivateLinkResponse.js';
import { SeverityFilters } from '../models/SeverityFilters.js';
import { Snapshot } from '../models/Snapshot.js';
import { SnapshotAccessDeniedNotificationArguments } from '../models/SnapshotAccessDeniedNotificationArguments.js';
import { SnapshotDateFilters } from '../models/SnapshotDateFilters.js';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions.js';
import { SnapshotFindingCountsResponse } from '../models/SnapshotFindingCountsResponse.js';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters.js';
import { SnapshotLocation } from '../models/SnapshotLocation.js';
import { SnapshotReference } from '../models/SnapshotReference.js';
import { SnapshotStorage } from '../models/SnapshotStorage.js';
import { SnapshotsSummaryResponse } from '../models/SnapshotsSummaryResponse.js';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig.js';
import { SortBackupJobBy } from '../models/SortBackupJobBy.js';
import { SortColumnSpec } from '../models/SortColumnSpec.js';
import { SortLogsBy } from '../models/SortLogsBy.js';
import { SortResourceBy } from '../models/SortResourceBy.js';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy.js';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy.js';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy.js';
import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy.js';
import { SourceAccount } from '../models/SourceAccount.js';
import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput.js';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes.js';
import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig.js';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters.js';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions.js';
import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit.js';
import { SourceRegionFilters } from '../models/SourceRegionFilters.js';
import { SourceSizeCheckResult } from '../models/SourceSizeCheckResult.js';
import { SourceStorage } from '../models/SourceStorage.js';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus.js';
import { SparkEngine } from '../models/SparkEngine.js';
import { SparkJob } from '../models/SparkJob.js';
import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy.js';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams.js';
import { SparkJobStorageConfig } from '../models/SparkJobStorageConfig.js';
import { SqlEngine } from '../models/SqlEngine.js';
import { SqlInstructions } from '../models/SqlInstructions.js';
import { SqlQueryExecution } from '../models/SqlQueryExecution.js';
import { SqlQueryExecutionResult } from '../models/SqlQueryExecutionResult.js';
import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn.js';
import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo.js';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings.js';
import { StackNameFilters } from '../models/StackNameFilters.js';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan.js';
import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig.js';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules.js';
import { StandardIntervalConfig } from '../models/StandardIntervalConfig.js';
import { StartNotebookSessionInput } from '../models/StartNotebookSessionInput.js';
import { StartSparkJobDirectParams } from '../models/StartSparkJobDirectParams.js';
import { StartSparkJobInput } from '../models/StartSparkJobInput.js';
import { StartSparkJobTemplateParams } from '../models/StartSparkJobTemplateParams.js';
import { StartSqlQueryExecutionInput } from '../models/StartSqlQueryExecutionInput.js';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters.js';
import { StatusCodeFilters } from '../models/StatusCodeFilters.js';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination.js';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget.js';
import { StorageConfig } from '../models/StorageConfig.js';
import { StorageGateway } from '../models/StorageGateway.js';
import { StorageGatewayDetails } from '../models/StorageGatewayDetails.js';
import { SubnetConfig } from '../models/SubnetConfig.js';
import { SubnetFilters } from '../models/SubnetFilters.js';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone.js';
import { SubnetsCondition } from '../models/SubnetsCondition.js';
import { SupportedProviders } from '../models/SupportedProviders.js';
import { TableMaintenanceConfig } from '../models/TableMaintenanceConfig.js';
import { TableRecord } from '../models/TableRecord.js';
import { TagKeyValue } from '../models/TagKeyValue.js';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition.js';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters.js';
import { TagKeysCondition } from '../models/TagKeysCondition.js';
import { TagKeysFilters } from '../models/TagKeysFilters.js';
import { TakeNativeSnapshotRequest } from '../models/TakeNativeSnapshotRequest.js';
import { TakeSnapshotRequest } from '../models/TakeSnapshotRequest.js';
import { TakeSnapshotResponse } from '../models/TakeSnapshotResponse.js';
import { TeardownAwsPrivateLinkResponse } from '../models/TeardownAwsPrivateLinkResponse.js';
import { TeardownMongoAtlasPrivateLinkResponse } from '../models/TeardownMongoAtlasPrivateLinkResponse.js';
import { TimeFrame } from '../models/TimeFrame.js';
import { TimeOfDay } from '../models/TimeOfDay.js';
import { TimeOfYear } from '../models/TimeOfYear.js';
import { TokenResponse } from '../models/TokenResponse.js';
import { TotalSourceStorageSizeRequest } from '../models/TotalSourceStorageSizeRequest.js';
import { TotalSourceStorageSizeResponse } from '../models/TotalSourceStorageSizeResponse.js';
import { TriggerKeyspacesScheduledDump200Response } from '../models/TriggerKeyspacesScheduledDump200Response.js';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord.js';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord.js';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord.js';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord.js';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord.js';
import { UpPulumiStacksResponse } from '../models/UpPulumiStacksResponse.js';
import { UpdateAccountCompanyContactsRequest } from '../models/UpdateAccountCompanyContactsRequest.js';
import { UpdateAccountLabelsRequest } from '../models/UpdateAccountLabelsRequest.js';
import { UpdateAccountProfileResponse } from '../models/UpdateAccountProfileResponse.js';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest.js';
import { UpdateAwsRestoreAccountAttributes } from '../models/UpdateAwsRestoreAccountAttributes.js';
import { UpdateAwsSourceAccountAttributes } from '../models/UpdateAwsSourceAccountAttributes.js';
import { UpdateBackupPolicyRequest } from '../models/UpdateBackupPolicyRequest.js';
import { UpdateBackupPolicyResponse } from '../models/UpdateBackupPolicyResponse.js';
import { UpdateBackupZeroEtlPolicyInput } from '../models/UpdateBackupZeroEtlPolicyInput.js';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest.js';
import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup.js';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup.js';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput.js';
import { UpdateCredentialsProfileInput } from '../models/UpdateCredentialsProfileInput.js';
import { UpdateDashboardInput } from '../models/UpdateDashboardInput.js';
import { UpdateDlsgPolicyRequest } from '../models/UpdateDlsgPolicyRequest.js';
import { UpdateDlsgPolicyResponse } from '../models/UpdateDlsgPolicyResponse.js';
import { UpdateGcpRestoreAccountAttributes } from '../models/UpdateGcpRestoreAccountAttributes.js';
import { UpdateGcpSourceAccountAttributes } from '../models/UpdateGcpSourceAccountAttributes.js';
import { UpdateGraphInput } from '../models/UpdateGraphInput.js';
import { UpdateIdpGroupRequest } from '../models/UpdateIdpGroupRequest.js';
import { UpdateIdpGroupResponse } from '../models/UpdateIdpGroupResponse.js';
import { UpdateIngestionPipelineInput } from '../models/UpdateIngestionPipelineInput.js';
import { UpdateIntegrationRequest } from '../models/UpdateIntegrationRequest.js';
import { UpdateIntegrationResponse } from '../models/UpdateIntegrationResponse.js';
import { UpdateJobTemplateInput } from '../models/UpdateJobTemplateInput.js';
import { UpdateMPAPolicyRequest } from '../models/UpdateMPAPolicyRequest.js';
import { UpdateMPAPolicyResponse } from '../models/UpdateMPAPolicyResponse.js';
import { UpdateNotebookInput } from '../models/UpdateNotebookInput.js';
import { UpdatePrivateLinkInput } from '../models/UpdatePrivateLinkInput.js';
import { UpdateProjectConfigurationKeyRequest } from '../models/UpdateProjectConfigurationKeyRequest.js';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest.js';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest.js';
import { UpdateRestoreAccountAttributesInput } from '../models/UpdateRestoreAccountAttributesInput.js';
import { UpdateRestoreAccountConnectivityConfigRequest } from '../models/UpdateRestoreAccountConnectivityConfigRequest.js';
import { UpdateRestoreAccountConnectivityConfigResponse } from '../models/UpdateRestoreAccountConnectivityConfigResponse.js';
import { UpdateRestoreAccountRequest } from '../models/UpdateRestoreAccountRequest.js';
import { UpdateRestoreAccountResponse } from '../models/UpdateRestoreAccountResponse.js';
import { UpdateRoleRequest } from '../models/UpdateRoleRequest.js';
import { UpdateRoleResponse } from '../models/UpdateRoleResponse.js';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput.js';
import { UpdateSavedQueryInput } from '../models/UpdateSavedQueryInput.js';
import { UpdateSessionRequest } from '../models/UpdateSessionRequest.js';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest.js';
import { UpdateSourceAccountAttributesInput } from '../models/UpdateSourceAccountAttributesInput.js';
import { UpdateSourceAccountRequest } from '../models/UpdateSourceAccountRequest.js';
import { UpdateSourceAccountResponse } from '../models/UpdateSourceAccountResponse.js';
import { UpdateTableMaintenanceConfigInput } from '../models/UpdateTableMaintenanceConfigInput.js';
import { UpdateUserInput } from '../models/UpdateUserInput.js';
import { UpdateVaultRequest } from '../models/UpdateVaultRequest.js';
import { UpdateVaultResponse } from '../models/UpdateVaultResponse.js';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest.js';
import { UpdateWorkspaceBucketPolicyInput } from '../models/UpdateWorkspaceBucketPolicyInput.js';
import { UpdateWorkspaceLoggingSettingsInput } from '../models/UpdateWorkspaceLoggingSettingsInput.js';
import { UpdateWorkspaceMetricsSettingsInput } from '../models/UpdateWorkspaceMetricsSettingsInput.js';
import { UpdateZeroEtlPolicyInput } from '../models/UpdateZeroEtlPolicyInput.js';
import { Usage } from '../models/Usage.js';
import { User } from '../models/User.js';
import { UserIdFilters } from '../models/UserIdFilters.js';
import { VNetConfig } from '../models/VNetConfig.js';
import { ValidateResourceConfigurationRequest } from '../models/ValidateResourceConfigurationRequest.js';
import { ValidateResourceConfigurationResponse } from '../models/ValidateResourceConfigurationResponse.js';
import { VaultFilters } from '../models/VaultFilters.js';
import { VaultMetadataReplicationConfig } from '../models/VaultMetadataReplicationConfig.js';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments.js';
import { VaultProviderAttributes } from '../models/VaultProviderAttributes.js';
import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput.js';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount.js';
import { VerifyMongoAtlasPrivateLinkResponse } from '../models/VerifyMongoAtlasPrivateLinkResponse.js';
import { Viewer } from '../models/Viewer.js';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments.js';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination.js';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries.js';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint.js';
import { VisualizationLabel } from '../models/VisualizationLabel.js';
import { VolumeSettings } from '../models/VolumeSettings.js';
import { VpcCondition } from '../models/VpcCondition.js';
import { VpcPeering } from '../models/VpcPeering.js';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters.js';
import { WarmCapacity } from '../models/WarmCapacity.js';
import { WeeklyConfig } from '../models/WeeklyConfig.js';
import { Workspace } from '../models/Workspace.js';
import { WorkspaceBucketPolicy } from '../models/WorkspaceBucketPolicy.js';
import { WorkspaceLoggingSettings } from '../models/WorkspaceLoggingSettings.js';
import { WorkspaceMetricsSettings } from '../models/WorkspaceMetricsSettings.js';
import { WorkspaceNetworkingSettings } from '../models/WorkspaceNetworkingSettings.js';
import { WorkspaceNetworkingSettingsVpcPeering } from '../models/WorkspaceNetworkingSettingsVpcPeering.js';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution.js';
import { ZeroEtlIdentityColumnSpec } from '../models/ZeroEtlIdentityColumnSpec.js';
import { ZeroEtlPolicy } from '../models/ZeroEtlPolicy.js';
import { ZeroEtlResourceSelector } from '../models/ZeroEtlResourceSelector.js';
import { ZeroEtlRoutingPolicy } from '../models/ZeroEtlRoutingPolicy.js';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "AccessConditionEffect",
    "AccountInstallationMethod",
    "AccountState",
    "ActionRequiredType",
    "AgreementWithCreditsTypeEnum",
    "AuditLogAction",
    "AuditLogAuthMethod",
    "AuditLogAuthStatus",
    "AuditLogInitiatorType",
    "AuditLogMfaMethod",
    "AwsEbsVolumeResourceVolumeTypeEnum",
    "AwsEbsVolumeResourceStateEnum",
    "AwsFsxResourceFileSystemTypeEnum",
    "AwsFsxResourceStorageTypeEnum",
    "AwsFsxResourceLifecycleStatusEnum",
    "AwsKeyspacesResourceCdcStatusEnum",
    "AwsKeyspacesResourceCdcViewTypeEnum",
    "AwsRdsEngine",
    "AwsRedshiftResourceClusterTypeEnum",
    "AzureAppRegistrationOptionApplicationTypeEnum",
    "AzureMarketplaceWebhookInputActionEnum",
    "AzureMarketplaceWebhookInputStatusEnum",
    "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
    "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
    "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
    "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
    "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
    "AzureOnboardingStatusStatusEnum",
    "AzureRestorePointDataRestorePointTypeEnum",
    "AzureVaultType",
    "BackupJobSortField",
    "BackupJobType",
    "BackupPolicyType",
    "BackupStatus",
    "BackupZeroEtlIdentityColumnField",
    "BackupZeroEtlRoutingMode",
    "BatchMode",
    "BillingTransactionHistoryTransactionTypeEnum",
    "CloudAccountType",
    "CloudResourceAttachmentEventType",
    "CompactionStrategy",
    "ConditionOperatorEnum",
    "CostDataGroupBy",
    "CostGranularity",
    "CostRecordMetadataType",
    "CostUnit",
    "CreateGraphInputChartTypeEnum",
    "CreateOAuthAppRequestTypeEnum",
    "CreateSqlEngineInputWorkerSizeEnum",
    "DBSnapshotType",
    "DashboardGraphChartTypeEnum",
    "DataCatalogType",
    "DataClass",
    "DataTransferOperationType",
    "DayOfWeek",
    "DetectorSummaryDetectorTypeEnum",
    "DetectorSummaryConclusionEnum",
    "DetectorType",
    "DynamoDbBillingMode",
    "EFSRestoreDestinationRestoreTypeEnum",
    "EFSRestoreDestinationPerformanceModeEnum",
    "EFSRestoreDestinationThroughputModeEnum",
    "EfsSnapshotPropertiesPerformanceModeEnum",
    "EfsSnapshotPropertiesThroughputModeEnum",
    "EksClusterStatus",
    "Environment",
    "EonAccountStatus",
    "EonAccountType",
    "EonSparkVersion",
    "ErrorCode",
    "ErrorPolicy",
    "FileFormat",
    "FindingCountEntryDetectorTypeEnum",
    "FindingEntryObjectTypeEnum",
    "FsxOntapVolumeVolumeTypeEnum",
    "FsxOntapVolumeSecurityStyleEnum",
    "GcpDiskResourceDiskTypeEnum",
    "GcpDiskResourceStatusEnum",
    "GcpNetworkType",
    "GetAdditionalAzureAppsOnboardingStatus200ResponseStatusEnum",
    "GetAwsPrivateLinkStatusResponseStatusEnum",
    "HighFrequencyBackupScheduleFrequency",
    "HighFrequencyIntervalConfigIntervalMinutesEnum",
    "IcebergRestCatalogAuthType",
    "IndexRestoreMode",
    "IngestionPipelineStatus",
    "IngestionSourceType",
    "IntegType",
    "JobStatus",
    "JobStepName",
    "JobStepStatus",
    "KafkaKeyHandling",
    "KafkaMessageFormat",
    "KafkaSaslMechanism",
    "KafkaSecurityProtocol",
    "KafkaStartingOffset",
    "KubeAccessStatus",
    "KubernetesAccessMode",
    "ListOperators",
    "LogSourceTypeEnum",
    "LogSourceWithPolicyTypeEnum",
    "LogicalOperator",
    "MPADecision",
    "MPAListRequestSortField",
    "MPAOperationScope",
    "MPAOperationType",
    "MPARequestStatus",
    "MPAResourceSelectionMode",
    "MPAReviewSubmitDecision",
    "MeteringDimension",
    "MinRetentionRuleFrequencyEnum",
    "NativeStandardBackupPolicyPlanVaultProtectionModeEnum",
    "NativeStandardConfigVaultProtectionModeEnum",
    "NetworkInterfaceConfigModeEnum",
    "NotebookExecutionOutputTypeEnum",
    "NotebookExecutionResultStatusEnum",
    "NotebookSessionStatus",
    "NotificationPolicyTypeEnum",
    "NotificationStatus",
    "NotificationType",
    "OAuthAppTypeEnum",
    "ObjectStoreExclusionRuleStoreTypeEnum",
    "ObjectStoreExclusionRuleMatchTypeEnum",
    "PartialRestoreType",
    "PartitionFormat",
    "PartitionSegmentType",
    "PartitionType",
    "PathType",
    "PermissionCategory",
    "PermissionType",
    "PitrIntervalConfigIntervalMinutesEnum",
    "PrivateLinkCheckResultStatusEnum",
    "PrivateLinkStatus",
    "ProjectConfigurationKeyEnum",
    "Provider",
    "ProviderCategory",
    "QueryDBRestoreDestinationType",
    "QueryDBStatus",
    "QuotaStatus",
    "RdsPasswordConfigPasswordManagementTypeEnum",
    "ResourceSelectorMode",
    "ResourceSortField",
    "ResourceType",
    "RestoreAccountSortField",
    "RestoreJobSortField",
    "RestoreJobType",
    "RestoreMethod",
    "RestoreMethodAvailabilityReason",
    "RoleInstallationMethod",
    "ScalarOperators",
    "ScanJobType",
    "ScheduleMode",
    "ScheduleType",
    "SchemaEvolutionMode",
    "SchemaRegistryAuthType",
    "SecurityAssignmentStatus",
    "SecurityGroupRuleProtocol",
    "SecurityScanConclusionEnum",
    "SecurityScanDetectorTypeEnum",
    "SecurityScanReviewerTypeEnum",
    "SecurityScanConclusion",
    "SecurityScanExclusionPathType",
    "SecurityScanNotificationDataDetectorTypeEnum",
    "SecurityScanNotificationDataConclusionEnum",
    "SecurityScanResultEvidenceTypeEnum",
    "SecurityScanResultTypeEnum",
    "SegmentType",
    "SendA2AMessageRequestJsonrpcEnum",
    "SendA2AMessageRequestMethodEnum",
    "Severity",
    "SnapshotLocationSnapshotTypeEnum",
    "SnapshotSortField",
    "SnapshotStatus",
    "SortColumnSpecDirectionEnum",
    "SortLogsByFieldEnum",
    "SortOrder",
    "SourceAccountSortField",
    "SparkEngineStatus",
    "SparkJobStatus",
    "SqlEngineStatus",
    "SqlQueryExecutionStatus",
    "StandardBackupScheduleFrequency",
    "StandardIntervalConfigIntervalHoursEnum",
    "StorageGatewayStatus",
    "SubjectNamingStrategy",
    "SubnetConfigModeEnum",
    "TakeNativeSnapshotRequestVaultProtectionModeEnum",
    "UpdateGraphInputChartTypeEnum",
    "UsageUnit",
    "VNetConfigModeEnum",
    "VaultStatus",
    "VpcPeeringStatus",
    "WorkspaceStatus",
    "ZeroEtlIdentityColumnField",
    "ZeroEtlRoutingMode",
]);
let typeMap = {
    "AccessCondition": AccessCondition,
    "AccessConditionalExpression": AccessConditionalExpression,
    "Account": Account,
    "AccountConfigInput": AccountConfigInput,
    "AccountIdCondition": AccountIdCondition,
    "AccountIdFilters": AccountIdFilters,
    "AccountMetricsDestination": AccountMetricsDestination,
    "AccountNameFilters": AccountNameFilters,
    "AccountStatusFilters": AccountStatusFilters,
    "AccountUpdateInput": AccountUpdateInput,
    "AccountVersion": AccountVersion,
    "ActionFilters": ActionFilters,
    "ActionRequiredDetails": ActionRequiredDetails,
    "ActivateAtlasOrganizationResponse": ActivateAtlasOrganizationResponse,
    "ActivateGcpFolderResponse": ActivateGcpFolderResponse,
    "ActivateGcpOrganizationResponse": ActivateGcpOrganizationResponse,
    "AddRestoreAtlasPrivateLinkRequest": AddRestoreAtlasPrivateLinkRequest,
    "AgreementWithCredits": AgreementWithCredits,
    "Ami": Ami,
    "AmiBlockDevice": AmiBlockDevice,
    "AnalyzeSqlQueryRequest": AnalyzeSqlQueryRequest,
    "AnnuallyConfig": AnnuallyConfig,
    "AnomalyDataPoint": AnomalyDataPoint,
    "AnomalyGraphData": AnomalyGraphData,
    "ApiCredentials": ApiCredentials,
    "ApiCredentialsProperties": ApiCredentialsProperties,
    "App": App,
    "AppFilters": AppFilters,
    "ApplicationOverride": ApplicationOverride,
    "AppsCondition": AppsCondition,
    "AppsDetails": AppsDetails,
    "AtlasCluster": AtlasCluster,
    "AtlasClusters": AtlasClusters,
    "AtlasOrganization": AtlasOrganization,
    "AtlasProject": AtlasProject,
    "AtlasProjects": AtlasProjects,
    "AuditLog": AuditLog,
    "AuditLogEntitiesInner": AuditLogEntitiesInner,
    "AuditLogExtendedData": AuditLogExtendedData,
    "AuditLogExtendedDataAuth": AuditLogExtendedDataAuth,
    "AuditLogFilterConditions": AuditLogFilterConditions,
    "AuthResponse": AuthResponse,
    "AwsAccountConfigInput": AwsAccountConfigInput,
    "AwsAccountMetricsDestination": AwsAccountMetricsDestination,
    "AwsCredentialProfile": AwsCredentialProfile,
    "AwsCredentialProfileInput": AwsCredentialProfileInput,
    "AwsDatabaseDestination": AwsDatabaseDestination,
    "AwsDynamoDBDestination": AwsDynamoDBDestination,
    "AwsDynamoDbResource": AwsDynamoDbResource,
    "AwsDynamoDbSnapshotProperties": AwsDynamoDbSnapshotProperties,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput,
    "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner,
    "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection,
    "AwsEbsSnapshotConvertResult": AwsEbsSnapshotConvertResult,
    "AwsEbsVolumeResource": AwsEbsVolumeResource,
    "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
    "AwsEbsVolumeRestoreResult": AwsEbsVolumeRestoreResult,
    "AwsEbsVolumeSnapshotProperties": AwsEbsVolumeSnapshotProperties,
    "AwsEc2AmiConvertResult": AwsEc2AmiConvertResult,
    "AwsEc2InstanceRestoreDestination": AwsEc2InstanceRestoreDestination,
    "AwsEc2InstanceRestoreResult": AwsEc2InstanceRestoreResult,
    "AwsEc2InstanceRestoreTarget": AwsEc2InstanceRestoreTarget,
    "AwsEc2Resource": AwsEc2Resource,
    "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
    "AwsEksNamespaceResource": AwsEksNamespaceResource,
    "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
    "AwsFsxResource": AwsFsxResource,
    "AwsKeyspacesDestination": AwsKeyspacesDestination,
    "AwsKeyspacesResource": AwsKeyspacesResource,
    "AwsNativePitrBackupPolicyPlan": AwsNativePitrBackupPolicyPlan,
    "AwsNativePitrBackupResourceType": AwsNativePitrBackupResourceType,
    "AwsNativePitrConfig": AwsNativePitrConfig,
    "AwsNeptuneResource": AwsNeptuneResource,
    "AwsRdsResource": AwsRdsResource,
    "AwsRdsResourceAurora": AwsRdsResourceAurora,
    "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
    "AwsRedshiftResource": AwsRedshiftResource,
    "AwsRestoreAccountAttributes": AwsRestoreAccountAttributes,
    "AwsRestoreAccountAttributesInput": AwsRestoreAccountAttributesInput,
    "AwsRestoreAccountConnectivityConfig": AwsRestoreAccountConnectivityConfig,
    "AwsSourceAccountAttributes": AwsSourceAccountAttributes,
    "AwsSourceAccountAttributesInput": AwsSourceAccountAttributesInput,
    "AwsVaultConfig": AwsVaultConfig,
    "AwsVaultConfigInput": AwsVaultConfigInput,
    "AwsVpcConnectivityConfig": AwsVpcConnectivityConfig,
    "AzureAccountConfigInput": AzureAccountConfigInput,
    "AzureAksNamespaceResource": AzureAksNamespaceResource,
    "AzureAppRegistrationOption": AzureAppRegistrationOption,
    "AzureBackupApplicationsResponse": AzureBackupApplicationsResponse,
    "AzureCmkEligibleApp": AzureCmkEligibleApp,
    "AzureConsentUrlResponse": AzureConsentUrlResponse,
    "AzureDisk": AzureDisk,
    "AzureDiskRestoreData": AzureDiskRestoreData,
    "AzureDiskRestoreDestination": AzureDiskRestoreDestination,
    "AzureDiskRestoreResult": AzureDiskRestoreResult,
    "AzureDiskSettings": AzureDiskSettings,
    "AzureDiskTarget": AzureDiskTarget,
    "AzureEonApplication": AzureEonApplication,
    "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
    "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
    "AzureManagementGroup": AzureManagementGroup,
    "AzureManagementGroups": AzureManagementGroups,
    "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
    "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
    "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
    "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
    "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
    "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
    "AzureOnboardedTenantsResponse": AzureOnboardedTenantsResponse,
    "AzureOnboardingStatus": AzureOnboardingStatus,
    "AzurePostgresDatabaseRestoreDestination": AzurePostgresDatabaseRestoreDestination,
    "AzurePostgresDatabaseRestoreTarget": AzurePostgresDatabaseRestoreTarget,
    "AzureResourceGroup": AzureResourceGroup,
    "AzureResourceGroups": AzureResourceGroups,
    "AzureRestoreAccountAttributes": AzureRestoreAccountAttributes,
    "AzureRestoreAccountAttributesInput": AzureRestoreAccountAttributesInput,
    "AzureRestoreAccountConnectivityConfig": AzureRestoreAccountConnectivityConfig,
    "AzureRestorePointData": AzureRestorePointData,
    "AzureRestorePointSpec": AzureRestorePointSpec,
    "AzureSapHanaResource": AzureSapHanaResource,
    "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
    "AzureSourceAccountAttributes": AzureSourceAccountAttributes,
    "AzureSourceAccountAttributesInput": AzureSourceAccountAttributesInput,
    "AzureSqlDatabaseRestoreDestination": AzureSqlDatabaseRestoreDestination,
    "AzureSqlDatabaseRestoreTarget": AzureSqlDatabaseRestoreTarget,
    "AzureStorageAccount": AzureStorageAccount,
    "AzureStorageAccounts": AzureStorageAccounts,
    "AzureSubscription": AzureSubscription,
    "AzureTenant": AzureTenant,
    "AzureVaultConfig": AzureVaultConfig,
    "AzureVaultConfigInput": AzureVaultConfigInput,
    "AzureVmInstanceRestoreDestination": AzureVmInstanceRestoreDestination,
    "AzureVmInstanceRestoreResult": AzureVmInstanceRestoreResult,
    "AzureVmInstanceRestoreTarget": AzureVmInstanceRestoreTarget,
    "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
    "AzureVnetConnectivityConfig": AzureVnetConnectivityConfig,
    "BackedUpByResourceType": BackedUpByResourceType,
    "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
    "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
    "BackupControlViolations": BackupControlViolations,
    "BackupJob": BackupJob,
    "BackupJobResponse": BackupJobResponse,
    "BackupJobTypeFilters": BackupJobTypeFilters,
    "BackupJobsFilterConditions": BackupJobsFilterConditions,
    "BackupPoliciesFilters": BackupPoliciesFilters,
    "BackupPoliciesLimits": BackupPoliciesLimits,
    "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
    "BackupPolicy": BackupPolicy,
    "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
    "BackupPolicyConfig": BackupPolicyConfig,
    "BackupPolicyExpression": BackupPolicyExpression,
    "BackupPolicyGroupCondition": BackupPolicyGroupCondition,
    "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
    "BackupPolicyPlan": BackupPolicyPlan,
    "BackupPolicyResourceSelector": BackupPolicyResourceSelector,
    "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
    "BackupRegionsFilters": BackupRegionsFilters,
    "BackupSchedule": BackupSchedule,
    "BackupScope": BackupScope,
    "BackupScopeSummary": BackupScopeSummary,
    "BackupStatusFilters": BackupStatusFilters,
    "BackupVault": BackupVault,
    "BackupZeroEtlAccessConfiguration": BackupZeroEtlAccessConfiguration,
    "BackupZeroEtlAwsAccessConfiguration": BackupZeroEtlAwsAccessConfiguration,
    "BackupZeroEtlAwsGlueCatalogConfiguration": BackupZeroEtlAwsGlueCatalogConfiguration,
    "BackupZeroEtlCatalogConfiguration": BackupZeroEtlCatalogConfiguration,
    "BackupZeroEtlIdentityColumnSpec": BackupZeroEtlIdentityColumnSpec,
    "BackupZeroEtlPolicy": BackupZeroEtlPolicy,
    "BackupZeroEtlResourceSelector": BackupZeroEtlResourceSelector,
    "BackupZeroEtlRoutingPolicy": BackupZeroEtlRoutingPolicy,
    "BackupZeroEtlStorageConfiguration": BackupZeroEtlStorageConfiguration,
    "BatchApplicationOverrides": BatchApplicationOverrides,
    "BatchOperationResponse": BatchOperationResponse,
    "BatchResourceValidationResult": BatchResourceValidationResult,
    "BatchUpdateLlgPoliciesRequest": BatchUpdateLlgPoliciesRequest,
    "BatchUpdateLlgPolicyItem": BatchUpdateLlgPolicyItem,
    "BatchValidateResourceConfigurationRequest": BatchValidateResourceConfigurationRequest,
    "BatchValidateResourceConfigurationResponse": BatchValidateResourceConfigurationResponse,
    "BigQueryDatasetDestination": BigQueryDatasetDestination,
    "BigQueryIntegrationConfig": BigQueryIntegrationConfig,
    "BigQueryNativePitrBackupPolicyPlan": BigQueryNativePitrBackupPolicyPlan,
    "BigQueryNativePitrBackupResourceType": BigQueryNativePitrBackupResourceType,
    "BigQueryNativePitrConfig": BigQueryNativePitrConfig,
    "BigQueryNativePitrDestination": BigQueryNativePitrDestination,
    "BiglakeCatalogProperties": BiglakeCatalogProperties,
    "BillingPeriod": BillingPeriod,
    "BillingTransactionHistory": BillingTransactionHistory,
    "BooleanFilters": BooleanFilters,
    "BucketPathPartitionSpec": BucketPathPartitionSpec,
    "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
    "CancelMyMPARequestResponse": CancelMyMPARequestResponse,
    "CatalogAccessRequest": CatalogAccessRequest,
    "CatalogAccessResponse": CatalogAccessResponse,
    "CdcBackupModeCheckResult": CdcBackupModeCheckResult,
    "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
    "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
    "CheckCdcPrerequisitesResponse": CheckCdcPrerequisitesResponse,
    "Classifications": Classifications,
    "CloudAccountIdFilters": CloudAccountIdFilters,
    "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
    "CloudProviderCondition": CloudProviderCondition,
    "CloudProviderFilters": CloudProviderFilters,
    "CloudRegion": CloudRegion,
    "CloudResourceAttachmentEvent": CloudResourceAttachmentEvent,
    "CloudResourceConfiguration": CloudResourceConfiguration,
    "CloudResourceConfigurationCdcBackup": CloudResourceConfigurationCdcBackup,
    "CloudResourceConfigurationInventoryBackup": CloudResourceConfigurationInventoryBackup,
    "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
    "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
    "ClusterNameFilters": ClusterNameFilters,
    "ColumnMetadata": ColumnMetadata,
    "CompanyContact": CompanyContact,
    "Condition": Condition,
    "ConnectAtlasOrganizationRequest": ConnectAtlasOrganizationRequest,
    "ConnectAtlasOrganizationResponse": ConnectAtlasOrganizationResponse,
    "ConnectAzureBackupAccountRequest": ConnectAzureBackupAccountRequest,
    "ConnectAzureBackupApplicationsRequest": ConnectAzureBackupApplicationsRequest,
    "ConnectAzureRestoreAccountRequest": ConnectAzureRestoreAccountRequest,
    "ConnectAzureSourceAccountRequest": ConnectAzureSourceAccountRequest,
    "ConnectAzureVaultAccountRequest": ConnectAzureVaultAccountRequest,
    "ConnectBYOApps200Response": ConnectBYOApps200Response,
    "ConnectBYOAppsRequest": ConnectBYOAppsRequest,
    "ConnectBYOAzureBackupApplicationsRequest": ConnectBYOAzureBackupApplicationsRequest,
    "ConnectCustomerVaultAccountRequest": ConnectCustomerVaultAccountRequest,
    "ConnectCustomerVaultAccountResponse": ConnectCustomerVaultAccountResponse,
    "ConnectGcpFolderRequest": ConnectGcpFolderRequest,
    "ConnectGcpFolderResponse": ConnectGcpFolderResponse,
    "ConnectGcpOrganizationRequest": ConnectGcpOrganizationRequest,
    "ConnectGcpOrganizationResponse": ConnectGcpOrganizationResponse,
    "ConnectRestoreAccountRequest": ConnectRestoreAccountRequest,
    "ConnectRestoreAccountResponse": ConnectRestoreAccountResponse,
    "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
    "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
    "ConnectSourceAwsOrganizationalUnitRequest": ConnectSourceAwsOrganizationalUnitRequest,
    "ConnectSourceAwsOrganizationalUnitResponse": ConnectSourceAwsOrganizationalUnitResponse,
    "Control": Control,
    "ControlPlaneConfig": ControlPlaneConfig,
    "ControlRules": ControlRules,
    "ControlViolation": ControlViolation,
    "ControlViolations": ControlViolations,
    "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
    "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
    "ControlsFilters": ControlsFilters,
    "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
    "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
    "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
    "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
    "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
    "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
    "Cost": Cost,
    "CostDataFilters": CostDataFilters,
    "CostDataRecord": CostDataRecord,
    "CostDataRecordCost": CostDataRecordCost,
    "CostDataRecordDimensions": CostDataRecordDimensions,
    "CostRecordMetadata": CostRecordMetadata,
    "CostRecordMetadataDataTransfer": CostRecordMetadataDataTransfer,
    "CreateAccountInput": CreateAccountInput,
    "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
    "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
    "CreateBackupPolicyRequest": CreateBackupPolicyRequest,
    "CreateBackupPolicyResponse": CreateBackupPolicyResponse,
    "CreateBackupZeroEtlPolicyInput": CreateBackupZeroEtlPolicyInput,
    "CreateCredentialsProfileInput": CreateCredentialsProfileInput,
    "CreateCredentialsProfileInputAwsCredentialProfile": CreateCredentialsProfileInputAwsCredentialProfile,
    "CreateDashboardInput": CreateDashboardInput,
    "CreateDataCatalogInput": CreateDataCatalogInput,
    "CreateDlsgPolicyRequest": CreateDlsgPolicyRequest,
    "CreateDlsgPolicyResponse": CreateDlsgPolicyResponse,
    "CreateFabricTableShortcutDemoRequest": CreateFabricTableShortcutDemoRequest,
    "CreateFabricTableShortcutDemoRequestShortcutsInner": CreateFabricTableShortcutDemoRequestShortcutsInner,
    "CreateFabricTableShortcutDemoResponse": CreateFabricTableShortcutDemoResponse,
    "CreateFabricTableShortcutDemoResponseResultsInner": CreateFabricTableShortcutDemoResponseResultsInner,
    "CreateGraphInput": CreateGraphInput,
    "CreateIdpGroupRequest": CreateIdpGroupRequest,
    "CreateIdpGroupResponse": CreateIdpGroupResponse,
    "CreateInfectedExcludePathInput": CreateInfectedExcludePathInput,
    "CreateIngestionPipelineInput": CreateIngestionPipelineInput,
    "CreateIntegrationRequest": CreateIntegrationRequest,
    "CreateIntegrationResponse": CreateIntegrationResponse,
    "CreateJobTemplateInput": CreateJobTemplateInput,
    "CreateMPAPolicyRequest": CreateMPAPolicyRequest,
    "CreateMPAPolicyResponse": CreateMPAPolicyResponse,
    "CreateMPARequestReviewRequest": CreateMPARequestReviewRequest,
    "CreateMPARequestReviewResponse": CreateMPARequestReviewResponse,
    "CreateNotebookInput": CreateNotebookInput,
    "CreateOAuthAppRequest": CreateOAuthAppRequest,
    "CreateOAuthAppResponse": CreateOAuthAppResponse,
    "CreatePolicyInput": CreatePolicyInput,
    "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
    "CreatePrivateLinkInput": CreatePrivateLinkInput,
    "CreateProjectInput": CreateProjectInput,
    "CreatePulumiConfigurationRequest": CreatePulumiConfigurationRequest,
    "CreateRoleRequest": CreateRoleRequest,
    "CreateRoleResponse": CreateRoleResponse,
    "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
    "CreateSavedQueryInput": CreateSavedQueryInput,
    "CreateScanJobInput": CreateScanJobInput,
    "CreateScanJobResponse": CreateScanJobResponse,
    "CreateSessionRequest": CreateSessionRequest,
    "CreateSparkEngineInput": CreateSparkEngineInput,
    "CreateSqlEngineInput": CreateSqlEngineInput,
    "CreateUserInput": CreateUserInput,
    "CreateVaultRequest": CreateVaultRequest,
    "CreateVaultResponse": CreateVaultResponse,
    "CreateVpcPeeringInput": CreateVpcPeeringInput,
    "CreateZeroEtlPolicyInput": CreateZeroEtlPolicyInput,
    "CredentialFinding": CredentialFinding,
    "CredentialsProfile": CredentialsProfile,
    "CredentialsProfileAwsCredentialProfile": CredentialsProfileAwsCredentialProfile,
    "CreditsMonthlyUsageNotificationArguments": CreditsMonthlyUsageNotificationArguments,
    "CreditsNotificationArguments": CreditsNotificationArguments,
    "CrossResourceQueryRequest": CrossResourceQueryRequest,
    "CrossResourceQueryRequestResourcesInner": CrossResourceQueryRequestResourcesInner,
    "CustomTagsInner": CustomTagsInner,
    "CustomerVaultAccount": CustomerVaultAccount,
    "DBResourceMetadata": DBResourceMetadata,
    "DBServerRecord": DBServerRecord,
    "DBSnapshotMetadata": DBSnapshotMetadata,
    "DailyConfig": DailyConfig,
    "DailySnapshotData": DailySnapshotData,
    "DailyStorageSummaries": DailyStorageSummaries,
    "DailyStorageSummary": DailyStorageSummary,
    "Dashboard": Dashboard,
    "DashboardGraph": DashboardGraph,
    "DashboardGraphLayout": DashboardGraphLayout,
    "DashboardWithGraphs": DashboardWithGraphs,
    "DataCatalog": DataCatalog,
    "DataCatalogBiglakeProperties": DataCatalogBiglakeProperties,
    "DataCatalogGlueProperties": DataCatalogGlueProperties,
    "DataCatalogIcebergRestProperties": DataCatalogIcebergRestProperties,
    "DataClassesCondition": DataClassesCondition,
    "DataClassesDetails": DataClassesDetails,
    "DataClassesFilters": DataClassesFilters,
    "DataClassificationEntity": DataClassificationEntity,
    "DataShareIntegrationConfig": DataShareIntegrationConfig,
    "DatabaseDestination": DatabaseDestination,
    "DatabaseRecord": DatabaseRecord,
    "DatabricksIntegrationConfig": DatabricksIntegrationConfig,
    "DeactivateAccountRequest": DeactivateAccountRequest,
    "DeactivateAccountResponse": DeactivateAccountResponse,
    "DeactivateAtlasOrganizationResponse": DeactivateAtlasOrganizationResponse,
    "DeactivateGcpFolderResponse": DeactivateGcpFolderResponse,
    "DeactivateGcpOrganizationResponse": DeactivateGcpOrganizationResponse,
    "DestinationDetails": DestinationDetails,
    "DestinationProviderAttributes": DestinationProviderAttributes,
    "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
    "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
    "DetectorSummary": DetectorSummary,
    "DisableResourceOverrideLimitsResponse": DisableResourceOverrideLimitsResponse,
    "DisconnectCustomerVaultAccountResponse": DisconnectCustomerVaultAccountResponse,
    "DisconnectRestoreAccountResponse": DisconnectRestoreAccountResponse,
    "DisconnectSourceAccountResponse": DisconnectSourceAccountResponse,
    "DisconnectSourceAwsOrganizationalUnitResponse": DisconnectSourceAwsOrganizationalUnitResponse,
    "DiscoveryInvokeParams": DiscoveryInvokeParams,
    "DiscoveryJob": DiscoveryJob,
    "DiscoveryStatusResponse": DiscoveryStatusResponse,
    "DlsgPolicy": DlsgPolicy,
    "DlsgPolicyConfig": DlsgPolicyConfig,
    "DlsgPolicyFilters": DlsgPolicyFilters,
    "DlsgPolicyPlan": DlsgPolicyPlan,
    "DlsgSettings": DlsgSettings,
    "DocumentDBRestoreDestination": DocumentDBRestoreDestination,
    "DocumentDbClusterParameterGroup": DocumentDbClusterParameterGroup,
    "DocumentDbClusterParameterGroups": DocumentDbClusterParameterGroups,
    "DocumentDbSnapshotProperties": DocumentDbSnapshotProperties,
    "DriftProtectionPolicy": DriftProtectionPolicy,
    "DriftProtectionSummary": DriftProtectionSummary,
    "DriftProtectionTimePoint": DriftProtectionTimePoint,
    "DynamoDBAdvancedIndexConfig": DynamoDBAdvancedIndexConfig,
    "DynamoDBRestoreMethodAvailabilityRequest": DynamoDBRestoreMethodAvailabilityRequest,
    "DynamoDBRestoreMethodAvailabilityResponse": DynamoDBRestoreMethodAvailabilityResponse,
    "DynamoDbBackupConfig": DynamoDbBackupConfig,
    "DynamoDbBackupConfigApplication": DynamoDbBackupConfigApplication,
    "DynamodbTableRestoreDestination": DynamodbTableRestoreDestination,
    "EFSRestoreDestination": EFSRestoreDestination,
    "EbsRestoreDestination": EbsRestoreDestination,
    "EbsSnapshotRestoreDestination": EbsSnapshotRestoreDestination,
    "EbsSnapshotTarget": EbsSnapshotTarget,
    "EbsTarget": EbsTarget,
    "EfsSnapshotProperties": EfsSnapshotProperties,
    "EksCluster": EksCluster,
    "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
    "EksNamespaceRestoreResult": EksNamespaceRestoreResult,
    "EksVolumeRestoreResult": EksVolumeRestoreResult,
    "EmrIntegrationConfig": EmrIntegrationConfig,
    "EnableFromLimitExceededResponse": EnableFromLimitExceededResponse,
    "EnableResourceOverrideLimitsResponse": EnableResourceOverrideLimitsResponse,
    "EnableRestoreAccountMetricsConfigRequest": EnableRestoreAccountMetricsConfigRequest,
    "EnableRestoreAccountMetricsConfigResponse": EnableRestoreAccountMetricsConfigResponse,
    "EnableSourceAccountMetricsConfigRequest": EnableSourceAccountMetricsConfigRequest,
    "EnableSourceAccountMetricsConfigResponse": EnableSourceAccountMetricsConfigResponse,
    "EncryptionKey": EncryptionKey,
    "EncryptionKeys": EncryptionKeys,
    "EndTimeDateFilters": EndTimeDateFilters,
    "EnvironmentCondition": EnvironmentCondition,
    "EnvironmentDetails": EnvironmentDetails,
    "EnvironmentFilters": EnvironmentFilters,
    "EonAccount": EonAccount,
    "EonAccountIdFilters": EonAccountIdFilters,
    "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
    "ExecuteNotebookCodeInput": ExecuteNotebookCodeInput,
    "ExportAccessDeniedItemsRequest": ExportAccessDeniedItemsRequest,
    "ExportCostData400Response": ExportCostData400Response,
    "ExportCostDataRequest": ExportCostDataRequest,
    "FSxRestoreDestination": FSxRestoreDestination,
    "FSxRestoreDestinationOntapRestoreOptions": FSxRestoreDestinationOntapRestoreOptions,
    "FeatureFlagOverrideGet200Response": FeatureFlagOverrideGet200Response,
    "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
    "FileExplorerResponse": FileExplorerResponse,
    "FilePath": FilePath,
    "FileRestoreData": FileRestoreData,
    "FileSearchRecord": FileSearchRecord,
    "FileSnapshot": FileSnapshot,
    "FindingCountEntry": FindingCountEntry,
    "FindingEntry": FindingEntry,
    "ForceDeleteSnapshotsRequest": ForceDeleteSnapshotsRequest,
    "FreeTextFilters": FreeTextFilters,
    "FsxOntapVolume": FsxOntapVolume,
    "FsxSnapshotProperties": FsxSnapshotProperties,
    "FsxVolumeBackupInfo": FsxVolumeBackupInfo,
    "GCSBucket": GCSBucket,
    "GCSBuckets": GCSBuckets,
    "GCSRestoreDestination": GCSRestoreDestination,
    "GCSRestoreTarget": GCSRestoreTarget,
    "GcpAccountConfigInput": GcpAccountConfigInput,
    "GcpBigQueryResource": GcpBigQueryResource,
    "GcpBigQueryResourceMaterializedViewsInner": GcpBigQueryResourceMaterializedViewsInner,
    "GcpBigQueryResourceRoutinesInner": GcpBigQueryResourceRoutinesInner,
    "GcpBigQueryResourceTablesInner": GcpBigQueryResourceTablesInner,
    "GcpBigQueryResourceViewsInner": GcpBigQueryResourceViewsInner,
    "GcpCloudSqlResource": GcpCloudSqlResource,
    "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
    "GcpCloudSqlRestoreDestination": GcpCloudSqlRestoreDestination,
    "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
    "GcpCloudSqlTarget": GcpCloudSqlTarget,
    "GcpDiskResource": GcpDiskResource,
    "GcpDiskRestoreData": GcpDiskRestoreData,
    "GcpDiskRestoreDestination": GcpDiskRestoreDestination,
    "GcpDiskSettings": GcpDiskSettings,
    "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
    "GcpDiskTarget": GcpDiskTarget,
    "GcpDiskTypesResponse": GcpDiskTypesResponse,
    "GcpEncryptionKey": GcpEncryptionKey,
    "GcpEncryptionKeys": GcpEncryptionKeys,
    "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
    "GcpMachineTypesResponse": GcpMachineTypesResponse,
    "GcpNetworkConnectivityConfig": GcpNetworkConnectivityConfig,
    "GcpOrganization": GcpOrganization,
    "GcpRestoreAccountAttributes": GcpRestoreAccountAttributes,
    "GcpRestoreAccountAttributesInput": GcpRestoreAccountAttributesInput,
    "GcpRestoreAccountConnectivityConfig": GcpRestoreAccountConnectivityConfig,
    "GcpSapHanaResource": GcpSapHanaResource,
    "GcpSourceAccountAttributes": GcpSourceAccountAttributes,
    "GcpSourceAccountAttributesInput": GcpSourceAccountAttributesInput,
    "GcpSubnet": GcpSubnet,
    "GcpSubnetPerRegion": GcpSubnetPerRegion,
    "GcpVaultConfig": GcpVaultConfig,
    "GcpVaultConfigInput": GcpVaultConfigInput,
    "GcpVmInstanceRestoreDestination": GcpVmInstanceRestoreDestination,
    "GcpVmInstanceRestoreResult": GcpVmInstanceRestoreResult,
    "GcpVmInstanceRestoreTarget": GcpVmInstanceRestoreTarget,
    "GcpVmResource": GcpVmResource,
    "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
    "GcsSourceProperties": GcsSourceProperties,
    "GenericSnapshotData": GenericSnapshotData,
    "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
    "GetAdditionalAzureAppsOnboardingStatus200Response": GetAdditionalAzureAppsOnboardingStatus200Response,
    "GetAgreementsResponse": GetAgreementsResponse,
    "GetAwsPrivateLinkStatusResponse": GetAwsPrivateLinkStatusResponse,
    "GetBackupJobResponse": GetBackupJobResponse,
    "GetBackupPolicyResponse": GetBackupPolicyResponse,
    "GetBillingPeriodsResponse": GetBillingPeriodsResponse,
    "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
    "GetCredits400Response": GetCredits400Response,
    "GetCreditsResponse": GetCreditsResponse,
    "GetDlsgPolicyResponse": GetDlsgPolicyResponse,
    "GetGcsServiceAgentResponse": GetGcsServiceAgentResponse,
    "GetIdpGroupResponse": GetIdpGroupResponse,
    "GetIntegrationResponse": GetIntegrationResponse,
    "GetLimitsResponseValue": GetLimitsResponseValue,
    "GetMPAPolicyResponse": GetMPAPolicyResponse,
    "GetMPARequestResponse": GetMPARequestResponse,
    "GetNotebookContent200Response": GetNotebookContent200Response,
    "GetProjectConfigurationKeyResponse": GetProjectConfigurationKeyResponse,
    "GetProjectConfigurationKeysResponse": GetProjectConfigurationKeysResponse,
    "GetResourceResponse": GetResourceResponse,
    "GetRestoreAccountConnectivityConfigResponse": GetRestoreAccountConnectivityConfigResponse,
    "GetRestoreAccountMetricsConfigResponse": GetRestoreAccountMetricsConfigResponse,
    "GetRestoreJobResponse": GetRestoreJobResponse,
    "GetRoleResponse": GetRoleResponse,
    "GetScanJobResponse": GetScanJobResponse,
    "GetSnapshotResponse": GetSnapshotResponse,
    "GetSourceAccountMetricsConfigResponse": GetSourceAccountMetricsConfigResponse,
    "GetSourceAccountResponse": GetSourceAccountResponse,
    "GetSqlVmNetworkInfoRequest": GetSqlVmNetworkInfoRequest,
    "GetSqlVmNetworkInfoResponse": GetSqlVmNetworkInfoResponse,
    "GetVaultResponse": GetVaultResponse,
    "GlobalClusterIdentifierCondition": GlobalClusterIdentifierCondition,
    "GlueCatalogProperties": GlueCatalogProperties,
    "GoogleWorkspaceConnectionInfo": GoogleWorkspaceConnectionInfo,
    "GoogleWorkspaceServiceAccountInfo": GoogleWorkspaceServiceAccountInfo,
    "GoogleWorkspaceSourceAccountAttributes": GoogleWorkspaceSourceAccountAttributes,
    "GoogleWorkspaceSourceAccountAttributesInput": GoogleWorkspaceSourceAccountAttributesInput,
    "HighFrequencyBackupPolicyPlan": HighFrequencyBackupPolicyPlan,
    "HighFrequencyBackupResourceType": HighFrequencyBackupResourceType,
    "HighFrequencyBackupScheduleConfig": HighFrequencyBackupScheduleConfig,
    "HighFrequencyBackupSchedules": HighFrequencyBackupSchedules,
    "HighFrequencyIntervalConfig": HighFrequencyIntervalConfig,
    "IDs": IDs,
    "IcebergRestCatalogProperties": IcebergRestCatalogProperties,
    "IdFilters": IdFilters,
    "Identifier": Identifier,
    "IdentityProvidersNames": IdentityProvidersNames,
    "Idp": Idp,
    "IdpGroup": IdpGroup,
    "ImportDlsgCertificateRequest": ImportDlsgCertificateRequest,
    "InfectedDataByClassification": InfectedDataByClassification,
    "InfectedDataClassificationSize": InfectedDataClassificationSize,
    "InfectedDataOverTime": InfectedDataOverTime,
    "InfectedDateSize": InfectedDateSize,
    "InfectedExcludePath": InfectedExcludePath,
    "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
    "IngestionPipeline": IngestionPipeline,
    "InitAuthInput": InitAuthInput,
    "Initiator": Initiator,
    "InitiatorNameFilters": InitiatorNameFilters,
    "IntegConfig": IntegConfig,
    "IntegrationConfig": IntegrationConfig,
    "InventoryFilterConditions": InventoryFilterConditions,
    "InventoryGcpDisk": InventoryGcpDisk,
    "InventoryResource": InventoryResource,
    "InventoryResourceMetadata": InventoryResourceMetadata,
    "InventorySnapshotVolume": InventorySnapshotVolume,
    "InventoryVault": InventoryVault,
    "InventoryVolume": InventoryVolume,
    "IsVaultDeletableResponse": IsVaultDeletableResponse,
    "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
    "JobExecutionDetails": JobExecutionDetails,
    "JobFailedNotificationArguments": JobFailedNotificationArguments,
    "JobIdFilters": JobIdFilters,
    "JobInitiationResponse": JobInitiationResponse,
    "JobMetricsReportFailedArguments": JobMetricsReportFailedArguments,
    "JobSnapshotDetails": JobSnapshotDetails,
    "JobStatusFilters": JobStatusFilters,
    "JobStep": JobStep,
    "JobSucceededNotificationArguments": JobSucceededNotificationArguments,
    "JobTemplate": JobTemplate,
    "JobTemplateRetryPolicy": JobTemplateRetryPolicy,
    "KafkaBatchConfig": KafkaBatchConfig,
    "KafkaErrorHandlingConfig": KafkaErrorHandlingConfig,
    "KafkaPartitioningConfig": KafkaPartitioningConfig,
    "KafkaSecurityConfig": KafkaSecurityConfig,
    "KafkaSourceConfig": KafkaSourceConfig,
    "KafkaSourceProperties": KafkaSourceProperties,
    "KeyspacesBackupConfig": KeyspacesBackupConfig,
    "KeyspacesBackupConfigApplication": KeyspacesBackupConfigApplication,
    "KeyspacesTableRestoreDestination": KeyspacesTableRestoreDestination,
    "LimitData": LimitData,
    "ListAccountsResponse": ListAccountsResponse,
    "ListAllRegionsResponse": ListAllRegionsResponse,
    "ListAllRegionsResponseRegions": ListAllRegionsResponseRegions,
    "ListApiCredentialsResponse": ListApiCredentialsResponse,
    "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
    "ListAtlasOrganizationsResponse": ListAtlasOrganizationsResponse,
    "ListAuditLogRequest": ListAuditLogRequest,
    "ListAuditLogResponse": ListAuditLogResponse,
    "ListAuditLogsResponse": ListAuditLogsResponse,
    "ListAwsVpcsResponse": ListAwsVpcsResponse,
    "ListAwsVpcsResponseVpcsInner": ListAwsVpcsResponseVpcsInner,
    "ListAzureAppRegistrationsResponse": ListAzureAppRegistrationsResponse,
    "ListAzureCmkEligibleAppsResponse": ListAzureCmkEligibleAppsResponse,
    "ListAzureRegions200Response": ListAzureRegions200Response,
    "ListAzureSKUs200Response": ListAzureSKUs200Response,
    "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
    "ListAzureSKUsRequest": ListAzureSKUsRequest,
    "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
    "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
    "ListAzureSubnets200Response": ListAzureSubnets200Response,
    "ListAzureSubnets200ResponseSubnetsInner": ListAzureSubnets200ResponseSubnetsInner,
    "ListAzureSubnetsRequest": ListAzureSubnetsRequest,
    "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
    "ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner": ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner,
    "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
    "ListAzureVirtualNetworks200Response": ListAzureVirtualNetworks200Response,
    "ListAzureVirtualNetworks200ResponseVirtualNetworksInner": ListAzureVirtualNetworks200ResponseVirtualNetworksInner,
    "ListAzureVirtualNetworksRequest": ListAzureVirtualNetworksRequest,
    "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
    "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
    "ListBackupJobsRequest": ListBackupJobsRequest,
    "ListBackupJobsResponse": ListBackupJobsResponse,
    "ListBackupPoliciesResponse": ListBackupPoliciesResponse,
    "ListBackupPolicyResponse": ListBackupPolicyResponse,
    "ListBackupVaultResponse": ListBackupVaultResponse,
    "ListBackupZeroEtlPoliciesResponse": ListBackupZeroEtlPoliciesResponse,
    "ListBillingTransactionHistoryRequest": ListBillingTransactionHistoryRequest,
    "ListBillingTransactionHistoryResponse": ListBillingTransactionHistoryResponse,
    "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
    "ListControlViolationsResponse": ListControlViolationsResponse,
    "ListControlsResponse": ListControlsResponse,
    "ListCredentialFindingsResponse": ListCredentialFindingsResponse,
    "ListCredentialsProfilesResponse": ListCredentialsProfilesResponse,
    "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
    "ListDashboardsResponse": ListDashboardsResponse,
    "ListDataCatalogsResponse": ListDataCatalogsResponse,
    "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
    "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
    "ListDlsgPoliciesResponse": ListDlsgPoliciesResponse,
    "ListDynamoDbBackupConfigsResponse": ListDynamoDbBackupConfigsResponse,
    "ListEksClustersResponse": ListEksClustersResponse,
    "ListFindingsResponse": ListFindingsResponse,
    "ListGcpFoldersResponse": ListGcpFoldersResponse,
    "ListGcpNetworksResponse": ListGcpNetworksResponse,
    "ListGcpNetworksResponseNetworksInner": ListGcpNetworksResponseNetworksInner,
    "ListGcpOrganizationsResponse": ListGcpOrganizationsResponse,
    "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
    "ListIdpGroupsResponse": ListIdpGroupsResponse,
    "ListIdpsResponse": ListIdpsResponse,
    "ListInfectedExcludePathsResponse": ListInfectedExcludePathsResponse,
    "ListIngestionPipelinesResponse": ListIngestionPipelinesResponse,
    "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
    "ListInstanceTypesResponse": ListInstanceTypesResponse,
    "ListIntegrationsResponse": ListIntegrationsResponse,
    "ListInventoryAppsResponse": ListInventoryAppsResponse,
    "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
    "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
    "ListInventoryGlobalDatabasesResponse": ListInventoryGlobalDatabasesResponse,
    "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
    "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
    "ListInventoryRequest": ListInventoryRequest,
    "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
    "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
    "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
    "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
    "ListInventorySensitivityAnnotationValuesResponse": ListInventorySensitivityAnnotationValuesResponse,
    "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
    "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
    "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
    "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
    "ListInventoryTagsResponse": ListInventoryTagsResponse,
    "ListJobErrorCodesResponse": ListJobErrorCodesResponse,
    "ListJobTemplatesResponse": ListJobTemplatesResponse,
    "ListKeyspacesBackupConfigsResponse": ListKeyspacesBackupConfigsResponse,
    "ListKnownAppsResponse": ListKnownAppsResponse,
    "ListLogSourcesPoliciesResponse": ListLogSourcesPoliciesResponse,
    "ListLogSourcesResponse": ListLogSourcesResponse,
    "ListMPAOperationsResponse": ListMPAOperationsResponse,
    "ListMPAPoliciesResponse": ListMPAPoliciesResponse,
    "ListMPARequestsRequest": ListMPARequestsRequest,
    "ListMPARequestsRequestFilters": ListMPARequestsRequestFilters,
    "ListMPARequestsResponse": ListMPARequestsResponse,
    "ListMPARequestsSort": ListMPARequestsSort,
    "ListMongoAtlasPrivateLinks200Response": ListMongoAtlasPrivateLinks200Response,
    "ListMyMPARequestsRequest": ListMyMPARequestsRequest,
    "ListMyMPARequestsRequestFilters": ListMyMPARequestsRequestFilters,
    "ListMyMPARequestsResponse": ListMyMPARequestsResponse,
    "ListNotebooksResponse": ListNotebooksResponse,
    "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
    "ListNotificationsResponse": ListNotificationsResponse,
    "ListOAuthAppsResponse": ListOAuthAppsResponse,
    "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
    "ListPermissionsResponse": ListPermissionsResponse,
    "ListProjectsResponse": ListProjectsResponse,
    "ListResourceAttachmentEventsResponse": ListResourceAttachmentEventsResponse,
    "ListResourcesResponse": ListResourcesResponse,
    "ListRestoreAccountsRequest": ListRestoreAccountsRequest,
    "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
    "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
    "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
    "ListRestoreJobsRequest": ListRestoreJobsRequest,
    "ListRestoreJobsResponse": ListRestoreJobsResponse,
    "ListRolesResponse": ListRolesResponse,
    "ListSavedQueriesResponse": ListSavedQueriesResponse,
    "ListScanJobTypesResponse": ListScanJobTypesResponse,
    "ListScanJobsInternal200Response": ListScanJobsInternal200Response,
    "ListScanJobsRequest": ListScanJobsRequest,
    "ListScanJobsResponse": ListScanJobsResponse,
    "ListSensitivityAnnotationsResponse": ListSensitivityAnnotationsResponse,
    "ListSourceAccountsRequest": ListSourceAccountsRequest,
    "ListSourceAccountsResponse": ListSourceAccountsResponse,
    "ListSourceAwsOrganizationalUnitsResponse": ListSourceAwsOrganizationalUnitsResponse,
    "ListSparkEnginesResponse": ListSparkEnginesResponse,
    "ListSparkJobsResponse": ListSparkJobsResponse,
    "ListSqlEnginesResponse": ListSqlEnginesResponse,
    "ListSqlQueryExecutionsResponse": ListSqlQueryExecutionsResponse,
    "ListStorageGatewaysResponse": ListStorageGatewaysResponse,
    "ListSubnetsResponse": ListSubnetsResponse,
    "ListSubnetsResponseV2": ListSubnetsResponseV2,
    "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
    "ListUsersResponse": ListUsersResponse,
    "ListZeroEtlPoliciesResponse": ListZeroEtlPoliciesResponse,
    "LlgLocationResource": LlgLocationResource,
    "LlgLocationWithResources": LlgLocationWithResources,
    "LlgResourcePolicy": LlgResourcePolicy,
    "LogRecord": LogRecord,
    "LogSource": LogSource,
    "LogSourceLocation": LogSourceLocation,
    "LogSourceLocationCloudTrail": LogSourceLocationCloudTrail,
    "LogSourceLocationCloudWatchLogs": LogSourceLocationCloudWatchLogs,
    "LogSourceLocationDatadog": LogSourceLocationDatadog,
    "LogSourceLocationGcpCloudLogging": LogSourceLocationGcpCloudLogging,
    "LogSourceLocationSplunkDdss": LogSourceLocationSplunkDdss,
    "LogSourceWithPolicy": LogSourceWithPolicy,
    "LogsHistogramDataPoint": LogsHistogramDataPoint,
    "LogsSchema": LogsSchema,
    "LogsSchemaColumn": LogsSchemaColumn,
    "LogsSchemaEntry": LogsSchemaEntry,
    "LogsSchemasResponse": LogsSchemasResponse,
    "LuceneQueryInput": LuceneQueryInput,
    "MPAOperationInfo": MPAOperationInfo,
    "MPAPolicy": MPAPolicy,
    "MPARequest": MPARequest,
    "MPARequestDetail": MPARequestDetail,
    "MPAResourceSelector": MPAResourceSelector,
    "MPAReview": MPAReview,
    "MaxRetentionDaysLimit": MaxRetentionDaysLimit,
    "MaxRetentionRule": MaxRetentionRule,
    "Message": Message,
    "MicrosoftFabricIntegrationConfig": MicrosoftFabricIntegrationConfig,
    "MinRetentionRule": MinRetentionRule,
    "ModelError": ModelError,
    "MongoAtlasPrivateLinkEntry": MongoAtlasPrivateLinkEntry,
    "MongoAtlasRestoreAccountAttributes": MongoAtlasRestoreAccountAttributes,
    "MongoAtlasRestoreAccountAttributesInput": MongoAtlasRestoreAccountAttributesInput,
    "MongoAtlasSourceAccountAttributes": MongoAtlasSourceAccountAttributes,
    "MongoAtlasSourceAccountAttributesInput": MongoAtlasSourceAccountAttributesInput,
    "MonthlyConfig": MonthlyConfig,
    "MonthlySnapshotData": MonthlySnapshotData,
    "MsaAcceptanceResponse": MsaAcceptanceResponse,
    "NativeStandardBackupPolicyPlan": NativeStandardBackupPolicyPlan,
    "NativeStandardBackupSchedules": NativeStandardBackupSchedules,
    "NativeStandardConfig": NativeStandardConfig,
    "NeptuneClusterParameterGroup": NeptuneClusterParameterGroup,
    "NeptuneClusterParameterGroups": NeptuneClusterParameterGroups,
    "NeptuneRestoreDestination": NeptuneRestoreDestination,
    "NeptuneSnapshotProperties": NeptuneSnapshotProperties,
    "NetworkInterfaceConfig": NetworkInterfaceConfig,
    "Notebook": Notebook,
    "NotebookExecutionOutput": NotebookExecutionOutput,
    "NotebookExecutionResult": NotebookExecutionResult,
    "NotebookSession": NotebookSession,
    "Notification": Notification,
    "NotificationArguments": NotificationArguments,
    "NotificationPolicy": NotificationPolicy,
    "NotificationPolicyConfig": NotificationPolicyConfig,
    "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
    "NotificationPolicyConfigServiceNow": NotificationPolicyConfigServiceNow,
    "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
    "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
    "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
    "NotificationPolicyConfigWebhook": NotificationPolicyConfigWebhook,
    "NumberOfCopiesRule": NumberOfCopiesRule,
    "OAuthApp": OAuthApp,
    "Oauth2TokenResponse": Oauth2TokenResponse,
    "ObjectStorageDestination": ObjectStorageDestination,
    "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
    "OnboardAdditionalAzureApps200Response": OnboardAdditionalAzureApps200Response,
    "OnboardAdditionalAzureAppsRequest": OnboardAdditionalAzureAppsRequest,
    "OnboardRdsCdcRequest": OnboardRdsCdcRequest,
    "OnboardRdsCdcResponse": OnboardRdsCdcResponse,
    "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
    "OperationIdFilters": OperationIdFilters,
    "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
    "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
    "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
    "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
    "OverrideSensitivityAnnotationsRequest": OverrideSensitivityAnnotationsRequest,
    "Pagination": Pagination,
    "ParameterCheckResult": ParameterCheckResult,
    "ParentIdFilters": ParentIdFilters,
    "PartialRestoreData": PartialRestoreData,
    "Path": Path,
    "PathSegment": PathSegment,
    "PathSnapshotsRequest": PathSnapshotsRequest,
    "PathSnapshotsResponse": PathSnapshotsResponse,
    "Permission": Permission,
    "PermissionGrant": PermissionGrant,
    "PermissionGrantInput": PermissionGrantInput,
    "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
    "PitrBackupPolicyPlan": PitrBackupPolicyPlan,
    "PitrBackupResourceType": PitrBackupResourceType,
    "PitrBackupSchedules": PitrBackupSchedules,
    "PitrIntervalConfig": PitrIntervalConfig,
    "PitrRestoreVaultWindows": PitrRestoreVaultWindows,
    "PitrRestoreWindow": PitrRestoreWindow,
    "PitrRestoreWindowsResponse": PitrRestoreWindowsResponse,
    "Preferences": Preferences,
    "PrivateLink": PrivateLink,
    "PrivateLinkCheckResult": PrivateLinkCheckResult,
    "PrivateLinkFormatInstructions": PrivateLinkFormatInstructions,
    "PrivateLinkInstructionStep": PrivateLinkInstructionStep,
    "Project": Project,
    "ProjectIdFilters": ProjectIdFilters,
    "ProviderAccountIdFilters": ProviderAccountIdFilters,
    "ProviderCategoryFilters": ProviderCategoryFilters,
    "ProviderParentIdFilters": ProviderParentIdFilters,
    "ProviderRestoreAccountConnectivityConfig": ProviderRestoreAccountConnectivityConfig,
    "PulumiConfiguration": PulumiConfiguration,
    "PulumiConfigurations": PulumiConfigurations,
    "PulumiConfigurationsFilterConditions": PulumiConfigurationsFilterConditions,
    "PulumiConfigurationsRequest": PulumiConfigurationsRequest,
    "QueryCostData400Response": QueryCostData400Response,
    "QueryCostDataRequest": QueryCostDataRequest,
    "QueryCostDataResponse": QueryCostDataResponse,
    "QueryDBRequest": QueryDBRequest,
    "QueryDBResponse": QueryDBResponse,
    "QueryDBRestoreDestination": QueryDBRestoreDestination,
    "QueryDBResultResponse": QueryDBResultResponse,
    "QueryDBStatusResponse": QueryDBStatusResponse,
    "QuotaStatusFilters": QuotaStatusFilters,
    "RamShareCheckResult": RamShareCheckResult,
    "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
    "RdsNativePitrAdvancedConfig": RdsNativePitrAdvancedConfig,
    "RdsNativePitrClusterAdvancedConfig": RdsNativePitrClusterAdvancedConfig,
    "RdsNativePitrNetworkConfig": RdsNativePitrNetworkConfig,
    "RdsNativePitrWindow": RdsNativePitrWindow,
    "RdsPasswordConfig": RdsPasswordConfig,
    "RdsSecurityGroup": RdsSecurityGroup,
    "ReactivateAccountRequest": ReactivateAccountRequest,
    "ReconnectCustomerVaultAccountResponse": ReconnectCustomerVaultAccountResponse,
    "ReconnectRestoreAccountResponse": ReconnectRestoreAccountResponse,
    "ReconnectSourceAccountResponse": ReconnectSourceAccountResponse,
    "ReconnectSourceAwsOrganizationalUnitResponse": ReconnectSourceAwsOrganizationalUnitResponse,
    "RecordRestoreResult": RecordRestoreResult,
    "RecoveryPointData": RecoveryPointData,
    "RedshiftCluster": RedshiftCluster,
    "RedshiftClusters": RedshiftClusters,
    "RedshiftIntegrationConfig": RedshiftIntegrationConfig,
    "RedshiftRestoreDestination": RedshiftRestoreDestination,
    "RedshiftServerlessNamespace": RedshiftServerlessNamespace,
    "RedshiftServerlessNamespaces": RedshiftServerlessNamespaces,
    "RedshiftSnapshotProperties": RedshiftSnapshotProperties,
    "RegionCondition": RegionCondition,
    "RegisterInput": RegisterInput,
    "RegisterInputBillingToken": RegisterInputBillingToken,
    "RegisterResponse": RegisterResponse,
    "RelatedGlobalDbCluster": RelatedGlobalDbCluster,
    "RequestDetails": RequestDetails,
    "ResourceDetails": ResourceDetails,
    "ResourceGroupNameCondition": ResourceGroupNameCondition,
    "ResourceIdCondition": ResourceIdCondition,
    "ResourceIdFilters": ResourceIdFilters,
    "ResourceIdentifiers": ResourceIdentifiers,
    "ResourceNameCondition": ResourceNameCondition,
    "ResourceNameFilters": ResourceNameFilters,
    "ResourceProperties": ResourceProperties,
    "ResourceQuota": ResourceQuota,
    "ResourceSnapshot": ResourceSnapshot,
    "ResourceSnapshotProperties": ResourceSnapshotProperties,
    "ResourceTag": ResourceTag,
    "ResourceTypeCondition": ResourceTypeCondition,
    "ResourceTypeFilters": ResourceTypeFilters,
    "ResourceTypeToSecurityGroup": ResourceTypeToSecurityGroup,
    "ResourceValidationError": ResourceValidationError,
    "RestoreAccount": RestoreAccount,
    "RestoreAccountAttributesInput": RestoreAccountAttributesInput,
    "RestoreAccountCloudAttributes": RestoreAccountCloudAttributes,
    "RestoreAccountConnectivityConfig": RestoreAccountConnectivityConfig,
    "RestoreAccountMetricsConfig": RestoreAccountMetricsConfig,
    "RestoreAccountRegions": RestoreAccountRegions,
    "RestoreAccountsFilterConditions": RestoreAccountsFilterConditions,
    "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
    "RestoreAvailabilityZones": RestoreAvailabilityZones,
    "RestoreAwsEc2InstanceRequest": RestoreAwsEc2InstanceRequest,
    "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
    "RestoreAzureDiskRequest": RestoreAzureDiskRequest,
    "RestoreAzureInstanceDiskInput": RestoreAzureInstanceDiskInput,
    "RestoreAzurePostgresDatabaseRequest": RestoreAzurePostgresDatabaseRequest,
    "RestoreAzureSqlDatabaseRequest": RestoreAzureSqlDatabaseRequest,
    "RestoreAzureSqlVmPitrRequest": RestoreAzureSqlVmPitrRequest,
    "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
    "RestoreAzureVmInstanceRequest": RestoreAzureVmInstanceRequest,
    "RestoreBigQueryDatasetRequest": RestoreBigQueryDatasetRequest,
    "RestoreBigQueryNativePitrRequest": RestoreBigQueryNativePitrRequest,
    "RestoreBucketRequest": RestoreBucketRequest,
    "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
    "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
    "RestoreDestinationLimits": RestoreDestinationLimits,
    "RestoreDocumentDBRequest": RestoreDocumentDBRequest,
    "RestoreDynamoDBTableRequest": RestoreDynamoDBTableRequest,
    "RestoreDynamoDBToExistingTableRequest": RestoreDynamoDBToExistingTableRequest,
    "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
    "RestoreEFSRequest": RestoreEFSRequest,
    "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
    "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
    "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
    "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
    "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
    "RestoreFSxRequest": RestoreFSxRequest,
    "RestoreFilesRequest": RestoreFilesRequest,
    "RestoreGceDiskConfig": RestoreGceDiskConfig,
    "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
    "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
    "RestoreGcpCloudSqlRequest": RestoreGcpCloudSqlRequest,
    "RestoreGcpDiskRequest": RestoreGcpDiskRequest,
    "RestoreGcpInstanceDiskInput": RestoreGcpInstanceDiskInput,
    "RestoreGcpVmInstanceRequest": RestoreGcpVmInstanceRequest,
    "RestoreImage201Response": RestoreImage201Response,
    "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
    "RestoreImageImageInput": RestoreImageImageInput,
    "RestoreImageInput": RestoreImageInput,
    "RestoreImageVolumeInput": RestoreImageVolumeInput,
    "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
    "RestoreInstanceImageInput": RestoreInstanceImageInput,
    "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
    "RestoreJob": RestoreJob,
    "RestoreJobConfiguration": RestoreJobConfiguration,
    "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
    "RestoreJobTypeFilters": RestoreJobTypeFilters,
    "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
    "RestoreKeyspacesTableRequest": RestoreKeyspacesTableRequest,
    "RestoreNeptuneRequest": RestoreNeptuneRequest,
    "RestoreRdsInstanceClasses": RestoreRdsInstanceClasses,
    "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
    "RestoreRdsNativePitrRequest": RestoreRdsNativePitrRequest,
    "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
    "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
    "RestoreRedshiftRequest": RestoreRedshiftRequest,
    "RestoreResult": RestoreResult,
    "RestoreSecurityGroups": RestoreSecurityGroups,
    "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
    "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
    "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
    "Role": Role,
    "RoleAccessGroupCondition": RoleAccessGroupCondition,
    "S3Bucket": S3Bucket,
    "S3Buckets": S3Buckets,
    "S3RestoreDestination": S3RestoreDestination,
    "S3RestoreTarget": S3RestoreTarget,
    "S3SourceProperties": S3SourceProperties,
    "SAMLCallback400Response": SAMLCallback400Response,
    "SAMLCallback401Response": SAMLCallback401Response,
    "SAMLCallback500Response": SAMLCallback500Response,
    "SamlIdentityProvider": SamlIdentityProvider,
    "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
    "SapHanaInstance": SapHanaInstance,
    "SapHanaRestoreProperties": SapHanaRestoreProperties,
    "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
    "SaveNotebookContentRequest": SaveNotebookContentRequest,
    "SavedQuery": SavedQuery,
    "ScanJob": ScanJob,
    "SchemaRecord": SchemaRecord,
    "SchemaRegistryAuthConfig": SchemaRegistryAuthConfig,
    "SchemaRegistryConfig": SchemaRegistryConfig,
    "SearchDBResponse": SearchDBResponse,
    "SearchFilesResponse": SearchFilesResponse,
    "SearchInput": SearchInput,
    "SearchLogsHistogramInput": SearchLogsHistogramInput,
    "SearchLogsHistogramResponse": SearchLogsHistogramResponse,
    "SearchLogsInput": SearchLogsInput,
    "SearchLogsResponse": SearchLogsResponse,
    "SearchResources200Response": SearchResources200Response,
    "SearchResources200ResponseTablesInner": SearchResources200ResponseTablesInner,
    "SearchResources200ResponseTablesInnerResource": SearchResources200ResponseTablesInnerResource,
    "SearchResources200ResponseTablesInnerSnapshots": SearchResources200ResponseTablesInnerSnapshots,
    "SearchResources200ResponseTablesInnerSource": SearchResources200ResponseTablesInnerSource,
    "SearchResources200ResponseTablesInnerTablesInner": SearchResources200ResponseTablesInnerTablesInner,
    "SearchResources200ResponseTablesInnerTablesInnerColumnsInner": SearchResources200ResponseTablesInnerTablesInnerColumnsInner,
    "SearchResourcesRequest": SearchResourcesRequest,
    "SecurityGroupRule": SecurityGroupRule,
    "SecurityInformation": SecurityInformation,
    "SecurityPlan": SecurityPlan,
    "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
    "SecurityResourceNotificationArguments": SecurityResourceNotificationArguments,
    "SecurityScan": SecurityScan,
    "SecurityScanNotificationData": SecurityScanNotificationData,
    "SecurityScanResult": SecurityScanResult,
    "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
    "SecuritySnapshotNotificationArguments": SecuritySnapshotNotificationArguments,
    "SecuritySummary": SecuritySummary,
    "SendA2AMessageRequest": SendA2AMessageRequest,
    "SendMessageToAI400Response": SendMessageToAI400Response,
    "SendMessageToAIRequest": SendMessageToAIRequest,
    "SensitivityAnnotation": SensitivityAnnotation,
    "SensitivityAnnotationsDetails": SensitivityAnnotationsDetails,
    "ServiceProviderDetails": ServiceProviderDetails,
    "Session": Session,
    "SetupAwsPrivateLinkRequest": SetupAwsPrivateLinkRequest,
    "SetupAwsPrivateLinkResponse": SetupAwsPrivateLinkResponse,
    "SetupMongoAtlasPrivateLinkRequest": SetupMongoAtlasPrivateLinkRequest,
    "SetupMongoAtlasPrivateLinkResponse": SetupMongoAtlasPrivateLinkResponse,
    "SeverityFilters": SeverityFilters,
    "Snapshot": Snapshot,
    "SnapshotAccessDeniedNotificationArguments": SnapshotAccessDeniedNotificationArguments,
    "SnapshotDateFilters": SnapshotDateFilters,
    "SnapshotFilterConditions": SnapshotFilterConditions,
    "SnapshotFindingCountsResponse": SnapshotFindingCountsResponse,
    "SnapshotIdFilters": SnapshotIdFilters,
    "SnapshotLocation": SnapshotLocation,
    "SnapshotReference": SnapshotReference,
    "SnapshotStorage": SnapshotStorage,
    "SnapshotsSummaryResponse": SnapshotsSummaryResponse,
    "SnowflakeIntegrationConfig": SnowflakeIntegrationConfig,
    "SortBackupJobBy": SortBackupJobBy,
    "SortColumnSpec": SortColumnSpec,
    "SortLogsBy": SortLogsBy,
    "SortResourceBy": SortResourceBy,
    "SortRestoreAccountsBy": SortRestoreAccountsBy,
    "SortRestoreJobBy": SortRestoreJobBy,
    "SortSnapshotsBy": SortSnapshotsBy,
    "SortSourceAccountsBy": SortSourceAccountsBy,
    "SourceAccount": SourceAccount,
    "SourceAccountAttributesInput": SourceAccountAttributesInput,
    "SourceAccountCloudAttributes": SourceAccountCloudAttributes,
    "SourceAccountMetricsConfig": SourceAccountMetricsConfig,
    "SourceAccountProviderIdFilters": SourceAccountProviderIdFilters,
    "SourceAccountsFilterConditions": SourceAccountsFilterConditions,
    "SourceAwsOrganizationalUnit": SourceAwsOrganizationalUnit,
    "SourceRegionFilters": SourceRegionFilters,
    "SourceSizeCheckResult": SourceSizeCheckResult,
    "SourceStorage": SourceStorage,
    "SourceStorageBackupStatus": SourceStorageBackupStatus,
    "SparkEngine": SparkEngine,
    "SparkJob": SparkJob,
    "SparkJobRetryPolicy": SparkJobRetryPolicy,
    "SparkJobSparkSubmitParams": SparkJobSparkSubmitParams,
    "SparkJobStorageConfig": SparkJobStorageConfig,
    "SqlEngine": SqlEngine,
    "SqlInstructions": SqlInstructions,
    "SqlQueryExecution": SqlQueryExecution,
    "SqlQueryExecutionResult": SqlQueryExecutionResult,
    "SqlQueryExecutionResultColumn": SqlQueryExecutionResultColumn,
    "SqlVmNetworkInfo": SqlVmNetworkInfo,
    "SsoIntegrationSettings": SsoIntegrationSettings,
    "StackNameFilters": StackNameFilters,
    "StandardBackupPolicyPlan": StandardBackupPolicyPlan,
    "StandardBackupScheduleConfig": StandardBackupScheduleConfig,
    "StandardBackupSchedules": StandardBackupSchedules,
    "StandardIntervalConfig": StandardIntervalConfig,
    "StartNotebookSessionInput": StartNotebookSessionInput,
    "StartSparkJobDirectParams": StartSparkJobDirectParams,
    "StartSparkJobInput": StartSparkJobInput,
    "StartSparkJobTemplateParams": StartSparkJobTemplateParams,
    "StartSqlQueryExecutionInput": StartSqlQueryExecutionInput,
    "StartTimeDateFilters": StartTimeDateFilters,
    "StatusCodeFilters": StatusCodeFilters,
    "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
    "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
    "StorageConfig": StorageConfig,
    "StorageGateway": StorageGateway,
    "StorageGatewayDetails": StorageGatewayDetails,
    "SubnetConfig": SubnetConfig,
    "SubnetFilters": SubnetFilters,
    "SubnetPerAvailabilityZone": SubnetPerAvailabilityZone,
    "SubnetsCondition": SubnetsCondition,
    "SupportedProviders": SupportedProviders,
    "TableMaintenanceConfig": TableMaintenanceConfig,
    "TableRecord": TableRecord,
    "TagKeyValue": TagKeyValue,
    "TagKeyValuesCondition": TagKeyValuesCondition,
    "TagKeyValuesFilters": TagKeyValuesFilters,
    "TagKeysCondition": TagKeysCondition,
    "TagKeysFilters": TagKeysFilters,
    "TakeNativeSnapshotRequest": TakeNativeSnapshotRequest,
    "TakeSnapshotRequest": TakeSnapshotRequest,
    "TakeSnapshotResponse": TakeSnapshotResponse,
    "TeardownAwsPrivateLinkResponse": TeardownAwsPrivateLinkResponse,
    "TeardownMongoAtlasPrivateLinkResponse": TeardownMongoAtlasPrivateLinkResponse,
    "TimeFrame": TimeFrame,
    "TimeOfDay": TimeOfDay,
    "TimeOfYear": TimeOfYear,
    "TokenResponse": TokenResponse,
    "TotalSourceStorageSizeRequest": TotalSourceStorageSizeRequest,
    "TotalSourceStorageSizeResponse": TotalSourceStorageSizeResponse,
    "TriggerKeyspacesScheduledDump200Response": TriggerKeyspacesScheduledDump200Response,
    "UnifiedDBRecord": UnifiedDBRecord,
    "UnifiedDBServerRecord": UnifiedDBServerRecord,
    "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
    "UnifiedSchemaRecord": UnifiedSchemaRecord,
    "UnifiedTableRecord": UnifiedTableRecord,
    "UpPulumiStacksResponse": UpPulumiStacksResponse,
    "UpdateAccountCompanyContactsRequest": UpdateAccountCompanyContactsRequest,
    "UpdateAccountLabelsRequest": UpdateAccountLabelsRequest,
    "UpdateAccountProfileResponse": UpdateAccountProfileResponse,
    "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
    "UpdateAwsRestoreAccountAttributes": UpdateAwsRestoreAccountAttributes,
    "UpdateAwsSourceAccountAttributes": UpdateAwsSourceAccountAttributes,
    "UpdateBackupPolicyRequest": UpdateBackupPolicyRequest,
    "UpdateBackupPolicyResponse": UpdateBackupPolicyResponse,
    "UpdateBackupZeroEtlPolicyInput": UpdateBackupZeroEtlPolicyInput,
    "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
    "UpdateCloudResourceConfigurationRequestCdcBackup": UpdateCloudResourceConfigurationRequestCdcBackup,
    "UpdateCloudResourceConfigurationRequestInventoryBackup": UpdateCloudResourceConfigurationRequestInventoryBackup,
    "UpdateControlViolationInput": UpdateControlViolationInput,
    "UpdateCredentialsProfileInput": UpdateCredentialsProfileInput,
    "UpdateDashboardInput": UpdateDashboardInput,
    "UpdateDlsgPolicyRequest": UpdateDlsgPolicyRequest,
    "UpdateDlsgPolicyResponse": UpdateDlsgPolicyResponse,
    "UpdateGcpRestoreAccountAttributes": UpdateGcpRestoreAccountAttributes,
    "UpdateGcpSourceAccountAttributes": UpdateGcpSourceAccountAttributes,
    "UpdateGraphInput": UpdateGraphInput,
    "UpdateIdpGroupRequest": UpdateIdpGroupRequest,
    "UpdateIdpGroupResponse": UpdateIdpGroupResponse,
    "UpdateIngestionPipelineInput": UpdateIngestionPipelineInput,
    "UpdateIntegrationRequest": UpdateIntegrationRequest,
    "UpdateIntegrationResponse": UpdateIntegrationResponse,
    "UpdateJobTemplateInput": UpdateJobTemplateInput,
    "UpdateMPAPolicyRequest": UpdateMPAPolicyRequest,
    "UpdateMPAPolicyResponse": UpdateMPAPolicyResponse,
    "UpdateNotebookInput": UpdateNotebookInput,
    "UpdatePrivateLinkInput": UpdatePrivateLinkInput,
    "UpdateProjectConfigurationKeyRequest": UpdateProjectConfigurationKeyRequest,
    "UpdatePulumiConfigurationRequest": UpdatePulumiConfigurationRequest,
    "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
    "UpdateRestoreAccountAttributesInput": UpdateRestoreAccountAttributesInput,
    "UpdateRestoreAccountConnectivityConfigRequest": UpdateRestoreAccountConnectivityConfigRequest,
    "UpdateRestoreAccountConnectivityConfigResponse": UpdateRestoreAccountConnectivityConfigResponse,
    "UpdateRestoreAccountRequest": UpdateRestoreAccountRequest,
    "UpdateRestoreAccountResponse": UpdateRestoreAccountResponse,
    "UpdateRoleRequest": UpdateRoleRequest,
    "UpdateRoleResponse": UpdateRoleResponse,
    "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
    "UpdateSavedQueryInput": UpdateSavedQueryInput,
    "UpdateSessionRequest": UpdateSessionRequest,
    "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
    "UpdateSourceAccountAttributesInput": UpdateSourceAccountAttributesInput,
    "UpdateSourceAccountRequest": UpdateSourceAccountRequest,
    "UpdateSourceAccountResponse": UpdateSourceAccountResponse,
    "UpdateTableMaintenanceConfigInput": UpdateTableMaintenanceConfigInput,
    "UpdateUserInput": UpdateUserInput,
    "UpdateVaultRequest": UpdateVaultRequest,
    "UpdateVaultResponse": UpdateVaultResponse,
    "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
    "UpdateWorkspaceBucketPolicyInput": UpdateWorkspaceBucketPolicyInput,
    "UpdateWorkspaceLoggingSettingsInput": UpdateWorkspaceLoggingSettingsInput,
    "UpdateWorkspaceMetricsSettingsInput": UpdateWorkspaceMetricsSettingsInput,
    "UpdateZeroEtlPolicyInput": UpdateZeroEtlPolicyInput,
    "Usage": Usage,
    "User": User,
    "UserIdFilters": UserIdFilters,
    "VNetConfig": VNetConfig,
    "ValidateResourceConfigurationRequest": ValidateResourceConfigurationRequest,
    "ValidateResourceConfigurationResponse": ValidateResourceConfigurationResponse,
    "VaultFilters": VaultFilters,
    "VaultMetadataReplicationConfig": VaultMetadataReplicationConfig,
    "VaultNotificationArguments": VaultNotificationArguments,
    "VaultProviderAttributes": VaultProviderAttributes,
    "VaultProviderAttributesInput": VaultProviderAttributesInput,
    "VaultSnapshotCount": VaultSnapshotCount,
    "VerifyMongoAtlasPrivateLinkResponse": VerifyMongoAtlasPrivateLinkResponse,
    "Viewer": Viewer,
    "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
    "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
    "VisualizationHistogramSeries": VisualizationHistogramSeries,
    "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
    "VisualizationLabel": VisualizationLabel,
    "VolumeSettings": VolumeSettings,
    "VpcCondition": VpcCondition,
    "VpcPeering": VpcPeering,
    "VpcPropertyFilters": VpcPropertyFilters,
    "WarmCapacity": WarmCapacity,
    "WeeklyConfig": WeeklyConfig,
    "Workspace": Workspace,
    "WorkspaceBucketPolicy": WorkspaceBucketPolicy,
    "WorkspaceLoggingSettings": WorkspaceLoggingSettings,
    "WorkspaceMetricsSettings": WorkspaceMetricsSettings,
    "WorkspaceNetworkingSettings": WorkspaceNetworkingSettings,
    "WorkspaceNetworkingSettingsVpcPeering": WorkspaceNetworkingSettingsVpcPeering,
    "YearlySnapshotDistribution": YearlySnapshotDistribution,
    "ZeroEtlIdentityColumnSpec": ZeroEtlIdentityColumnSpec,
    "ZeroEtlPolicy": ZeroEtlPolicy,
    "ZeroEtlResourceSelector": ZeroEtlResourceSelector,
    "ZeroEtlRoutingPolicy": ZeroEtlRoutingPolicy,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
